/*
 * @Author: wyt
 * @Date: 2021-04-07 17:05:49
 * @LastEditTime: 2024-04-09 09:11:24
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \GSPNW\src\assets\js\common.js
 */
import Vue from "vue";
import store from "../../store/index";
import md5 from "js-md5";
import axios from "axios";
import request from "@/utils/axios";
import newReqs from "@/assets/api/newApi";
import pako from "pako";
import router from "../../router/index";
import heatMap from "@/assets/js/heatmap";
import pointCtx from "@/assets/font/woff/ctx"; //绘制点符号的方法
import comTool from "@/assets/js/customModules/tools";
import commonB from "@/assets/js/common-addition.js";
import DTPLabel from "@/assets/js/dtpLabel.js";
import LonLatConversion from "@/assets/js/customModules/LonLatConversion";
//import commonB from "@/assets/js/common_b.js";
import {
  Message
} from "element-ui";
import {
  updateAttrsingleBatch,
  updateFeatureAttr,
  GetSingleGeoDataFeature
} from "@/assets/api/feature";
import {
  addLayer
} from "@/assets/api/layer";
import {
  getBookmarkDataAll
} from "@/assets/api/bookmarks";
import {
  getGDataAttrByOBS,
  getBatchDataByProject,
  updateFieldOrder,
  getDataDetail_GDB,
  getGDataObject,
  getPointExtentGData,
  getAttr,
  updateSingleAttr,
  getGeoDataFeatureBatch,
  getTry_NewMethod_data
} from "@/assets/api/detaildata";

import {
  GetWebChatLocationParam
} from "@/assets/api/user-api";
import {
  exportCad,
  get_coorList,
  exportShp,
  updateLayerVisible,
  updateBaseLayerVisible,
  getTry_NewMethod
} from "@/assets/api/home-api";
import {
  point as trufPoint,
  lineString,
  polygon as trufPolygon,
  length as truflength,
  booleanPointInPolygon,
  booleanIntersects,
  booleanContains
} from "@turf/turf";
 

import {
  unlockClock
} from "../js/customModules/EditCommon"
import {
  UpdateVIdeoContents
} from "../api/mapvideo"



// import Worker from "../js/webworker.worker"
// var workers = new Worker();

window.lastLineCoordinate = []; //上一次的经纬度

window.TileCanvasCache = []; //切片缓存,用于拾取功能
window.ChangedCanvasCache = []; //数据库数据缓存，用于拾取功能

window.TileData = []; //剔除数据库数据后的切片数据，可用于切片重新绘制，包括layerID、点线面类型、切片行列、值、偏移量
//window.ChangedData = []; //数据库读取的当前范围的数据

window.notDrawIDs = []; //切片中所有被修改、删除要素的ID
window.deleteIDs = []; //所有删除的要素ID

window.ZHT_ChangedDelData = []; //数据库某个时间戳之后删除的数据ids
window.AllChangedData = [] //所有数据库数据
window.Intervaltime = 60000 //获取最新数据后多长时间内不再重新请求是否有新数据

window.CacheVersionArray = []; //各图层矢量切片缓存版本

window.lastNumber = 0; //缩放请求前次数
window.currentNumber = 0; //缩放请求回来次数
window.currentDragNumber = 0;
window.lastDragNumber = 0;
window.cancleToken = [];
var currentUrl = null;
window.hasnotDrawRowCol = []; //平移或缩放后还未绘制的行列
window.noDrawData = []; //未绘制的数据
window.cachePointData = []; //缓存
window.labelData = []; //labels
window.totalPostCounts = 0; //总的请求
window.hasPostedCounts = 0; //已请求
window.pointData = []; //点行列数据
window.selectedIdData = []; //选中的Ids
window.selectedAllData = []; //选中的全部数据  type vector 是数据库数据，screen是切片
window.lastPickedData = []; //当前拾取的canvas数据，用于点击选中
window.allTotalLayerPost = 0; //所有图层请求次数
window.allTotalLayerHasPosted = 0; //所有图层请求次数
window.cacheImageOffset = 0;
window.shareStatus = []
window.shareIDS = []
window.pointCanvasWidth = 296; //点canvas宽高
window.pointSpace = (pointCanvasWidth - 256) / 2; //点canvas缓冲区宽度
window.ZHT_LabelDrawData = []; //缓存label绘制数据

export function formDate(date, format) {
  var args = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
    S: date.getMilliseconds()
  };
  if (/(y+)/.test(format))
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var i in args) {
    var n = args[i];
    if (new RegExp("(" + i + ")").test(format))
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? n : ("00" + n).substr(("" + n).length)
      );
  }
  return format;
}

/**
 * @author: wyt
 * @description: 颜色转rgba值
 * @param {*} color 颜色
 * @return {*} rgba值
 */
export function convertToRGB(color) {
  var str = "";
  var colorstr = "";
  if (color) {
    str = color.r + "," + color.g + "," + color.b + "," + color.a;
    colorstr = "rgba(" + str + ")";
  }
  return colorstr;
}

export function RepairGeo(geom, Id, layerid, coordinate) {
  let list = store.state.arcLineArr;
  var geo = [];
  var flag = false;
  var firstCircle = null
  for (var m = 0; m < geom.length; m++) {
    var partGeo = [];
    for (var n = 0; n < geom[m].length; n++) {
      if (n + 1 < geom[m].length && n + 2 < geom[m].length) {
        if (geom[m][n].length == 2 && geom[m][n + 1].length == 3) {
          var tmp = [];
          tmp.push({
            x: geom[m][n][0],
            y: geom[m][n][1]
          });
          tmp.push({
            x: geom[m][n + 1][0],
            y: geom[m][n + 1][1]
          });
          tmp.push({
            x: geom[m][n + 2][0],
            y: geom[m][n + 2][1]
          });

          if (
            geom[m][n][0] == geom[m][n + 2][0] &&
            geom[m][n][1] == geom[m][n + 2][1]
          ) {
            //圆
            var s = setArcline(tmp, "circle");
            if (m != 0) {
              let d = locate(tmp) //算圆心
              if (firstCircle != null) {
                let r1 = firstCircle.radius
                let r2 = d.radius
                if (Math.abs(r2 - r1) < r1) {
                  s.reverse()
                }
              } else {
                let poly = trufPolygon([geo[0]])
                let pt1 = trufPoint([d.x, d.y])
                let fla = booleanPointInPolygon(pt1, poly)
                if (fla) {
                  s.reverse()
                }
              }
            } else {
              firstCircle = locate(tmp);
            }
            if (s != null) {
              s.forEach(item => {
                partGeo.push(item);
              });
              flag = true;
            }
            n = n + 2;
          } else {
            var s = setArcline(tmp, "arc");
            if (s != null) {
              s.forEach(item => {
                partGeo.push(item);
              });
              flag = true;
            }
            n = n + 1;
          }
        } else {
          partGeo.push(geom[m][n]);
        }
      } else {
        partGeo.push(geom[m][n]);
      }
    }
    if (partGeo.length > 0) {
      geo.push(partGeo);
    }
    if (flag) {
      let _geom = [];
      let esriModule = store.state.esriModule;
      geom.forEach(item => {
        let jtemp = [];
        for (let j = 0; j < item.length; j++) {
          let pt = new esriModule.Point(
            item[j][0],
            item[j][1],
            new esriModule.SpatialReference(coordinate)
          );
          pt = convertLngLat(coordinate, pt);
          if (!pt)
            continue
          if (item[j].length > 2) {
            jtemp.push([pt.x, pt.y, item[j][2]]);
          } else {
            jtemp.push([pt.x, pt.y]);
          }
        }
        if (jtemp.length > 0) {
          _geom.push(jtemp);
        }
      });
      let _geo = [];
      geo.forEach(item => {
        let jtemp = [];
        for (let j = 0; j < item.length; j++) {
          let pt = new esriModule.Point(
            item[j][0],
            item[j][1],
            new esriModule.SpatialReference(coordinate)
          );
          pt = convertLngLat(coordinate, pt);
          if (!pt)
            continue
          if (item[j].length > 2) {
            jtemp.push([pt.x, pt.y, item[j][2]]);
          } else {
            jtemp.push([pt.x, pt.y]);
          }
        }
        if (jtemp.length > 0) {
          _geo.push(jtemp);
        }
      });
      if (Id != -1) {
        let index = list.findIndex(
          x => x.layerId == layerid && x.featureId == Id
        );
        if (index < 0) {
          list.push({
            layerId: layerid,
            featureId: Id,
            originalShpape: geom,
            shape: geo,
            convertShpape: _geom,
            convertNodes: _geo
          });
        } else {
          list.splice(index, 1);
          list.push({
            layerId: layerid,
            featureId: Id,
            originalShpape: geom,
            shape: geo,
            convertShpape: _geom,
            convertNodes: _geo
          });
        }
      }
    }
  }
  store.commit("set_arcLineArr", list);
  // geo.forEach(item => {
  //   let df = lineString(item)
  //   let d = booleanClockwise(df)
  //   console.log("Clockwise", d)
  // })
  // console.log("RepairGeo:", Id, geo)
  return geo;
}

/**
 * @author: wyt
 * @description: 获取渲染符号
 * @export
 * @param {*} GeoType 数据类型
 * @param {*} RenderType 渲染类型
 * @param {*} Symbolobj 符号数据
 * @return {*}
 */
export function getRenderer(GeoType, RenderType, Symbolobj) {

  var esriModule = store.state.esriModule;
  var rendersymbol = "",
    renderer = "";
  if (GeoType == "面") {
    if (RenderType == "SimpleRender") {
      //简单符号填充
      if (Symbolobj.SymbolType == "Simple") {
        //简单渲染（简单符号）
        if (Symbolobj.Symbol.outline != null) {
          rendersymbol = initRendererSymbol(
            Symbolobj.Symbol,
            Symbolobj.SymbolType,
            GeoType
          );
        } else {
          rendersymbol = new esriModule.SimpleFillSymbol(
            Symbolobj.Symbol.style,
            null,
            Symbolobj.Symbol.color
          );
        }
      } else {
        //图片填充
        if (Symbolobj.Symbol.outline != null) {
          rendersymbol = initRendererSymbol(
            Symbolobj.Symbol,
            Symbolobj.SymbolType,
            GeoType
          );
        } else {
          rendersymbol = new esriModule.PictureFillSymbol(
            myConfig.baseUrl + Symbolobj.Symbol.url,
            null,
            Symbolobj.Symbol.width,
            Symbolobj.Symbol.height
          );
        }
      }
      renderer = new esriModule.SimpleRenderer(rendersymbol);
    } else {
      // 唯一值
      let defaultnullsymbol;
      if (Symbolobj.Symbols[0].SymbolsType == "Simple") {
        defaultnullsymbol = initRendererSymbol(
          Symbolobj.Symbols[0].Symbol,
          Symbolobj.Symbols[0].SymbolsType,
          GeoType
        );
      } else {
        defaultnullsymbol = new esriModule.PictureFillSymbol(
          myConfig.baseUrl + Symbolobj.Symbols[0].Symbol.url,
          null,
          Symbolobj.Symbols[0].Symbol.width,
          Symbolobj.Symbols[0].Symbol.height
        );
      }
      if (RenderType == "UniqueRender") {
        renderer = new esriModule.UniqueValueRenderer(
          defaultnullsymbol,
          Symbolobj.FieldName
        );
      } else {
        renderer = new esriModule.ClassBreaksRenderer(
          defaultnullsymbol,
          Symbolobj.FieldName
        );
      }
      for (let i = 0; i < Symbolobj.Symbols.length; i++) {
        let symobj = Symbolobj.Symbols[i].Symbol;
        if (Symbolobj.Symbols[i].SymbolsType == "Simple") {
          if (symobj.outline != null) {
            rendersymbol = initRendererSymbol(
              symobj,
              Symbolobj.Symbols[i].SymbolsType,
              GeoType
            );
          } else {
            rendersymbol = new esriModule.SimpleFillSymbol(
              symobj.style,
              null,
              symobj.color
            );
          }
        } else {
          if (symobj.outline == null) {
            rendersymbol = initRendererSymbol(
              symobj,
              Symbolobj.Symbols[i].SymbolsType,
              GeoType
            );
          } else {
            rendersymbol = new esriModule.PictureFillSymbol(
              myConfig.baseUrl + symobj.url,
              null,
              symobj.width,
              symobj.height
            );
          }
        }
        if (RenderType == "UniqueRender") {
          renderer.addValue(Symbolobj.Symbols[i].Value, rendersymbol);
        } else {
          let rangeArray = Symbolobj.Symbols[i].Value.split("-");
          if (rangeArray.length == 1) {
            renderer.addBreak(
              parseFloat(rangeArray[0]),
              parseFloat(rangeArray[0]),
              rendersymbol
            );
          } else {
            renderer.addBreak(
              parseFloat(rangeArray[0]),
              parseFloat(rangeArray[1]),
              rendersymbol
            );
          }
        }
      }
    }
  } else if (GeoType == "线") {
    if (RenderType == "SimpleRender") {
      //简单符号填充
      if (Symbolobj.SymbolType == "Simple") {
        //简单渲染（简单符号）
        rendersymbol = new esriModule.SimpleLineSymbol(
          Symbolobj.Symbol.style,
          Symbolobj.Symbol.color,
          Symbolobj.Symbol.width
        );
      }
      renderer = new esriModule.SimpleRenderer(rendersymbol);
    } else {
      // 唯一值||分级
      let sys = new esriModule.SimpleLineSymbol(
        Symbolobj.Symbols[0].Symbol.style,
        Symbolobj.Symbols[0].Symbol.color,
        Symbolobj.Symbols[0].Symbol.width
      );
      if (RenderType == "UniqueRender") {
        renderer = new esriModule.UniqueValueRenderer(sys, Symbolobj.FieldName);
      } else {
        renderer = new esriModule.ClassBreaksRenderer(sys, Symbolobj.FieldName);
      }
      for (let i = 0; i < Symbolobj.Symbols.length; i++) {
        let symobj = Symbolobj.Symbols[i].Symbol;
        if (Symbolobj.Symbols[i].SymbolsType == "Simple") {
          rendersymbol = new esriModule.SimpleLineSymbol(
            symobj.style,
            symobj.color,
            symobj.width
          );
        }
        if (RenderType == "UniqueRender") {
          renderer.addValue(Symbolobj.Symbols[i].Value, rendersymbol);
        } else {
          let rangeArray = Symbolobj.Symbols[i].Value.split("-");
          if (rangeArray.length == 1) {
            parseFloat(rangeArray[0]), parseFloat(rangeArray[0]), rendersymbol;
          } else {
            renderer.addBreak(
              parseFloat(rangeArray[0]),
              parseFloat(rangeArray[1]),
              rendersymbol
            );
          }
        }
      }
    }
  } else {
    if (RenderType == "SimpleRender") {
      //简单符号填充
      if (Symbolobj.SymbolType == "Simple") {
        //简单渲染（简单符号）
        if (Symbolobj.Symbol.outline != null) {
          rendersymbol = initRendererSymbol(
            Symbolobj.Symbol,
            Symbolobj.SymbolType,
            GeoType
          );
        } else {
          rendersymbol = new esriModule.SimpleMarkerSymbol(
            Symbolobj.Symbol.style,
            Symbolobj.Symbol.size,
            null,
            Symbolobj.Symbol.color
          );
        }
      } else {
        //图片填充
        rendersymbol = new esriModule.PictureMarkerSymbol(
          myConfig.baseUrl + Symbolobj.Symbol.url,
          Symbolobj.Symbol.width,
          Symbolobj.Symbol.height
        );
      }
      renderer = new esriModule.SimpleRenderer(rendersymbol);
    } else {
      // 唯一值||分级渲染
      let defaultnullsymbol;
      if (Symbolobj.Symbols[0].SymbolsType == "Simple") {
        defaultnullsymbol = initRendererSymbol(
          Symbolobj.Symbols[0].Symbol,
          Symbolobj.Symbols[0].SymbolsType,
          GeoType
        );
      } else {
        defaultnullsymbol = new esriModule.PictureMarkerSymbol(
          myConfig.baseUrl + Symbolobj.Symbols[0].Symbol.url,
          Symbolobj.Symbols[0].Symbol.width,
          Symbolobj.Symbols[0].Symbol.height
        );
      }
      if (RenderType == "UniqueRender") {
        renderer = new esriModule.UniqueValueRenderer(
          defaultnullsymbol,
          Symbolobj.FieldName
        );
      } else {
        renderer = new esriModule.ClassBreaksRenderer(
          defaultnullsymbol,
          Symbolobj.FieldName
        );
      }
      for (let i = 0; i < Symbolobj.Symbols.length; i++) {
        let symobj = Symbolobj.Symbols[i].Symbol;
        if (Symbolobj.Symbols[i].SymbolsType == "Simple") {
          if (symobj.outline != null) {
            rendersymbol = initRendererSymbol(
              symobj,
              Symbolobj.Symbols[i].SymbolsType,
              GeoType
            );
          } else {
            rendersymbol = new esriModule.SimpleMarkerSymbol(
              symobj.style,
              null,
              symobj.color
            );
          }
        } else {
          rendersymbol = new esriModule.PictureMarkerSymbol(
            myConfig.baseUrl + symobj.url,
            symobj.width,
            symobj.height
          );
        }
        if (RenderType == "UniqueRender") {
          renderer.addValue(Symbolobj.Symbols[i].Value, rendersymbol);
        } else {
          let rangeArray = Symbolobj.Symbols[i].Value.split("-");
          if (rangeArray.length == 1) {
            renderer.addBreak(
              parseFloat(rangeArray[0]),
              parseFloat(rangeArray[0]),
              rendersymbol
            );
          } else {
            renderer.addBreak(
              parseFloat(rangeArray[0]),
              parseFloat(rangeArray[1]),
              rendersymbol
            );
          }
        }
      }
    }
  }
  return renderer;
}

/**
 * @author: wyt
 * @description: 渲染符号
 * @param {*} symobj symbol
 * @param {*} symbolType symbol类型
 * @param {*} geoType 数据类型
 * @return {*}
 */

function initRendererSymbol(symobj, symbolType, geoType) {
  let esriModule = store.state.esriModule;
  let rendersymbol = {};
  if (symbolType == "Simple") {
    if (geoType == "面") {
      rendersymbol = new esriModule.SimpleFillSymbol(
        symobj.style,
        new esriModule.SimpleLineSymbol({
          style: symobj.outline.style,
          color: symobj.outline.color,
          width: symobj.outline.width
        }),
        symobj.color
      );
    } else if (geoType == "线") { } else {
      rendersymbol = new esriModule.SimpleMarkerSymbol(
        symobj.style,
        symobj.size,
        new esriModule.SimpleLineSymbol({
          color: symobj.outline.color,
          width: symobj.outline.width
        }),
        symobj.color
      );
    }
  } else {
    if (geoType == "面") {
      rendersymbol = new esriModule.PictureFillSymbol(
        myConfig.baseUrl + symobj.url,
        new esriModule.SimpleLineSymbol({
          style: symobj.outline.style,
          color: symobj.outline.color,
          width: symobj.outline.width
        }),
        symobj.width,
        symobj.height
      );
    } else if (geoType == "线") { } else { }
  }
  return rendersymbol;
}



/**
 * @author: wyt
 * @description: 颜色转换
 * @export
 * @param {*} color 颜色值
 * @return {*} color
 */
export function getColorFromStyle(color) {
  let esriModule = "";
  var length,
    rgbStr,
    rgb,
    _color = "";
  if (color) {
    esriModule = store.state.esriModule;
    length = color.length;
    rgbStr = color.substring(5, length - 1);
    if (color.indexOf("rgba") == -1) {
      rgbStr = color.substring(4, length - 1);
    }
    rgb = rgbStr.split(",");
    _color = new esriModule.Color([rgb[0], rgb[1], rgb[2], rgb[3]]);
  }
  return _color;
}

/**
 * @author: wyt
 * @description: 简单渲染
 * @export
 * @param {*} type 数据类型
 * @param {*} fillColor 填充颜色
 * @param {*} outlineWidth 边框长度
 * @param {*} outlineColor 边框颜色
 * @param {*} pointSize 点大小
 * @return {*}  symbol
 */
export function simpleRender(
  type,
  fillColor,
  outlineWidth,
  outlineColor,
  pointSize
) {
  var esriModule = store.state.esriModule;
  var rendersymbol = "";
  switch (type) {
    case "point":
      if (outlineWidth == 0) {
        rendersymbol = new esriModule.SimpleMarkerSymbol(
          esriModule.SimpleMarkerSymbol.STYLE_CIRCLE,
          pointSize,
          null,
          fillColor
        );
      } else {
        rendersymbol = new esriModule.SimpleMarkerSymbol(
          esriModule.SimpleMarkerSymbol.STYLE_CIRCLE,
          pointSize,
          new esriModule.SimpleLineSymbol(
            esriModule.SimpleLineSymbol.STYLE_SOLID,
            outlineColor,
            outlineWidth
          ),
          fillColor
        );
      }
      break;
    case "polyline":
      rendersymbol = new esriModule.SimpleLineSymbol(
        esriModule.SimpleLineSymbol.STYLE_SOLID,
        outlineColor,
        outlineWidth
      );
      break;
    case "polygon":
      if (outlineWidth == 0)
        rendersymbol = new esriModule.SimpleFillSymbol(
          esriModule.SimpleFillSymbol.STYLE_SOLID,
          null,
          fillColor
        );
      else {
        rendersymbol = new esriModule.SimpleFillSymbol(
          esriModule.SimpleFillSymbol.STYLE_SOLID,
          new esriModule.SimpleLineSymbol(
            esriModule.SimpleLineSymbol.STYLE_SOLID,
            outlineColor,
            outlineWidth
          ),
          fillColor
        );
      }
      break;
  }
  var renderer = new esriModule.SimpleRenderer(rendersymbol);
  var obj = {
    Symbol: rendersymbol,
    Renderer: renderer
  };
  return obj;
}

/**
 * @author: wyt
 * @description: 图片渲染
 * @export
 * @param {*} type 数据类型
 * @param {*} fileUrl 图片路径
 * @param {*} color 颜色
 * @param {*} width 宽度
 * @return {*}
 */
export function pictureRender(type, fileUrl, color, width) {
  var esriModule = store.state.esriModule;
  var rendererSymbol, render;
  switch (type) {
    case "point":
      rendererSymbol = new esriModule.PictureMarkerSymbol(fileUrl, 24, 24);
      break;
    case "polygon":
      if (width == 0) {
        rendererSymbol = new esriModule.PictureFillSymbol({
          url: fileUrl,
          height: 32,
          width: 32,
          outline: null
        });
      } else {
        rendererSymbol = new esriModule.PictureFillSymbol(
          fileUrl,
          new esriModule.SimpleLineSymbol(
            esriModule.SimpleLineSymbol.STYLE_SOLID,
            color,
            width
          ),
          32,
          32
        );
      }
      break;
  }
  return rendererSymbol;
}

/**
 * @author: wyt
 * @description: 获取选中的要素符号
 * @export
 * @param {*} geometrytype 要素类型
 * @param {*} oriSymbol 旧符号
 * @param {*} color 颜色
 * @return {*}
 */
export function getSelectSymbol(geometrytype, oriSymbol, color) {
  var esriModule = store.state.esriModule;
  var selectfillsymbol;
  if (geometrytype == "polygon") {
    selectfillsymbol = new esriModule.SimpleFillSymbol(
      esriModule.SimpleFillSymbol.STYLE_SOLID,
      new esriModule.SimpleLineSymbol({
        color: color,
        width: 2
      }),
      oriSymbol.color
    );
  } else if (geometrytype == "polyline") {
    selectfillsymbol = new esriModule.SimpleLineSymbol({
      color: color,
      width: 1
    });
  } else {
    if (getPageType() == 4) {
      selectfillsymbol = new esriModule.PictureMarkerSymbol(
        require("@/static/images/mobileP.png"),
        24,
        24
      );
    } else {
      selectfillsymbol = new esriModule.SimpleMarkerSymbol({
        style: "circle",
        color: color, //new esriModule.Color([0, 0, 0, 0]),
        size: 10,
        outline: {
          color: color,
          width: 1
        }
      });
    }
  }
  return selectfillsymbol;
}

/**
 * @author: wyt
 * @description: 检查字段类型
 * @export
 * @param {*} fieldName 字段名
 * @param {*} content 字段值
 * @param {*} type 字段类型
 * @param {*} Length 字段从长度
 * @return {*}
 */
export function checkFieldType(fieldName, content, type, Length) {
  if (type == "Short Integer" || type == "Long Integer") {
    if (isNaN(+content)) {
      return {
        flag: false,
        msg: fieldName + "输入值类型有误，请输入int类型的值"
      };
    }
    if (content.toString().indexOf(".") != -1) {
      return {
        flag: false,
        msg: fieldName + "输入值类型有误，请输入int类型的值"
      };
    }
  }
  if (type == "Text") {
    if (Length != 0) {
      if (content.length > Length) {
        return {
          flag: false,
          msg: fieldName + "输入值字符长度超过了该字段的最大长度"
        };
      }
    }
  }
  if (type == "Double") {
    if (isNaN(content)) {
      return {
        flag: false,
        msg: fieldName + "输入值类型有误，请输入double类型的值"
      };
    }
  }
  if (type == "Float") {
    if (isNaN(content)) {
      return {
        flag: false,
        msg: fieldName + "输入值类型有误，请输入float类型的值"
      };
    }
  }
  if (type == "Date") {
    if (!(isNaN(content) && !isNaN(Date.parse(content))) && content != "") {
      return {
        flag: false,
        msg: fieldName + "输入值类型有误，请输入date类型的值"
      };
    }
  }
  return {
    flag: true,
    msg: ""
  };
}

/**
 * @author: wyt
 * @description: symbol样式转html样式
 * @export
 * @param {*} data
 * @return {*}
 */
export function getStyle(data) {
  var style = {};
  if (data.shape == "polygon") {
    if (
      (data.renderType == "SimpleRender" ||
        data.renderType == "UniqueRender" ||
        data.renderType == "ClassBreakRender" ||
        data.renderType == "Interpolation") &&
      data.symbolType == "Simple"
    ) {
      style = {
        background: data.style.background,
        "border-width": data.style.borderWidth + "px",
        "border-style": "solid",
        "border-color": data.style.borderColor,
        opacity: data.style.opacity
      };
    } else if (
      (data.renderType == "SimpleRender" ||
        data.renderType == "UniqueRender" ||
        data.renderType == "ClassBreakRender") &&
      data.symbolType == "Picture"
    ) {
      style = {
        "background-image": "url('" + commonB.getImgPathUrl() + data.style.url + "')",
        "background-size": "cover",
        "border-style": "solid",
        "border-width": data.style.borderWidth + "px",
        "border-color": data.style.borderColor,
        opacity: data.style.opacity
      };
    }
  } else if (data.shape == "polyline") {
    if (
      (data.renderType == "SimpleRender" && data.symbolType == "Simple") ||
      (data.renderType == "UniqueRender" && data.symbolType == "Simple") ||
      (data.renderType == "ClassBreakRender" && data.symbolType == "Simple")
    ) {
      style = {
        "border-color": data.style.borderColor,
        "border-style": data.style.borderStyle == "dash" ? "dashed" : "solid",
        "border-width": data.style.borderWidth + "px",
        opacity: data.style.opacity
      };
    }
  } else {
    //点
    if (
      (data.renderType == "SimpleRender" ||
        data.renderType == "UniqueRender" ||
        data.renderType == "ClassBreakRender") &&
      data.symbolType == "Simple"
    ) {
      style = {
        // background: data.style.background,
        color: data.style.background,
        // "border-width": data.style.borderWidth + "px",
        // "border-color": data.style.borderColor,
        // "border-style": "solid",
        opacity: data.style.opacity,
        // width: data.style.size + "px",
        // height: data.style.size + "px"
        "font-size": data.style.size + "px",
        "transform": `rotate(${data.angle}deg)`,
        unicode: data.style.unicode
      };
    } else if (
      (data.renderType == "SimpleRender" ||
        data.renderType == "UniqueRender" ||
        data.renderType == "ClassBreakRender") &&
      data.symbolType == "Picture"
    ) {
      style = {
        "background-image": "url('" + commonB.getImgPathUrl() + data.style.url + "')",
        "background-size": "cover",
        width: data.style.imgWidth + "px",
        height: data.style.imgHeight + "px",
        "border-color": data.style.borderColor,
        opacity: data.style.opacity
      };
    }
  }
  return style;
}

/**
 * @author: wyt
 * @description: 随机生成rgb颜色
 * @export
 * @return {*}
 */
export function randomRgbColor(type) {
  //随机生成RGB颜色
  var r = Math.floor(60 + Math.random() * 140);
  var g = Math.floor(60 + Math.random() * 140);
  var b = Math.floor(30 + Math.random() * 140);
  if (type === "面" || type === "polygon") {
    r = Math.floor(155 + Math.random() * 93);
    g = Math.floor(155 + Math.random() * 93);
    b = Math.floor(155 + Math.random() * 93);
  }
  return "rgba(" + r + "," + g + "," + b + "," + 1 + ")"; //返回rgb(r,g,b,a)格式颜色
}

/**
 * @author: wyt
 * @description: 随机生成rgb颜色
 * @export
 * @return {*}
 */
export function randomRgbColorLine() {
  //随机生成RGB颜色
  var r = Math.floor(200 + Math.random() * 55); //随机生成256以内r值
  var g = Math.floor(100 + Math.random() * 55); //随机生成256以内g值
  var b = Math.floor(30 + Math.random() * 55); //随机生成256以内b值

  return "rgba(" + r + "," + g + "," + b + "," + 1 + ")"; //返回rgb(r,g,b,a)格式颜色
}

/**
 * @author: wyt
 * @description: 获取树形节点中选中的节点数据
 * @export
 * @param {*} treeData 数据
 * @param {*} nodeKey 节点的key（checked/expaned）
 * @return {*}
 */
export function setDataNodeChecked(treeData, nodeKey) {
  var checkedKeys = [],
    checkedNodes = [];
  var setChecked = function (nodes, key) {
    if (key == undefined) {
      key = [];
    }
    var tmpKey = key.concat();
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i][nodeKey]) {
        tmpKey.push(nodes[i].id);
        checkedKeys.push(nodes[i].id);
        checkedNodes.push(nodes[i]);
      } else {
        //return;
      }
      if (nodes[i].children) {
        var findResult = setChecked(nodes[i].children, tmpKey);
        if (findResult) {
          return findResult;
        }
      }
    }
  };
  setChecked(treeData);
  return {
    checkedKeys: checkedKeys,
    checkedNodes: checkedNodes
  };
}
/**
 * @author: wyt
 * @description: 获取树形节点中选中的节点数据
 * @export
 * @param {*} filterNodes 树形节点
 * @param {*} taskIdS  taskId数组
 * @param {*} type
 */
export async function fillFeatureData(filterNodes, taskIdS, type) {
  let esriModule = store.state.esriModule;
  for (var i = 0; i < filterNodes.length; i++) {
    var currentLayer = map.getLayer("dataLayer_" + filterNodes[i].id);
    let isHasProperty = currentLayer.dataAttributes.isHasProperty;
    if (currentLayer != undefined) {
      currentLayer.clear();
    }
    var LabelGraphicLayer = map.getLayer(filterNodes[i].id + "_Label");
    if (LabelGraphicLayer != undefined) {
      LabelGraphicLayer.clear();
    }
    let timestamp = Date.now();
    let params = {
      Userid: store.state.user.UserId,
      taskId: taskIdS.toString(),
      GDataId: filterNodes[i].gDataId,
      TaskDataId: store.state.taskDataId,
      mapDocId: store.state.SingleData.MapDocs.ID,
      IsALL: isHasProperty ? 0 : 1,
      timestamp: timestamp,
      secretkey: ""
    };
    let secretkey = getSecretkey(params);
    params.secretkey = secretkey;
    await getBatchDataByProject(params).then(result => {
      if (result.data.OBSpath != null) {
        //批量取数据
        let allData = getObSData(result.data, result.data.data, 2);
        result.data.data = allData;
      }
      let data = result.data.data;
      if (data == null || data.length == 0) {
        store.commit("changeDataLoadState", false);
      } else {
        let gdata = [];
        for (let key in data) {
          gdata = gdata.concat(data[key]);
        }
        var features = getFeatures(
          filterNodes[i].geoType,
          gdata,
          result.data.bases.Coordinate,
          filterNodes[i].id,
          filterNodes[i].gDataId
        );
        var defaultsymbol = getDefaultSymbol(filterNodes[i].geoType);
        var allLayerData = store.state.allLayerData;
        var layerData = allLayerData.filter(item => {
          return item.Id == filterNodes[i].id;
        });
        let renderer = "";
        if (layerData[0].Symbol != "") {
          renderer = getRenderer(
            layerData[0].GeoType,
            layerData[0].RenderType,
            JSON.parse(layerData[0].Symbol)
          );
        } else {
          renderer = new esriModule.SimpleRenderer(defaultsymbol);
        }
        currentLayer.setRenderer(renderer);
        currentLayer.applyEdits(features, null, null);
        if (layerData[0].Label.trim() != "") {
          var LabelInfo = JSON.parse(layerData[0].Label);
          getLabelGraphic(filterNodes[i].id, layerData[0].GeoType, LabelInfo);
        }
        if (i == filterNodes.length - 1) {
          store.commit("changeDataLoadState", false);
        }
      }
    });
  }
  changeAttrTable(filterNodes);
}

/**
 * @author: wyt
 * @description: 属性表变化情况
 * @export
 * @param {*} vetorNodes 当前节点
 */
export function changeAttrTable(vetorNodes) {
  //属性表打开状态数据变化
  let openTableLayerId = store.state.openTableLayerId;
  if (openTableLayerId != "") {
    let index = -1;
    index = vetorNodes.findIndex(item => {
      return item.id == openTableLayerId;
    });
    let currentLayer = map.getLayer("dataLayer_" + openTableLayerId);
    let IdArr = currentLayer.graphics.map(item => {
      return item.attributes.ID;
    });
    if (index > -1) {
      store.commit("set_featuresChange", IdArr);
    }
  }
}

/**
 * @author: wyt
 * @description: 图层要素数据移除
 * @export
 * @param {*} layerId
 */
export function handleMap(layerId) {
  var currentLayer = map.getLayer("dataLayer_" + layerId);
  var LabelGraphicLayer = map.getLayer(layerId + "_Label");
  if (currentLayer) {
    for (var j = 0; j < currentLayer.graphics.length; j++) {
      var item = currentLayer.graphics[j];
      if (item.attributes.TaskId == CurrentEditTaskGraphic.attributes.Taskid) {
        currentLayer.remove(item);
        j = j - 1;
      }
    }
  }
  if (LabelGraphicLayer != undefined) {
    for (var k = 0; k < LabelGraphicLayer.graphics.length; k++) {
      var item = LabelGraphicLayer.graphics[k];
      if (item.attributes.TaskId == CurrentEditTaskGraphic.attributes.Taskid) {
        LabelGraphicLayer.remove(item);
        k = k - 1;
      }
    }
  }
}

export function getShape(rings) {
  var Shape = "";
  for (var i = 0; i < rings.length; i++) {
    if (Shape == "") {
      Shape = rings[i].toString();
    } else {
      Shape = Shape + "#" + rings[i].toString();
    }
  }
  return Shape;
}

/**
 * @author: wyt
 * @description: 获取矢量数据节点
 * @export
 * @param {*} treeData 数据图层节点
 * @return {*}
 */
export function getVetorLayerNode(treeData) {
  var vNodes = [];
  var getNode = function (nodes, key) {
    if (key == undefined) {
      key = [];
    }
    var tmpKey = key.concat();
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].type && nodes[i].type == "shapefileLayer") {
        tmpKey.push(nodes[i]);
        vNodes.push(nodes[i]);
      } else {
        //return;
      }
      if (nodes[i].children) {
        var findResult = getNode(nodes[i].children, tmpKey);
        if (findResult) {
          return findResult;
        }
      }
    }
  };
  getNode(treeData);
  return vNodes;
}

/**
 * @author: wyt
 * @description: 根据parentId获取父节点
 * @export
 * @param {*} treeData 数据图层节点
 * @param {*} parentId 父Id
 * @return {*}
 */
export function getParentNode(treeData, parentId) {
  var vNodes = [];
  var getNode = function (nodes) {
    for (var i = 0; i < nodes.length; i++) {
      if (
        nodes[i].type &&
        nodes[i].type == "layerGroup" &&
        nodes[i].parentId == parentId
      ) {
        vNodes.push(nodes[i]);
        return;
      } else {
        if (nodes[i].children) {
          var findResult = getNode(nodes[i].children);
          if (findResult) {
            return findResult;
          }
        }
      }
    }
  };
  getNode(treeData);
  return vNodes;
}

/**
 * @author: wyt
 * @description: 获取图层符号
 * @export
 * @param {*} geoType 数据类型
 * @param {*} layerId 图层Id
 * @return {*}
 */
export function getLayerSymbol(geoType, layerId) {
  var esriModule = store.state.esriModule;
  var symbol;
  var vectorLayerData = getVetorLayerNode(store.state.dataTreeData);
  var currentLayerData = vectorLayerData.filter(item => {
    return item.id == layerId;
  });
  var targetLayerData = currentLayerData[0].children[0];
  var symbolType = targetLayerData.symbolType;
  if (geoType == "point") {
    if (symbolType == undefined || symbolType == "Simple") {
      var size = targetLayerData.style.size;
      if (size.toString().indexOf("px") != -1) {
        size = targetLayerData.style.size.replace("px", "");
      }
      var fillcolor = getColorFromStyle(targetLayerData.style.background);
      var bordercolor = getColorFromStyle(targetLayerData.style.borderColor);
      var borderwidth = targetLayerData.style.borderWidth;
      symbol = new esriModule.SimpleMarkerSymbol(
        esriModule.SimpleMarkerSymbol.STYLE_CIRCLE,
        size,
        new esriModule.SimpleLineSymbol(
          esriModule.SimpleLineSymbol.STYLE_SOLID,
          bordercolor,
          borderwidth
        ),
        fillcolor
      );
    } else {
      symbol = new esriModule.PictureMarkerSymbol(url, 24, 24);
    }
  } else if (geoType == "polyline") {
    var width = targetLayerData.style.borderWidth;
    var fillcolor = getColorFromStyle(targetLayerData.style.borderColor);
    var lineStyle =
      targetLayerData.style.borderStyle == "solid" ?
        esriModule.SimpleLineSymbol.STYLE_SOLID :
        esriModule.SimpleLineSymbol.STYLE_DASH;
    symbol = new esriModule.SimpleLineSymbol(lineStyle, fillcolor, width);
  } else {
    if (symbolType == undefined || symbolType == "Simple") {
      var fillcolor = getColorFromStyle(targetLayerData.style.background);
      var bordercolor = getColorFromStyle(targetLayerData.style.borderColor);
      var borderwidth = targetLayerData.style.borderWidth;
      symbol = new esriModule.SimpleFillSymbol(
        esriModule.SimpleFillSymbol.STYLE_SOLID,
        new esriModule.SimpleLineSymbol({
          style: esriModule.SimpleLineSymbol.STYLE_SOLID,
          color: bordercolor,
          width: borderwidth
        }),
        fillcolor
      );
    } else {
      var url = targetLayerData.style.url;
      var bordercolor = getColorFromStyle(targetLayerData.style.borderColor);
      var borderwidth = targetLayerData.style.borderwidth;
      symbol = new esriModule.PictureFillSymbol(
        url,
        new esriModule.SimpleLineSymbol({
          style: esriModule.SimpleFillSymbol.STYLE_SOLID,
          color: bordercolor,
          width: borderwidth
        }),
        30,
        30
      );
    }
  }
  return symbol;
}

/**
 * @author: wyt
 * @description: 右侧属性框信息
 * @export
 * @param {*} layerId 图层Id
 * @param {*} type 类型（shapefile）
 */
export async function updateFieldAttribute(layerId, type) {
  if (layerId != "") {
    var fieldDefault = [];
    var layerAttrTable = [];
    var layerData = [];
    let temp = store.state.allLayerData.filter(item => {
      return item.Id == layerId;
    });
    layerData = temp[0];
    if (layerData.field) {
      let layerField = JSON.parse(layerData.field);
      for (var i = 0; i < layerField.length; i++) {
        var ValueRangeStr = layerField[i].ValueRange;
        var ValueRange = [];
        if (ValueRangeStr != null && ValueRangeStr != "") {
          ValueRange = ValueRangeStr.split("|");
        }
        let value = getByType(layerField[i].FildType).value;
        var obj = {
          fieldName: layerField[i].FildName,
          fieldType: layerField[i].FildType,
          length: layerField[i].Length,
          valueRange: ValueRange,
          value: value
        };
        //预设值
        var defaults = getValueRangeAttr(layerData, ValueRange);
        let tmpobj = {
          fieldName: layerField[i].FildName,
          defaults: defaults,
          selectId: -1
        };
        if (layerField[i].FildName == "ID") {
          layerAttrTable.unshift(obj);
          if (defaults.length > 0) {
            fieldDefault.unshift(tmpobj);
          }
        } else {
          layerAttrTable.push(obj);
          if (defaults.length > 0) {
            fieldDefault.unshift(tmpobj);
          }
        }
      }
      let index = layerAttrTable.findIndex(ele => {
        return ele.fieldName == "ID";
      });
      if (index == -1) {
        var obj = {
          fieldName: "ID",
          fieldType: "",
          length: 0,
          valueRange: 0,
          value: 1
        };
        layerAttrTable.unshift(obj);
      }
    }
    store.commit("setFiledDefault", fieldDefault);
    store.commit("setLayerAttrList", layerAttrTable);
  }
}

/**
 * @author: wyt
 * @description: 重置属性信息
 * @export
 * @Reviser：kangsl 20210421
 */
export function resetAttr() {
  let currentEditLayer = store.state.currentEditLayer;
  if (currentEditLayer != "") {
    let graphics = [];
    let currentGraphic = [];
    if (currentEditLayer == "taskExtent") {
      for (let i = 0; i < select.length; i++) {
        if (select[i]._layer.id == currentEditLayer) {
          graphics.push(select[i]);
        }
      }
    } else {
      for (let i = 0; i < select.length; i++) {
        if (select[i]._layer.id == "dataLayer_" + currentEditLayer) {
          graphics.push(select[i]);
        }
      }
    }
    if (graphics.length > 0) {
      currentGraphic.push(graphics[0]);
      var GraAttributes = currentGraphic[0].attributes;
      //右侧属性框填充
      var editLayer = currentGraphic[0].getLayer();
      var dataAttr = editLayer.dataAttributes;
      var layerAttr = store.state.layerAttrList;
      if (layerAttr.length > 0) {
        if (
          (currentEditLayer != "taskExtent" && dataAttr.isEdit == 1) ||
          currentEditLayer == "taskExtent"
        ) {
          for (var i = 0; i < layerAttr.length; i++) {
            if (GraAttributes[layerAttr[i].fieldName]) {
              layerAttr[i].value = GraAttributes[layerAttr[i].fieldName];
            } else {
              layerAttr[i].value = "";
            }
          }
          store.commit("setLayerAttrList", layerAttr);
        }
      }
    }
    //当前选中的要素
    store.commit("set_currentSelect", currentGraphic);
  }
}

/**
 * @author: wyt
 * @description: 查询、选择工具点击查询属性信息
 * @export
 * @param {*} layerId 图层Id
 * @param {*} id 要素Id
 */
export function resetAttrBySearch(layerId, id) {
  updateFieldAttribute(layerId, "shapefile");
  var layerAttr = store.state.layerAttrList;
  var layerInfo = store.state.allLayerData.find(ele => {
    return ele.Id == layerId;
  });
  let params = {
    gdataId: layerInfo.GDataId,
    userid: store.state.user.UserId,
    id: id,
    mapdocId: getPageType() == 0 ? -1 : store.state.SingleData.MapDocs.ID,
    type: getPageType()
  };
  var attributes = {};
  getAttr(params).then(res => {
    var data = res.data;
    if (data.Status == 0) {
      var attr = JSON.parse(data.Data);
      if (attr.length > 0) {
        attributes = attr[0];
        layerAttr = fillAttr(attributes);
      } else {
        attributes = {
          ID: id
        };
        layerAttr.forEach(item => {
          if (item.fieldName == "ID") {
            item.value = id;
          }
        });
      }
      store.commit("setLayerAttrList", layerAttr);
      var current = {
        layerId: layerId,
        attributes: attributes
      };
      store.commit("set_currentSelect", [current]);
    } else {
      Message({
        message: res.data.Msg,
        type: "error"
      });
    }
  });
}
/**
 * @author: kangsl
 * @description: 批量赋值右侧属性变化
 * @export
 * @param {*} layerId 图层Id
 * @param {*} id 要素Id
 */
export function resetAttrByID(layerId, id) {
  var layerAttr = store.state.layerAttrList;
  var layerInfo = store.state.allLayerData.find(ele => {
    return ele.Id == layerId;
  });
  let params = {
    gdataId: layerInfo.GDataId,
    userid: store.state.user.UserId,
    id: id,
    mapdocId: getPageType() == 0 ? -1 : store.state.SingleData.MapDocs.ID,
    type: getPageType()
  };
  var attributes = {};
  getAttr(params).then(res => {
    var data = res.data;
    if (data.Status == 0) {
      var attr = JSON.parse(data.Data);
      if (attr.length > 0) {
        attributes = attr[0];
        layerAttr = fillAttr(attributes);
      } else {
        attributes = {
          ID: id
        };
        layerAttr.forEach(item => {
          if (item.fieldName == "ID") {
            item.value = id;
          }
        });
      }
      store.commit("setLayerAttrList", layerAttr);
      var current = {
        layerId: layerId,
        attributes: attributes
      };
      store.commit("set_currentSelect", [current]);
    } else {
      Message({
        message: res.data.Msg,
        type: "error"
      });
    }
  });
}

/**
 * @author: wyt
 * @description: 属性赋值
 * @export
 * @param {*} attributes
 * @return {*}
 */
export function fillAttr(attributes) {
  var layerAttr = store.state.layerAttrList;
  if (layerAttr.length > 0) {
    for (var i = 0; i < layerAttr.length; i++) {
      if (attributes[layerAttr[i].fieldName]) {
        layerAttr[i].value = attributes[layerAttr[i].fieldName];
      } else {
        layerAttr[i].value = "";
      }
    }
  }
  return layerAttr;
}

/**
 * @author: wyt
 * @description: 右侧属性tab=》预设值
 * @export
 * @param {*} data
 * @param {*} valueRange 值域
 * @return {*}
 */
export function getValueRangeAttr(data, valueRange) {
  var fieldDefault = [];
  let symbol = getLegend(
    data.GeoType,
    data.RenderType,
    JSON.parse(data.Symbol),
    data.Opacity / 100
  );
  for (var j = 0; j < valueRange.length; j++) {
    let obj = {},
      sys = {};
    let newSys = [];
    if (data.RenderType == "ClassBreakRender") {
      newSys = symbol.filter(function (currentValue, index, arr) {
        let label = symbol[index].label.split("-");
        if (index == 0) {
          if (
            parseFloat(valueRange[j]) >= parseFloat(label[0]) &&
            parseFloat(valueRange[j]) <= parseFloat(label[1])
          ) {
            return currentValue;
          }
        } else {
          return (
            parseFloat(valueRange[j]) > parseFloat(label[0]) &&
            parseFloat(valueRange[j]) <= parseFloat(label[1])
          );
        }
      });
    } else {
      newSys = symbol.filter(item => {
        return item.label == valueRange[j];
      });
    }
    if (newSys.length == 0) {
      sys = JSON.parse(JSON.stringify(symbol[0]));
    } else {
      sys = JSON.parse(JSON.stringify(newSys[0]));
    }
    obj = Object.assign(sys, {
      value: valueRange[j],
      id: []
    });
    fieldDefault.push(obj);
  }
  return fieldDefault;
}

/**
 * @author: wyt
 * @description: 图层的图例
 * @export
 * @param {*} geoType 数据类型
 * @param {*} RenderType 渲染类型
 * @param {*} SymbolObj symbol
 * @param {*} Opacity 透明度
 * @return {*}
 */
export function getLegend(geoType, RenderType, SymbolObj, Opacity) {
  var Symbolobj = SymbolObj;
  var obj = {},
    arr = [];
  if (geoType == "面") {
    var borderColor = "";
    var borderWidth = 0;
    if (RenderType == "SimpleRender") {
      //简单符号填充
      if (Symbolobj == "" || JSON.stringify(Symbolobj) == "{}") {
        obj = {
          shape: "polygon",
          style: {}
        };
      } else {
        if (Symbolobj.SymbolType == "Simple") {
          //简单渲染（简单符号）
          var background = convertToRGB(Symbolobj.Symbol.color);
          if (Symbolobj.Symbol.outline != null) {
            borderColor = convertToRGB(Symbolobj.Symbol.outline.color);
            borderWidth = Symbolobj.Symbol.outline.width;
          }

          obj = {
            shape: "polygon",
            renderType: RenderType,
            symbolType: Symbolobj.SymbolType,
            lineStyles: Symbolobj.Symbol.lineStyles ? Symbolobj.Symbol.lineStyles : [],
            style: {
              background: background,
              opacity: Opacity,
              borderColor: borderColor,
              borderWidth: borderWidth,
              isflu: Symbolobj.Symbol.isflu,
              fluorescence: Symbolobj.Symbol.fluorescence,
            }
          };
        } else {
          //图片填充
          var url = Symbolobj.Symbol.url;
          if (Symbolobj.Symbol.outline != null) {
            borderColor = convertToRGB(Symbolobj.Symbol.outline.color);
            borderWidth = Symbolobj.Symbol.outline.width;
          }
          obj = {
            shape: "polygon",
            renderType: RenderType,
            symbolType: Symbolobj.SymbolType,
            lineStyles: Symbolobj.Symbol.lineStyles ? Symbolobj.Symbol.lineStyles : [],
            style: {
              url: url,
              opacity: Opacity,
              borderColor: borderColor,
              borderWidth: borderWidth
            }
          };
        }
      }
      arr.push(obj);
    } else if (RenderType == "Interpolation") {
      for (var i = 0; i < Symbolobj.breaks.length; i++) {
        var background = convertToRGB(Symbolobj.colors[i].color);
        if (Symbolobj.colors[i].outline != null) {
          borderColor = convertToRGB(Symbolobj.colors[i].outline.color);
          borderWidth = Symbolobj.colors[i].outline.width;
        }
        let label = "";
        if (i == 0) {
          label = "<=" + Symbolobj.breaks[i];
        } else {
          label = Symbolobj.breaks[i - 1] + "-" + Symbolobj.breaks[i];
        }
        obj = {
          shape: "polygon",
          renderType: RenderType,
          symbolType: "Simple",
          lineStyles: Symbolobj.Symbol.lineStyles ? Symbolobj.Symbol.lineStyles : [],
          style: {
            background: background,
            opacity: Opacity,
            borderColor: borderColor,
            borderWidth: borderWidth
          },
          label: label,
          mark: ""
        };
        arr.push(obj);
      }
    } else {
      // 唯一值或分级
      for (var i = 0; i < Symbolobj.Symbols.length; i++) {
        var symobj = Symbolobj.Symbols[i].Symbol;
        if (Symbolobj.Symbols[i].SymbolsType == "Simple") {
          var background = convertToRGB(symobj.color);
          if (symobj.outline != null) {
            borderColor = convertToRGB(symobj.outline.color);
            borderWidth = symobj.outline.width;
          }
          obj = {
            shape: "polygon",
            renderType: RenderType,
            symbolType: Symbolobj.Symbols[i].SymbolsType,
            lineStyles: symobj.lineStyles ? symobj.lineStyles : [],
            style: {
              background: background,
              opacity: Opacity,
              borderColor: borderColor,
              borderWidth: borderWidth
            },
            label: Symbolobj.Symbols[i].Value,
            mark: RenderType == "ClassBreakRender" ? Symbolobj.Symbols[i].Mark : ""
          };
        } else {
          var url = symobj.url;
          if (symobj.outline != null) {
            borderColor = convertToRGB(symobj.outline.color);
            borderWidth = symobj.outline.width;
          }
          obj = {
            shape: "polygon",
            renderType: RenderType,
            symbolType: Symbolobj.Symbols[i].SymbolsType,
            lineStyles: symobj.lineStyles ? symobj.lineStyles : [],
            style: {
              url: url,
              opacity: Opacity,
              borderColor: borderColor,
              borderWidth: borderWidth
            },
            label: Symbolobj.Symbols[i].Value,
            mark: RenderType == "ClassBreakRender" ? Symbolobj.Symbols[i].Mark : ""
          };
        }
        arr.push(obj);
      }
    }
  } else if (geoType == "线") {
    if (Symbolobj == "" || JSON.stringify(Symbolobj) == "{}") {
      obj = {
        shape: "polyline",
        style: {}
      };
      arr.push(obj);
    } else {
      if (RenderType == "SimpleRender") {
        //简单符号填充
        if (Symbolobj.SymbolType == "Simple") {
          //简单渲染（简单符号）
          var borderColor = convertToRGB(Symbolobj.Symbol.color);
          var borderWidth = Symbolobj.Symbol.width;
          var borderStyle =
            Symbolobj.Symbol.style == "solid" ? "solid" : "dash";

          obj = {
            shape: "polyline",
            renderType: RenderType,
            symbolType: Symbolobj.SymbolType,
            lineStyles: Symbolobj.Symbol.lineStyles ? Symbolobj.Symbol.lineStyles : [],
            style: {
              borderColor: borderColor,
              borderWidth: borderWidth,
              opacity: Opacity,
              borderStyle: borderStyle,
              isflu: Symbolobj.Symbol.isflu,
              fluorescence: Symbolobj.Symbol.fluorescence,
            }
          };
        } else {
          //图片填充
        }
        arr.push(obj);
      } else {
        // 唯一值
        for (var i = 0; i < Symbolobj.Symbols.length; i++) {
          var symobj = Symbolobj.Symbols[i].Symbol;
          if (Symbolobj.Symbols[i].SymbolsType == "Simple") {
            var background = convertToRGB(symobj.color);
            var borderWidth = symobj.width;
            var borderStyle = symobj.style;
            obj = {
              shape: "polyline",
              renderType: RenderType,
              symbolType: Symbolobj.Symbols[i].SymbolsType,
              lineStyles: symobj.lineStyles ? symobj.lineStyles : [],
              style: {
                borderColor: background,
                borderWidth: borderWidth,
                borderStyle: borderStyle,
                opacity: Opacity
              },
              label: Symbolobj.Symbols[i].Value,
              mark: RenderType == "ClassBreakRender" ?
                Symbolobj.Symbols[i].Mark : ""
            };
          } else { }
          arr.push(obj);
        }
      }
    }
  } else {
    var borderColor = "";
    var borderWidth = 0;
    if (Symbolobj == "" || JSON.stringify(Symbolobj) == "{}") {
      obj = {
        shape: "point",
        style: {}
      };
      arr.push(obj);
    } else {
      if (RenderType == "SimpleRender") {
        //简单符号填充
        if (Symbolobj.SymbolType == "Simple") {
          //简单渲染（简单符号）
          var background = convertToRGB(Symbolobj.Symbol.color);
          if (Symbolobj.Symbol.outline != null) {
            borderColor = convertToRGB(Symbolobj.Symbol.outline.color);
            borderWidth = Symbolobj.Symbol.outline.width;
          }
          var size = Symbolobj.Symbol.size;
          obj = {
            shape: "point",
            renderType: RenderType,
            symbolType: Symbolobj.SymbolType,
            unicode: Symbolobj.Symbol.unicode,
            angle: Symbolobj.Symbol.angle,
            offsetX: Symbolobj.Symbol.offsetX,
            offsetY: Symbolobj.Symbol.offsetY,
            style: {
              background: background,
              borderColor: borderColor,
              borderWidth: borderWidth,
              size: size,
              opacity: Opacity,
              isflu: Symbolobj.Symbol.isflu,
              fluorescence: Symbolobj.Symbol.fluorescence,
            }
          };
        } else {
          //图片填充
          obj = {
            shape: "point",
            renderType: RenderType,
            symbolType: Symbolobj.SymbolType,
            style: {
              url: Symbolobj.Symbol.url,
              opacity: Opacity,
              imgWidth: Symbolobj.Symbol.width,
              imgHeight: Symbolobj.Symbol.height
            }
          };
        }
        arr.push(obj);
      } else {
        // 唯一值
        for (var i = 0; i < Symbolobj.Symbols.length; i++) {
          var symobj = Symbolobj.Symbols[i].Symbol;
          if (Symbolobj.Symbols[i].SymbolsType == "Simple") {
            var background = convertToRGB(symobj.color);
            if (symobj.outline != null) {
              borderColor = convertToRGB(symobj.outline.color);
              borderWidth = symobj.outline.width;
            }
            var size = symobj.size;
            obj = {
              shape: "point",
              renderType: RenderType,
              symbolType: Symbolobj.Symbols[i].SymbolsType,
              unicode: symobj.unicode,
              offsetX: symobj.offsetX,
              offsetY: symobj.offsetY,
              angle: symobj.angle,
              style: {
                background: background,
                borderColor: borderColor,
                borderWidth: borderWidth,
                size: size,
                opacity: Opacity
              },
              label: Symbolobj.Symbols[i].Value,
              mark: RenderType == "ClassBreakRender" ?
                Symbolobj.Symbols[i].Mark : ""
            };
          } else {
            var url = symobj.url;
            obj = {
              shape: "point",
              renderType: RenderType,
              symbolType: Symbolobj.Symbols[i].SymbolsType,
              style: {
                url: url,
                imgWidth: symobj.width,
                imgHeight: symobj.height,
                opacity: Opacity
              },
              label: Symbolobj.Symbols[i].Value,
              mark: RenderType == "ClassBreakRender" ?
                Symbolobj.Symbols[i].Mark : ""
            };
          }
          arr.push(obj);
        }
      }
    }
  }
  return arr;
}

/**
 * @author: wyt
 * @description: 框选、多边形选择赋值
 * @export
 * @param {*} evt
 * @return {*}
 * @Reviser：kangsl 20210421
 */
export async function addSelectGraphic(evt) {
  if (current_tool == null) {
    return;
  }
  let selectedField = store.state.selectedField;
  if (selectedField.length == 0) {
    Message("请选择字段的预设值!");
    return;
  }

  let geometry = evt.geometry;
  var esriModule = store.state.esriModule;
  let layerInfo = store.state.allLayerData.find(
    x => x.Id == store.state.currentEditLayer
  );
  var extent = geometry.getExtent();
  var rowcol = getRowCol(extent);
  var allrowcol = getRowCol(map.extent);
  var alldata = AllChangedData.find(e => e.layerId == layerInfo.Id);
  var viewdata = alldata.data.filter(ele => ele.IsInView == true)
  var selectedIds = [];
  //数据库数据
  if (viewdata) {
    viewdata.forEach(ele => {
      var insGeo = getGeometry(ele.Shape, layerInfo.GeoType);
      let isIntersect = esriModule.geometryEngine.intersects(insGeo, geometry);
      //取相交
      if (isIntersect) {
        if (selectedIds.indexOf(ele.Attr.ID) == -1) {
          selectedIds.push(ele.Attr.ID);
        }
      }
    });
  }
  //选择框所占的行列号
  for (var j = rowcol.minRow; j <= rowcol.maxRow; j++) {
    for (var k = rowcol.minCol; k <= rowcol.maxCol; k++) {
      var selectgeo = convertToScreen(
        geometry,
        j,
        k,
        layerInfo.GeoType,
        rowcol
      );
      var sdata = TileData.find(
        e => e.layerId == layerInfo.Id && e.row == j && e.col == k
      );
      if (sdata) {
        if (sdata.data.J != null && sdata.data.J.length != 0) {
          sdata.data.J.forEach(ele => {
            let ngeo;
            //点线面转为屏幕坐标的geometry
            if (layerInfo.GeoType == "点") {
              //转屏幕坐标
              ngeo = getGeometryToScreen(ele.G, layerInfo.GeoType);
            } else if (layerInfo.GeoType == "线") {
              var jitem = [];
              ele.G.forEach(gitem => {
                let tempitem = gitem.filter(x => x != null);
                if (tempitem.length >= 2) {
                  jitem.push(tempitem);
                }
              });
              if (jitem.length > 0) {
                ngeo = getGeometryToScreen(jitem, layerInfo.GeoType);
              }
            } else {
              var jitem = [];
              ele.G.forEach(gitem => {
                let tempitem = gitem.filter(x => x != null);
                if (tempitem.length >= 4) {
                  jitem.push(tempitem);
                }
              });
              ngeo = getGeometryToScreen(jitem, layerInfo.GeoType);
            }
            if (ngeo) {
              //取相交
              let isIntersect = esriModule.geometryEngine.intersects(
                ngeo,
                selectgeo
              );
              if (isIntersect) {
                if (selectedIds.indexOf(ele.O) == -1) {
                  selectedIds.push(ele.O);
                }
              }
            }
          });
        }
      }
    }
  }
  if (selectedIds.length > 0) {
    let attrobj = {};
    let attrArr = [];
    selectedIds.forEach(item => {
      let obj = {};
      selectedField.forEach(jtem => {
        obj[jtem.fieldName] = jtem.value;
      });
      attrobj[item] = obj;
      let d = JSON.parse(JSON.stringify(obj));
      d.ID = item;
      attrArr.push(d);
    });
    let param = {
      gdataId: parseInt(layerInfo.GDataId),
      data: attrobj,
      mapdocId: getmapDocId(),
      type: getType(),
      userid: store.state.user.UserId
    };
    updateAttrsingleBatch(param).then(resd => {
      if (resd.data.Status == 1) {
        //当属性表打开的时候，更新数据
        let openTableLayerId = store.state.openTableLayerId;
        if (layerInfo.Id == openTableLayerId) {
          //更新属性表，借用之前的方法，参数之前是传graphics,现传ids，作为监听作用，参数无意义
          store.commit("set_featuresChange", selectedIds);
        }
        let currentSelected = store.state.currentSelected;
        if (
          currentSelected[0].layerId == layerInfo.Id &&
          selectedIds.indexOf(currentSelected[0].attributes.ID) != -1
        ) {
          resetAttrByID(layerInfo.Id, currentSelected[0].attributes.ID);
        }
        DTPLabel.clearLabelCanvas(layerInfo.Id);
        DTPLabel.reloadLabelData(layerInfo.Id);

        let layerSym = JSON.parse(layerInfo.Symbol);
        let isRender = false;
        if (layerSym.hasOwnProperty("FieldName")) {
          isRender = true;
        }
        if (isRender) {
          if (attrArr[0][layerSym.FieldName] != undefined) {
            commonB.resetMultiSymbolRender(layerInfo.Id, attrArr);
          }
        }
        Message({
          message: "赋值成功！",
          type: "success"
        });
      } else {
        Message({
          message: resd.data.Msg,
          type: "warning"
        });
      }
    });
  }
}

/**
 * @author: wyt
 * @description: 右侧tab属性-保存
 * @export
 * @param {*} attr 属性对象
 * @param {*} layerId 图层id
 */
export function savaAttrBySingle(attr, layerId) {
  var pageType = getPageType();
  let currentSelected = store.state.allLayerData.filter(item => {
    return item.Id == layerId;
  });
  let gDataId = currentSelected[0].GDataId;
  let {
    ID,
    ...newAttr
  } = attr;
  let params = {
    gdataId: gDataId,
    id: attr.ID,
    data: JSON.stringify(newAttr),
    mapdocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1,
    type: pageType,
    userid: store.state.user.UserId
  };

  updateSingleAttr(params).then(res => {
    if (res.data.Status == 0) {
      Message({
        message: "赋值成功！",
        type: "success"
      });
      //setLabel(layerId, attr, attr.ID);
      //重置符号
      //resetCanvasSymbolByAttr(layerId, attr);
      DTPLabel.clearLabelCanvas(layerId);
      DTPLabel.reloadLabelData(layerId);
      let layerSym = JSON.parse(currentSelected[0].Symbol);
      let isRender = false;
      if (layerSym.hasOwnProperty("FieldName")) {
        isRender = true;
      }
      if (isRender) {
        if (newAttr[layerSym.FieldName] != undefined) {
          commonB.resetMultiSymbolRender(layerId, [attr]);
        }
      }
    } else {
      Message({
        message: res.data.Msg,
        type: "error"
      });
    }
  });
}

/**
 * @author: wyt
 * @description: 右侧tab属性-属性赋值保存（旧）
 * @export
 * @param {*} Id 要素Id
 * @param {*} Attr 属性对象
 * @param {*} layerName 图层Id
 * @param {*} selectId 选择的个数
 * @param {*} taskId
 */
export async function saveSingle(Id, Attr, layerName, selectId, taskId) {
  let esriModule = store.state.esriModule;
  let AttrObj = JSON.parse(JSON.stringify(Attr));
  let currentSelected = store.state.editLayerOptions.filter(item => {
    return item.value == layerName;
  });
  let gDataId = currentSelected[0].GDataId;
  let geoType = currentSelected[0].GDataType;
  let params = {
    ID: Id,
    UserId: store.state.user.UserId,
    GDataId: gDataId,
    AttrObj: [AttrObj],
    IDArray: "",
    TaskId: taskId,
    mapDocId: store.state.pageType == "map" || store.state.pageType == "project" ?
      store.state.SingleData.MapDocs.ID :
      -1,
    type: getPageType(),
    openMapId: getPageType() == 4 ? store.state.openMapId : -1
  };
  await updateFeatureAttr(params).then(res => {
    if (res.data.Status == 1) {
      if (selectId == 0) {
        Message({
          message: "赋值成功！",
          type: "success"
        });
      }
      let currentLayer = map.getLayer("dataLayer_" + layerName);
      let currentLayerTemp = map.getLayer("selectedLayer_" + geoType);
      let targetGraphic;
      currentLayerTemp.graphics.map(ele => {
        if (
          ele.attributes.ID == Id &&
          ele.attributes.selectLayer.layerId == layerName
        ) {
          ele.attributes = Object.assign(ele.attributes, AttrObj);
          targetGraphic = new esriModule.Graphic(
            ele.geometry,
            null,
            ele.attributes
          );
        }
      });
      if (currentLayer) {
        currentLayer.applyEdits(null, [targetGraphic], null);
      }
      setLabel(layerName, AttrObj, Id);
    } else {
      Message.error(res.data.Msg);
    }
  });
}

/**
 * @author: wyt
 * @description: 构造featureLayer数据格式
 * @export
 * @param {*} geoType 类型
 * @return {*}
 */
export function getVectorCollection(geoType) {
  var geometryType = "";
  switch (geoType) {
    case "点":
      geometryType = "esriGeometryPoint";
      break;
    case "线":
      geometryType = "esriGeometryPolyline";
      break;
    case "面":
      geometryType = "esriGeometryPolygon";
      break;
  }
  var VectorDefinition = {
    geometryType: geometryType,
    objectIdField: "ObjectID",
    fields: [{
      name: "ObjectID",
      type: "esriFieldTypeOID",
      alias: "ObjectID"
    }]
  };
  var VectorCollection = {
    layerDefinition: VectorDefinition,
    featureSet: {
      features: [],
      geometryType: geometryType
    }
  };
  return VectorCollection;
}

/**
 * @author: wyt
 * @description: 创建GSPTileLayer图层
 * @export
 * @param {*} serviceUrl 路径
 * @return {*}
 */
export function createGSPTile(serviceUrl, type) {
  var esriModule = store.state.esriModule;
  if (serviceUrl.indexOf("http://") == -1 && serviceUrl.indexOf("https://") == -1) {
    serviceUrl = "http://" + serviceUrl;
  }
  
  var gspTileLayer = new esriModule.GSPTileLayer(serviceUrl, type);
  return gspTileLayer;
}

/**
 * @author: wyt
 * @description: 构造graphic数组
 * @export
 * @param {*} geoType
 * @param {*} data
 * @param {*} coordinate
 * @param {*} layerId
 * @param {*} gDataId
 * @param {*} untype
 * @return {*}
 */
export function getFeatures(
  geoType,
  data,
  coordinate,
  layerId,
  gDataId,
  untype
) {
  var esriModule = store.state.esriModule;
  let arcline = store.state.arcLineArr;
  var features = [];
  for (var i = 0; i < data.length; i++) {
    let newGeo;
    if (data[i].Shape != null && data[i].Shape.length > 0) {
      if (geoType == "点") {
        let geometry = data[i].Shape;
        newGeo = new esriModule.Point({
          x: geometry[0],
          y: geometry[1],
          spatialReference: parseInt(coordinate)
        });
        newGeo = convertLngLat(coordinate, newGeo);
      } else if (geoType == "线") {
        let geometry = RepairGeo(
          data[i].Shape,
          data[i].ID,
          layerId,
          coordinate
        );
        let onj = arcline.find(
          x => x.featureId == data[i].ID && x.layerId == layerId
        );
        if (onj != undefined && onj != null) {
          newGeo = new esriModule.Polyline({
            paths: onj.convertNodes,
            spatialReference: map.spatialReference
          });
        } else {
          newGeo = new esriModule.Polyline({
            paths: geometry,
            spatialReference: parseInt(coordinate)
          });
          newGeo = convertLngLat(coordinate, newGeo);
        }
      } else {
        let geometry = RepairGeo(
          data[i].Shape,
          data[i].ID,
          layerId,
          coordinate
        );
        let onj = arcline.find(
          x => x.featureId == data[i].ID && x.layerId == layerId
        );
        if (onj != undefined && onj != null) {
          newGeo = new esriModule.Polygon({
            rings: onj.convertNodes,
            spatialReference: map.spatialReference
          });
        } else {
          newGeo = new esriModule.Polygon({
            rings: geometry,
            spatialReference: parseInt(coordinate)
          });
          newGeo = convertLngLat(coordinate, newGeo);
        }
      }
      let layerData = store.state.allLayerData.filter(item => {
        return item.Id == layerId;
      });
      let attributes =
        data[i].Attr == "" || data[i].Attr == null ? {} : data[i].Attr;
      if (data[i].Attr == "" || data[i].Attr == null) {
        attributes["ID"] = data[i].ID;
      }
      if (getPageType() == 1) {
        if (layerData[0].RenderType == "UniqueRender") {
          var symbol = JSON.parse(layerData[0].Symbol);
          if (attributes.hasOwnProperty(symbol.FieldName)) {
            var index = attributes[symbol.FieldName];
            var value = "";
            if (index === "other") {
              value = symbol.Symbols[0].Value;
            } else {
              // value = symbol.Symbols[index - 1].Value;
              if (symbol.Symbols[index - 1]) {
                value = symbol.Symbols[index - 1].Value;
              } else {
                value = index;
              }
            }
            attributes[symbol.FieldName] = value;
          } else {
            attributes[symbol.FieldName] = symbol.Symbols[0].Value;
          }
        }
      }
      attributes["TaskId"] = data[i].TaskUnitCode;
      if (untype != undefined && untype == 1) {
        attributes["State"] = data[i].State;
        attributes["Executor"] = data[i].Executor;
      }

      attributes["selectLayer"] = {
        layerId: layerId,
        gDataId: gDataId,
        coordinate: coordinate,
        isEdit: layerData[0].Isedit,
        isSelected: layerData[0].IsChoice,
        IsPicked: layerData[0].IsPicked
      };
      //初始化加入字段
      if (layerData.length > 0) {
        let allField = JSON.parse(layerData[0].field);
        for (let j = 0; j < allField.length; j++) {
          if (!attributes.hasOwnProperty(allField[j].FildName)) {
            attributes[allField[j].FildName] = allField[j].DefaultValue;
          }
        }
      } //
      var graphic = new esriModule.Graphic(newGeo, null, attributes);
      features.push(graphic);
    }
  }
  return features;
}

/**
 * @author: wyt
 * @description: 坐标转换（要素的坐标转地图上的坐标）
 * @export
 * @param {*} convertCoor 坐标系
 * @param {*} geometry
 * @return {*}
 */
export function convertLngLat(convertCoor, geometry, basemapID, TransformPosition) {
  //底图如果是高德、捷泰、腾讯等地图，矢量数据为4490或4326，显示时要进行坐标转换，转到GCJ-02：中国坐标偏移标准
  if (basemapID == 4 || basemapID == 5 || basemapID == 6 || basemapID == 7 || basemapID == 8 || basemapID == 9) {
    if (geometry.spatialReference.wkid == 4490 || geometry.spatialReference.wkid == 4326) {
      let newPaths = []
      let oldPathsOrRings = null
      if (geometry.paths)
        oldPathsOrRings = geometry.paths
      if (geometry.rings)
        oldPathsOrRings = geometry.rings
      oldPathsOrRings.forEach(path => {
        let newPath = []
        path.forEach(pt => {
          let point = TransformPosition.wgs2gcj(pt[0], pt[1])
          newPath.push([point.Lon, point.Lat])
        })
        newPaths.push(newPath)
      })
      if (geometry.paths)
        geometry.paths = newPaths
      if (geometry.rings)
        geometry.rings = newPaths
    }
  }

  if (mapCoordinate == geometry.spatialReference.wkid) {
    return geometry;
  }

  let newGeo;
  var esriModule = store.state.esriModule;
  if (convertCoor < 0) {
    let o = store.state.coorList.find(x => x.Wkid == convertCoor);
    if (o != undefined) {
      if (isProjectionPromise) {
        var outSpatialReference = new esriModule.SpatialReference({
          wkt: o.Wkt
        });
        geometry.setSpatialReference(outSpatialReference);
        newGeo = esriModule.projection.project(geometry, map.spatialReference);
        return newGeo;
      } else {
        var projectionPromise = esriModule.projection.load();
        projectionPromise.then(function () {
          isProjectionPromise = true;
          newGeo = esriModule.projection.project(
            geometry,
            map.spatialReference
          );
          return newGeo;
        });
      }
    }
  } else {
    if (isProjectionPromise) {
      newGeo = esriModule.projection.project(geometry, map.spatialReference);
      return newGeo;
    } else {
      var projectionPromise = esriModule.projection.load();
      projectionPromise.then(function () {
        isProjectionPromise = true;
        newGeo = esriModule.projection.project(geometry, map.spatialReference);
        return newGeo;
      });
    }
  }
}

/**
 * @author: wyt
 * @description:设置默认符号
 * @export
 * @param {*} geoType 数据类型
 * @param {*} type 类型（任务区、shapefile）
 * @return {*}
 */
export function getDefaultSymbol(geoType, type) {
  var esriModule = store.state.esriModule;
  var defaultsymbol;
  var fillColor = randomRgbColor(geoType);
  if (geoType == "点") {
    defaultsymbol = new esriModule.SimpleMarkerSymbol(
      esriModule.SimpleMarkerSymbol.STYLE_CIRCLE,
      15,
      new esriModule.SimpleLineSymbol(
        esriModule.SimpleLineSymbol.STYLE_SOLID,
        new esriModule.Color([110, 110, 110, 1]),
        1
      ),
      new esriModule.Color(fillColor) //[255, 0, 0, 1]
    );
    // defaultsymbol.unicode = myConfig.defaultSymbol;
    defaultsymbol.unicode = '&#xe64f';

    defaultsymbol.offsetX = 0;
    defaultsymbol.offsetY = 0;
  } else if (geoType == "线") {
    defaultsymbol = new esriModule.SimpleLineSymbol(
      esriModule.SimpleLineSymbol.STYLE_SOLID,
      new esriModule.Color(fillColor),
      2
    );
  } else {
    let line = new esriModule.SimpleLineSymbol(
      type && type == "task" ?
        esriModule.SimpleLineSymbol.STYLE_DASH :
        esriModule.SimpleLineSymbol.STYLE_SOLID,
      new esriModule.Color([110, 110, 110, 1]),
      1
    );
    defaultsymbol = new esriModule.SimpleFillSymbol(
      esriModule.SimpleFillSymbol.STYLE_SOLID,
      line,
      new esriModule.Color(fillColor)
    );
  }
  return defaultsymbol;
}

//获取书签
export function getBookmarks(id) {
  let type =
    store.state.pageType == "data" ?
      1 :
      store.state.pageType == "zhongbao" ?
        3 :
        2;
  let temp = [];
  if (type == 2) {
    //我的地图
    getBookmarkDataAll({
      UserID: store.state.user.UserId,
      MapDocUnitCode: id
    }).then(res => {
      temp = res.data;
      store.dispatch("setbookmarksList", temp);
    });
  } else {
    store.dispatch("setbookmarksList", temp);
  }
}

/**
 * @author: wyt
 * @description:添加任务区数据
 * @export
 * @param {*} data
 */
export function applyTaskLayerFeature(data) {
  let fdata = store.state.pageType == "zhongbao" ? [data.Taskgeo] : data.Data;
  var features = [];
  let esriModule = store.state.esriModule;
  let symbol = getDefaultSymbol("面", "task");
  taskTextGraphicLayer.clear();
  for (var i = 0; i < fdata.length; i++) {
    if (fdata[i].Shape != null && fdata[i].Shape.length > 0) {
      let geometry = RepairGeo(fdata[i].Shape, fdata[i].ID);
      var polygon = new esriModule.Polygon({
        rings: geometry,
        spatialReference: parseInt(data.Coordinate)
      });
      polygon = convertLngLat(data.Coordinate, polygon);
      let attributes =
        fdata[i].Attr == null || fdata[i].Attr == "" ? {} : fdata[i].Attr;
      if (fdata[i].Attr == null || fdata[i].Attr == "") {
        attributes["ID"] = fdata[i].ID;
      }
      var graphic = new esriModule.Graphic(polygon, null, attributes);
      features.push(graphic);
      let extent = polygon.getExtent();
      addTaskTextGraphic(extent, attributes["片区名称"]);
    }
  }
  var renderer = new esriModule.SimpleRenderer(symbol);
  taskLayer.setRenderer(renderer);
  taskLayer.applyEdits(features, null, null);
}

/**
 * @author: wyt
 * @description:添加任务区文本图层数据
 * @export
 * @param {*} extent 范围
 * @param {*} name 任务区名称
 */
export function addTaskTextGraphic(extent, name) {
  let esriModule = store.state.esriModule;
  var center_x = (parseFloat(extent.xmax) + parseFloat(extent.xmin)) / 2;
  var center_y = (parseFloat(extent.ymax) + parseFloat(extent.ymin)) / 2;
  var centerpoint_name = new esriModule.Point(
    center_x,
    center_y,
    map.spatialReference
  );
  var font = new esriModule.Font();
  font.setWeight(esriModule.Font.WEIGHT_BOLD);
  var name_Symbol = new esriModule.TextSymbol(name)
    .setColor(new esriModule.Color([255, 0, 0]))
    .setFont(font)
    .setHaloSize(1)
    .setHaloColor(new esriModule.Color([255, 255, 255]));
  taskTextGraphicLayer.add(
    new esriModule.Graphic(centerpoint_name, name_Symbol, {
      type: "taskName"
    })
  );
  taskTextGraphicLayer.hide();
}

export function getExtent() {
  var ViewExtent = map.extent;
  var ViewExtentStr =
    ViewExtent.xmin +
    "," +
    ViewExtent.ymin +
    "," +
    ViewExtent.xmax +
    "," +
    ViewExtent.ymax;
  var zoom = map.getZoom();
  var x = (ViewExtent.xmin + ViewExtent.xmax) / 2;
  var y = (ViewExtent.ymin + ViewExtent.ymax) / 2;
  var obj = {
    x: x,
    y: y,
    zoom: zoom,
    ViewExtent: ViewExtentStr
  };
  return obj;
}

//移除数据
Array.prototype.baoremove = function (dx) {
  if (isNaN(dx) || dx > this.length) {
    return false;
  }
  this.splice(dx, 1);
};

/**
 * @author: wyt
 * @description:保存图层
 * @export
 * @param {*} data
 * @param {*} dataForm 图层数据
 * @return {*}
 */
export async function saveLayer(data, dataForm) {
  let esriModule = store.state.esriModule;
  var mapDocTaskDataId = store.state.taskDataId;
  if (data.TaskDataId != "") {
    if (mapDocTaskDataId != "") {
      if (mapDocTaskDataId != data.TaskDataId) {
        Message("所选择数据的片区与该地图绑定的片区不一致");
        return;
      }
    }
  }
  var renderType = "SimpleRender";
  var layerName = data.Name;
  var layerBigType = "矢量";
  var layerSmallType =
    data.GDataType == 1 ? "点" : data.GDataType == 2 ? "线" : "面";
  var outlineColor = new esriModule.Color([0, 0, 0, 1]);
  let fillColor = new esriModule.Color([0, 0, 0, 0]);
  if (layerSmallType == "点") {
    fillColor = new esriModule.Color([255, 0, 0, 1]);
    outlineColor = new esriModule.Color([0, 0, 0, 1]);
  }
  var geoType =
    data.GDataType == 1 ?
      "point" :
      data.GDataType == 2 ?
        "polyline" :
        "polygon";
  var obj = simpleRender(geoType, fillColor, 1, outlineColor, 8);
  var symbol = {
    SymbolType: "Simple",
    Symbol: obj.Symbol
  };
  var allLayers = store.state.allLayerData;
  var Id = 1;
  if (allLayers.length > 0) {
    Id = Math.max.apply(
      Math,
      allLayers.map(item => {
        return item.Id;
      })
    );
  }
  var LayerStr = {
    Id: Id + 1,
    LayerName: layerName,
    LayerType: layerBigType,
    GeoType: layerSmallType,
    LayerUrl: "",
    LayerField: "[]",
    Label: "",
    LayerAliasName: layerName,
    RenderType: renderType,
    LayerIndex: 0,
    Symbol: JSON.stringify(symbol),
    Opacity: 100,
    OpenState: 0,
    MaxScale: 0,
    MinScale: 0,
    IsChoice: dataForm.isSelected ? 1 : 0,
    Isedit: dataForm.isEditing ? 1 : 0,
    IsPicked: dataForm.IsPicked ? 1 : 0,
    GDataId: data.Id,
    ParentId: 0,
    TaskDataId: data.TaskDataId,
    Executor: store.state.user.UserId,
    IsRelease: false,
    IsInDatabase: true,
    field: data.field,
    IsConcealed: 0
  };
  if (store.state.pageType == "data") {
    handleSaveLayer(data, LayerStr);
  } else {
    let layerId = await addLayerByDoc(data, LayerStr);
    LayerStr.Id = layerId;
  }
  return LayerStr.Id;
}

/**
 * @author: wyt
 * @description:添加图层（地图页面）
 * @param {*} data
 * @param {*} LayerStr 图层数据
 * @return {*}
 */
async function addLayerByDoc(data, LayerStr) {
  let params = {
    LayerName: LayerStr.LayerName,
    LayerType: LayerStr.LayerType,
    GeoType: LayerStr.GeoType,
    LayerUrl: "",
    LayerAliasName: LayerStr.LayerName,
    RenderType: LayerStr.RenderType,
    Symbol: LayerStr.Symbol,
    Executor: store.state.user.UserId,
    MapDocUnitCode: store.state.SingleData.MapDocs.UnitCode,
    GDataId: LayerStr.GDataId,
    Isedit: LayerStr.Isedit,
    IsChoice: LayerStr.IsChoice,
    IsPicked: LayerStr.IsPicked
  };
  let result = await addLayer(params);
  if (result.data.Status == 1) {
    Message({
      message: "添加成功！",
      type: "success"
    });
    LayerStr.Id = result.data.Data;
    handleSaveLayer(data, LayerStr);
  } else {
    Message({
      message: result.data.Msg,
      type: "error"
    });
  }
  return LayerStr.Id;
}

/**
 * @author: wyt
 * @description:保存图层事件
 * @param {*} data
 * @param {*} LayerStr 图层数据
 */
function handleSaveLayer(data, LayerStr) {
  var allLayers = store.state.allLayerData;
  let esriModule = store.state.esriModule;
  let tree3 = store.state.dataTreeData;
  var sortData = sortLayerIndex(allLayers, "矢量");
  sortData.push(LayerStr);
  store.commit("setAllLayerData", sortData);
  var node = getLegend(
    LayerStr.GeoType,
    LayerStr.RenderType,
    JSON.parse(LayerStr.Symbol),
    1
  );
  var pNode = {
    id: LayerStr.Id,
    label: LayerStr.LayerName,
    layerUnitCode: LayerStr.LayerName,
    labelField: "",
    labelChecked: "", //热力图
    heatMapChecked: "",
    heatMapField: "",
    renderField: "",
    type: "shapefileLayer",
    geoType: LayerStr.GeoType,
    targetType: "dataLayer",
    gDataId: data.Id,
    taskDataId: data.TaskDataId,
    checked: true,
    expanded: false,
    isEdit: LayerStr.Isedit,
    isSelected: LayerStr.IsChoice,
    IsPicked: LayerStr.IsPicked,
    isConcealed: 0, //图层显示
    dataLoaded: true, //数据是否已加载
    parentId: 0,
    children: node
  };
  if (tree3[0].children.length > 0) {
    tree3[0].children.unshift(pNode);
  } else {
    tree3[0].children.push(pNode);
  }
  store.dispatch("setDataTree", tree3);
  //编辑工具条图层填充
  var layerOptions = store.state.editLayerOptions;
  var geoType =
    data.GDataType == 1 ?
      "point" :
      data.GDataType == 2 ?
        "polyline" :
        "polygon";
  var option = {
    label: LayerStr.LayerName,
    value: LayerStr.Id,
    type: "shapefile",
    taskDataId: data.TaskDataId,
    labelField: data.field,
    GDataId: LayerStr.GDataId,
    Id: LayerStr.Id,
    GDataType: geoType,
    isInDatabase: LayerStr.isInDatabase,
    taskId: ""
  };
  if (layerOptions.length > 0) {
    layerOptions.unshift(option);
  } else {
    layerOptions.push(option);
  }
  store.commit("setEditLayerOption", layerOptions);
  //地图上添加相应图层
  var VectorCollection = getVectorCollection(LayerStr.GeoType);
  var dataAttr = {
    isEdit: LayerStr.Isedit,
    isSelected: LayerStr.IsChoice,
    IsPicked: LayerStr.IsPicked,
    taskDataId: data.TaskDataId,
    GDataId: data.Id,
    isTaskLayer: 0,
    label: LayerStr.LayerName,
    coordinate: 4326,
    isHasProperty: false
  };
  var VectorDataMap = new esriModule.FeatureLayer(VectorCollection, {
    id: "dataLayer_" + LayerStr.Id,
    dataAttributes: dataAttr
  });
  map.addLayer(VectorDataMap);
}

/**
 * @author: wyt
 * @description:图层数据排序
 * @export
 * @param {*} layers 图层数据
 * @param {*} type 图层类型
 * @return {*}
 */
export function sortLayerIndex(layers, type) {
  if (type == "影像") {
    let data = layers.filter(item => {
      return item.LayerType == type;
    });
    let otherData = layers.filter(item => {
      return item.LayerType != type;
    });
    let result = _.sortBy(data, function (item) {
      return item.LayerIndex; //升序排序
    });
    for (var i = 0; i < result.length; i++) {
      result[i].LayerIndex = i + 1;
    }
    let newVal = otherData.concat(result);
    return newVal;
  } else {
    let data = layers.filter(item => {
      return (
        (item.LayerType == type && item.ParentId == 0) ||
        item.LayerType == "图层组"
      );
    });
    let otherData = layers.filter(item => {
      return (
        item.LayerType == "影像" ||
        (item.LayerType == type && item.ParentId != 0)
      );
    });
    let result = _.sortBy(data, function (item) {
      return item.LayerIndex; //升序排序
    });
    for (var i = 0; i < result.length; i++) {
      result[i].LayerIndex = i + 1;
    }
    let newVal = otherData.concat(result);
    return newVal;
  }
}

/**
 * @author: wyt
 * @description:加载数据（右侧-我的数据：拖进来的数据）
 * @export
 * @param {*} layerId 图层Id
 */
export async function loadDragData(layerId) {
  var vectorData = getVetorLayerNode(store.state.dataTreeData);
  var vectorLayerData = vectorData.find(ele => ele.id == layerId);
  store.commit("changeDataLoadState", true);
  var timestamp = Date.now();

  //加载数据库数据
  await getChangedData(layerId, "init").then(res => {
    //加载行列切片数据
    addTileData(vectorLayerData, "init", store.state.zoomEndTimestamp);
  });

  DTPLabel.addLabelCanvas(layerId);
  store.commit("changeDataLoadState", false);
}

/**
 * @author: wyt
 * @description:根据图层加载数据
 * @export
 * @param {*} layerData 图层数据
 */
export async function loadGeoFeatureByLayer(layerData) {
  //一开始勾选创建图层
  if (layerData.IsConcealed == 0) {
    getDataText();
    var canvasCtn = createTiledCanvas(layerData.Id);
    if (canvasCtn == null) return;
    canvasCtn.style.opacity = parseInt(layerData.Opacity) / 100;
    DTPLabel.addLabelCanvas(layerData.Id);
  }
  let layerIndex = store.state.allLayerData.findIndex(
    ele => ele.Id == layerData.Id
  );
  let pageType = getPageType();
  let params = {
    UserId: store.state.user.userid,
    GDataid: layerData.GDataId,
    type: pageType == 1 ? 1 : 0,
    mapDocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1
  };
  getDataDetail_GDB(params).then(async res => {
    let data = res.data;
    if (data.state.Status == 1) {
      var gdata = data.Gdata_data;
      let coordinate = gdata.Coordinate;
      let obj = {
        coordinate: parseInt(coordinate),
        minscale: gdata.Minscale,
        levelRange: gdata.Classification
      };
      let layerInfo = store.state.allLayerData[layerIndex];
      store.state.allLayerData[layerIndex] = Object.assign(layerInfo, obj);
      setScale(layerData.Id, data);

      let layerNodes = getVetorLayerNode(store.state.dataTreeData);
      let index = layerNodes.findIndex(node => node.id === layerData.Id);
      let flag = getChecked(layerNodes[index], layerInfo);
      if (!(!flag || !isInScale(layerData.Id))) {
        if (layerData.IsConcealed == 0) {
          var vdata = {
            id: layerData.Id,
            gDataId: layerData.GDataId,
            geoType: layerData.GeoType
          };
          let timestamp = Date.now();

          if (!layerInfo.IsTileMode) {
            getAllDataFromServer(layerData.Id, "init");
          } else {
            //编辑操作后的数据
            await getChangedData(layerData.Id, "init").then(res => {
              //行列号数据
              addTileData(vdata, "init", timestamp);
            });
          }
        }
      }
    } else {
      Message({
        type: "error",
        message: data.state.Msg
      });
    }
  });
}

/**
 * @author: wyt
 * @description:根据字段类型获取长度及默认值
 * @export
 * @param {*} type 字段类型
 * @return {*}
 */
export function getByType(type) {
  let length = 10;
  let value = "";
  switch (type) {
    case "Text":
      length = 50;
      value = "";
      break;
    case "Short Integer":
      length = 5;
      value = 0;
      break;
    case "Long Integer":
      length = 10;
      value = 0;
      break;
    case "Date":
      length = 10;
      value = "1900-01-01";
      break;
    case "Float":
      length = 6;
      value = 0;
      break;
    case "Double":
      length = 7;
      value = 0;
      break;
    default:
      length = "";
      value = "";
  }
  let obj = {
    length: length,
    value: value
  };
  return obj;
}

/**
 * @author: wyt
 * @description:获取渲染的符号
 * @export
 * @param {*} attributes 属性
 * @param {*} layerId 图层Id
 * @param {*} type 类型
 * @return {*}
 */
export function getRendererSymbol(attributes, layerId, type) {
  if (layerId != "") {
    let symbol;
    if (type == "shapefile") {
      if (layerId == "POI") {
        let esriModule = store.state.esriModule;
        symbol = new esriModule.SimpleMarkerSymbol(
          esriModule.SimpleMarkerSymbol.STYLE_CIRCLE,
          10,
          new esriModule.SimpleLineSymbol(
            esriModule.SimpleLineSymbol.STYLE_SOLID,
            new esriModule.Color([0, 0, 0]),
            1
          ),
          new esriModule.Color([0, 0, 255, 0.8])
        );
      } else {
        let layer = map.getLayer("dataLayer_" + layerId);
        var currentData = store.state.allLayerData.filter(item => {
          return item.Id == layerId;
        });
        if (currentData.length == 0) {
          return;
        }
        if (currentData[0].RenderType == "SimpleRender") {
          symbol = layer.renderer.symbol;
        } else if (currentData[0].RenderType == "UniqueRender") {
          let render = layer.renderer;
          let attributeField = render.attributeField;
          var allSymbols = render._symbols;
          for (var key in attributes) {
            if (key == attributeField) {
              let value = attributes[key];
              let temsymbol = allSymbols[value];
              if (!temsymbol) {
                symbol = allSymbols["other"].symbol;
              } else {
                symbol = allSymbols[value].symbol;
              }
            }
          }
        } else {
          let render = layer.renderer;
          let attributeField = render.attributeField;
          let allSymbols = render._symbols;
          let breaks = render.breaks;
          breaks.sort(function (x, y) {
            return x[0] - y[0]; //按照二维数组中每个数组元素（数组）的第一个元素升序排列
          });
          for (var key in attributes) {
            if (key == attributeField) {
              let value = parseFloat(attributes[key]);
              let temsymbol = null;
              for (let i = 0; i < breaks.length; i++) {
                if (i == 0) {
                  if (value >= breaks[0][0] && value <= breaks[0][1]) {
                    temsymbol = allSymbols[breaks[0].join("-")];
                  }
                } else {
                  if (value > breaks[i][0] && value <= breaks[i][1]) {
                    temsymbol = allSymbols[breaks[i].join("-")];
                  }
                }
              }
              if (temsymbol != null) {
                symbol = temsymbol;
              } else {
                symbol = render.defaultSymbol;
              }
            }
          }
        }
      }
    } else {
      let layer = map.getLayer(layerId);
      symbol = layer.renderer.symbol;
    }
    return symbol;
  }
}
export function TconvertLngLat(coor, geometry) {
  if (mapCoordinate == coor) {
    return geometry;
  }
  let newGeo;
  var esriModule = store.state.esriModule;
  if (coor < 0) {
    if (!store.state.coorList) {
      return
    }
    let o = store.state.coorList.find(x => x.Wkid == coor);
    if (o) {
      if (isProjectionPromise) {
        var outSpatialReference = new esriModule.SpatialReference({
          wkt: o.Wkt
        });
        newGeo = esriModule.projection.project(geometry, outSpatialReference);
        return newGeo;
      } else {
        var projectionPromise = esriModule.projection.load();
        projectionPromise.then(function () {
          isProjectionPromise = true;
          newGeo = esriModule.projection.project(geometry, outSpatialReference);
          return newGeo;
        });
      }
    }
  } else {
    var outSpatialReference = new esriModule.SpatialReference(coor);
    if (isProjectionPromise) {
      newGeo = esriModule.projection.project(geometry, outSpatialReference);
      return newGeo;
    } else {
      var projectionPromise = esriModule.projection.load();
      projectionPromise.then(function () {
        isProjectionPromise = true;
        newGeo = esriModule.projection.project(geometry, outSpatialReference);
        return newGeo;
      });
    }
  }
}

/**
 * @author: wyt
 * @description:数据分页
 * @export
 * @param {*} data
 * @param {*} pageIndex 页数
 * @param {*} pageSize 每页条数
 * @param {*} total 条数
 * @return {*}
 */
export function pagination(data, pageIndex, pageSize, total) {
  var start = (pageIndex - 1) * pageSize;
  var end = pageIndex * pageSize > total ? total : pageIndex * pageSize;
  var arr = data.slice(start, end);
  return arr;
}

/**
 * @author: wyt
 * @description:定位
 * @export
 * @param {*} gra  graphic
 */
export function setExtent(gra) {
  let extent = gra.geometry.getExtent();
  let esriModule = store.state.esriModule;
  let xmin = extent.xmin - (extent.xmax - extent.xmin);
  let xmax = extent.xmax + (extent.xmax - extent.xmin);
  let ymin = extent.ymin - (extent.ymax - extent.ymin);
  let ymax = extent.ymax + (extent.ymax - extent.ymin);
  let newExtent = new esriModule.Extent(
    xmin,
    ymin,
    xmax,
    ymax,
    map.spatialReference
  );
  map.setExtent(newExtent);
  isLocatePosition = null;
}

export function tureCoordinate(data) {
  switch (data) {
    case "4326":
      return "WGS84";
    case "4490":
      return "CGCS2000";
    case "102100":
      return "Web墨卡托";
    default:
      return "-";
  }
}

/**
 * @author: wyt
 * @description:调用接口取属性数据（old）
 * @export
 * @param {*} layerId 图层Id
 * @param {*} GDataId
 * @param {*} taskId
 */
export async function getAttributesData(layerId, GDataId, taskId) {
  let params = {
    UserId: store.state.user.UserId,
    GDataId: GDataId,
    state: false,
    mapDocId: store.state.pageType == "map" || store.state.pageType == "project" ?
      store.state.SingleData.MapDocs.ID :
      -1,
    Taskids: taskId,
    crowId: store.state.pageType != "data" ? store.state.crowID : "",
    type: getPageType(),
    timestamp: Date.now(),
    secretkey: ""
  };
  let secretkey = getSecretkey(params);
  params.secretkey = secretkey;
  await getGDataAttrByOBS(params)
    .then(res => {
      if (res.data.state.Status == 1) {
        let result = res.data;
        let attrList = [];
        if (result.OBSpath == null) {
          if (result.Table_Attr.length == 0) {
            attrList = result.Attrs == null ? [] : result.Attrs;
          } else {
            attrList = restructureData(result.Attrs, result.Table_Attr);
          }
        } else {
          //取华为服务器数据
          if (taskId == "") {
            let obsAttr = getDataStream(result.OBSpath.Attr);
            attrList =
              result.Table_Attr.length == 0 ?
                obsAttr :
                restructureData(obsAttr, result.Table_Attr);
          } else {
            let obsAttrArray = [];
            for (let key in result.OBSpath) {
              let obsAttr = getDataStream(result.OBSpath[key]);
              obsAttrArray = obsAttrArray.concat(obsAttr);
            }
            if (result.Table_Attr.length == 0) {
              attrList = obsAttrArray;
            } else {
              attrList = restructureData(obsAttrArray, result.Table_Attr);
            }
          }
        }
        updateLayerAttributes(layerId, attrList);
      } else {
        Message({
          message: res.data.state.Msg,
          type: "error"
        });
        store.commit("set_attrLoadState", false);
      }
    })
    .catch(err => {
      store.commit("set_attrLoadState", false);
    });
}

/**
 * @author: wyt
 * @description:取属性（old）
 * @export
 * @param {*} GDataId
 * @param {*} subjectType
 * @return {*}
 */
export async function getAttrByOBS(GDataId, subjectType) {
  let params = {
    UserId: store.state.user.UserId,
    GDataId: GDataId,
    state: false,
    mapDocId: store.state.pageType == "map" || store.state.pageType == "project" ?
      store.state.SingleData.MapDocs.ID :
      -1,
    Taskids: "",
    crowId: store.state.pageType != "data" ? store.state.crowID : "",
    type: subjectType,
    timestamp: Date.now(),
    secretkey: ""
  };

  let secretkey = getSecretkey(params);
  params.secretkey = secretkey;
  let attrList = [];
  try {
    let res = await getGDataAttrByOBS(params);
    if (res.data.state.Status == 1) {
      let result = res.data;
      if (result.OBSpath == null) {
        if (result.Table_Attr.length == 0) {
          attrList = result.Attrs;
        } else {
          attrList = restructureData(result.Attrs, result.Table_Attr);
        }
      } else {
        //取华为服务器数据
        let obsAttr = getDataStream(result.OBSpath.Attr);
        attrList =
          result.Table_Attr.length == 0 ?
            obsAttr :
            restructureData(obsAttr, result.Table_Attr);
      }
    } else {
      Message({
        message: res.data.state.Msg,
        type: "error"
      });
    }
  } catch (err) { }
  return attrList;
}

/**
 * @author: wyt
 * @description:加载图层属性数据（old）
 * @export
 * @param {*} taskDataId
 * @param {*} Id
 * @param {*} GDataId
 * @param {*} layer
 */
export async function loadAttr(taskDataId, Id, GDataId, layer) {
  store.commit("set_attrLoadState", true);
  let taskId = "";
  if (taskDataId == "") {
    //未绑定任务区
    taskId = "";
  } else {
    //绑定任务区
    let graphics = layer.graphics;
    if (graphics.length > 0) {
      let attr = _.groupBy(graphics, function (item) {
        return item.attributes.TaskId;
      });
      let taskIdArrayTmp = Object.keys(attr);
      taskIdArrayTmp = taskIdArrayTmp.filter(item => {
        return item != "null" && item != "undefined";
      });
      let taskIdArray = _.uniq(taskIdArrayTmp);
      taskId = taskIdArray.toString();
    }
  }
  await getAttributesData(Id, GDataId, taskId);
}

/**
 * @author: wyt
 * @description:更新图层属性（old）
 * @export
 * @param {*} layerId 图层Id
 * @param {*} oattributes 属性
 */
export function updateLayerAttributes(layerId, oattributes) {
  let currentLayer;
  if (layerId == "taskExtent") {
    currentLayer = map.getLayer(layerId);
  } else {
    currentLayer = map.getLayer("dataLayer_" + layerId);
  }
  currentLayer.dataAttributes.isHasProperty = true;
  let attributes = filterAttrField(layerId, oattributes);
  for (let i = 0; i < currentLayer.graphics.length; i++) {
    let attr = currentLayer.graphics[i].attributes;
    let currAttr = attributes.filter(ele => {
      return ele.ID == attr.ID;
    });
    let newAttr = Object.assign(attr, currAttr[0].Attr);
    currentLayer.graphics[i].setAttributes(newAttr);
  }
  store.commit("set_attrLoadState", false);
}

/**
 * @author: wyt
 * @description:过滤掉删除的属性（old）
 * @param {*} layerId 图层Id
 * @param {*} arrList
 * @return {*}
 */
function filterAttrField(layerId, arrList) {
  let layerInfo = store.state.allLayerData.filter(item => {
    return item.Id == layerId;
  });
  let newField = JSON.parse(layerInfo[0].field);
  for (let i = 0; i < arrList.length; i++) {
    for (let key in arrList[i].Attr) {
      let index = -1;
      index = newField.findIndex(ele => {
        return ele.FildName == key;
      });
      if (index == -1) {
        delete arrList[i].Attr[key];
      }
    }
  }
  return arrList;
}

/**
 * @author: wyt
 * @description:删除图层字段
 * @export
 * @param {*} fieldName 字段名
 * @param {*} layerList  图层数据
 */
export function handleDeleteFieldInfo(fieldName, layerList) {
  //地图绑定
  var layerId = layerList.Id;
  var currentlayer = map.getLayer("dataLayer_" + layerId);
  if (currentlayer.graphics.length > 0) {
    for (var i = 0; i < currentlayer.graphics.length; i++) {
      let att = currentlayer.graphics[i].attributes;
      if (att.hasOwnProperty(fieldName)) {
        delete att[fieldName];
      }
    }
  }
  //更新全局layerData
  let tmpData = store.state.allLayerData.map(item => {
    if (item.Id == layerId) {
      let field = JSON.parse(item.field);
      let index = field.findIndex(item => {
        return item.fieldName == fieldName;
      });
      field.splice(index, 1);
      item.field = JSON.stringify(field);
    }
    return item;
  });
  store.commit("setAllLayerData", tmpData);
  updateFieldAttribute(store.state.currentEditLayer, "shapefile");
}

/**
 * @author: wyt
 * @description:获取华为服务器的数据
 * @export
 * @param {*} url
 * @return {*}
 */
export function getDataStream(url) {
  let allData = [];
  //let url1 = "https://55555.obs.cn-north-1.myhuaweicloud.com/8/zzdf_929/T1_Shp?AccessKeyId=IICYVOBE48BYTP1XBODN&Expires=1588132603&Signature=8g5uDuQVZeMc1FdoDwhDctYzrH0%3D"
  //let url2 = "https://55555.obs.cn-north-1.myhuaweicloud.com/8/zzdf_929/T1_Attr?AccessKeyId=IICYVOBE48BYTP1XBODN&Expires=1588132603&Signature=SwRfo1rV%2BAgHSHbQszIgbwEqaNs%3D";
  $.ajax({
    url: url,
    type: "get",
    async: false,
    success: function (res) {
      let ts = unzip(res);
      let obsData = JSON.parse(ts);
      allData = obsData;
    },
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      if (
        XMLHttpRequest.status == 404 &&
        XMLHttpRequest.responseText.indexOf("NoSuchKey") > -1
      ) {
        allData = [];
      }
    }
  });
  return allData;
}

//解压转字符串
export function unzip(b64Data) {
  var charData = b64Data.split("").map(function (x) {
    return x.charCodeAt(0);
  });
  var data = pako.inflate(new Uint8Array(charData));
  var array = new Uint16Array(data);
  var strData = "";
  // var chunk = 8 * 1024;
  // var i;
  // for (i = 0; i < array.length / chunk; i++) {
  //     strData += byteToString(array.slice(i * chunk, (i + 1) * chunk));
  // }
  // strData += byteToString(array.slice(i * chunk));
  strData = Utf8ArrayToStr(array);
  return strData;
}
//解决乱码
function byteToString(arr) {
  if (typeof arr === "string") {
    return arr;
  }
  var str = "",
    _arr = arr;
  for (var i = 0; i < _arr.length; i++) {
    var one = _arr[i].toString(2),
      v = one.match(/^1+?(?=0)/);
    if (v && one.length == 8) {
      var bytesLength = v[0].length;
      var store = _arr[i].toString(2).slice(7 - bytesLength);
      for (var st = 1; st < bytesLength; st++) {
        store += _arr[st + i].toString(2).slice(2);
      }
      str += String.fromCharCode(parseInt(store, 2));
      i += bytesLength - 1;
    } else {
      str += String.fromCharCode(_arr[i]);
    }
  }
  return str;
}

function Utf8ArrayToStr(array) {
  // 数据流转化为字符串, 兼容汉字
  var out = "",
    i = 0,
    len = array.length,
    char1,
    char2,
    char3,
    char4;
  while (i < len) {
    char1 = array[i++];
    // 当单个字节时, 最大值 '01111111', 最小值 '00000000' 右移四位 07, 00
    // 当两个字节时, 最大值 '11011111', 最小值 '11000000' 右移四位 13, 12
    // 当三个字节时, 最大值 '11101111', 最小值 '11100000' 右移四位 14, 14
    if (char1 >> 4 <= 7) {
      out += String.fromCharCode(char1);
    } else if (char1 >> 4 == 12 || char1 >> 4 == 13) {
      char2 = array[i++];
      out += String.fromCharCode(((char1 & 0x1f) << 6) | (char2 & 0x3f));
    } else if (char1 >> 4 == 14) {
      char2 = array[i++];
      char3 = array[i++];
      char4 = ((char1 & 0x0f) << 12) | ((char2 & 0x3f) << 6);
      out += String.fromCharCode(char4 | ((char3 & 0x3f) << 0));
    }
  }
  return out;
}
//字符串转数组
export function stringToBytes(str) {
  var ch,
    st,
    re = [];
  for (var i = 0; i < str.length; i++) {
    ch = str.charCodeAt(i); // get char
    st = []; // set up "stack"
    do {
      st.push(ch & 0xff); // push byte to stack
      ch = ch >> 8; // shift value down by 1 byte
    } while (ch);
    // add stack contents to result
    // done because chars have "wrong" endianness
    re = re.concat(st.reverse());
  }
  // return an array of bytes
  return re;
}

/**
 * @author: wyt
 * @description:数据(属性)重新构造（增删改）（old）
 * @export
 * @param {*} oriList
 * @param {*} opList
 * @return {*}
 */
export function restructureData(oriList, opList) {
  let newList = [];
  if (opList != null) {
    for (let i = 0; i < opList.length; i++) {
      let id = opList[i].ID;
      let index = -1;
      if (oriList != null) {
        index = oriList.findIndex(item => {
          return item.ID == id;
        });
        if (index > -1) {
          if (opList[i].State == -999) {
            oriList.splice(index, 1);
          } else {
            for (let key in oriList[index]) {
              if (opList[i][key] != -1 || opList[i][key] != "") {
                oriList[index][key] = opList[i][key];
              }
            }
          }
        } else {
          if (opList[i].State != -999) {
            oriList.push(opList[i]);
          }
        }
        //newList = oriList;
        newList = oriList.filter(item => {
          return item.State != -999;
        });
      } else {
        if (opList[i].State != -999) {
          newList.push(opList[i]);
        }
      }
    }
  } else {
    newList = oriList;
  }
  return newList;
}

/**
 * @author: wyt
 * @description:属性+图形合并
 * @export
 * @param {*} geoList
 * @param {*} attrList
 * @return {*}
 */
export function restructureAttr_Data(geoList, attrList) {
  if (geoList.length > 0) {
    for (let i = 0; i < geoList.length; i++) {
      geoList[i] = Object.assign(geoList[i], attrList[i]);
    }
  }
  return geoList;
}

/**
 * @author: wyt
 * @description:取华为数据（old）
 * @export
 * @param {*} data
 * @param {*} tableData 数据库数据
 * @param {*} type
 * @return {*}
 */
export function getObSData(data, tableData, type) {
  let allData = [];
  if (type && type == 2) {
    //批量取数据
    let temData = {};
    for (let key in data.OBSpath) {
      let shpPath = data.OBSpath[key];
      let oriTable = [];
      if (tableData != null) {
        if (tableData[key]) {
          oriTable = tableData[key];
        }
      }
      let everyTaskData = getDataFromHW(shpPath, oriTable);
      temData[key] = everyTaskData;
    }
    allData = JSON.stringify(temData) == "{}" ? null : temData;
  } else {
    allData = getDataFromHW(data.OBSpath, tableData);
  }
  return allData;
}

/**
 * @author: wyt
 * @description:取华为云数据
 * @param {*} data
 * @param {*} tableData 数据库数据
 * @return {*}
 */
function getDataFromHW(data, tableData) {
  //取华为云数据
  let allData = [];
  //取图形
  let obsData = getDataStream(data.Shp);
  if (data.Attr) {
    //取属性
    let obsAtrr = getDataStream(data.Attr);
    let hData = restructureAttr_Data(obsData, obsAtrr);
    allData = restructureData(hData, tableData); //数据重新合并（融合）
  } else {
    if (tableData == null || tableData.length == 0) {
      allData = obsData;
    } else {
      allData = restructureData(obsData, tableData); //数据重新合并（融合）
    }
  }
  return allData;
}

//重置graphic属性
export function resetGraphicAttr(attr) {
  let delAttr = store.state.editTableAttr;
  let index = -1;
  index = delAttr.findIndex(item => {
    return item.ID == attr.ID;
  });
  if (index > -1) {
    let newAttr = delAttr[index];
    delAttr.splice(index, 1);
    store.commit("set_TableAttr", delAttr);
    return newAttr;
  } else {
    return attr;
  }
}

/**
 * @author: wyt
 * @description:停止绘制
 * @export
 */
export function StopDraw() {
  tb.deactivate();
  tb2.deactivate();
  map.setMapCursor("default");
  isDrawing = false;
  IsToolActive = false;
  EditHistory = []; //用来存储编辑的历史
  EditHistoryIndex = 0;
  lastGraphic = null; //上一个图形，用于撤销操作
  editTool.deactivate();
  TempLightlingLayer.clear();
  store.commit("set_nodeObj", null);
  map.enablePan();
  if (mapSnapingMouseMoveHandle != null) {
    snaplayer.hide();
    SnapingPoint = null;
    mapSnapingMouseMoveHandle.remove();
  }
  mapSnapingMouseMoveHandle = null;
  //DrawState = 0
}

/**
 * @author: wyt
 * @description:停止绘制
 * @param {*} LayerStr 图层数据
 */
function handleSaveBaseLayer(LayerStr, type) {
  let allLayers = store.state.allLayerData;
  let tree5 = store.state.baseTreeData;
  var sortData = sortLayerIndex(allLayers, "影像");
  sortData.push(LayerStr);

  store.commit("setAllLayerData", sortData);
  //树形
  var cNode = {
    id: LayerStr.Id,
    label: LayerStr.LayerAliasName,
    checked: true,
    type: "subBaseLayer",
    targetType: "baseLayer",
    geoType: LayerStr.GeoType,
    editing: false,
    isConcealed: 0,
    dataLoaded: true
  };
  tree5[0].children.unshift(cNode);
  store.commit("setBaseLayerTree", tree5);
  if (type == undefined) {
    //地图上添加相应四维图层
    var layer = new fourEarthLayer(
      LayerStr.SceneNumber,
      LayerStr.Ver,
      LayerStr.GeoType
    );
    layer.id = "baseLayer_" + LayerStr.Id;
    map.addLayer(layer);
  } else if (type == "EMapTile") {
    let o = store.state.eMapData;
    LayerStr.LayerUrl = LayerStr.LayerUrl.replace("{UserId}", LayerStr.Executor).replace("{UnitCode}", o.UnitCode.toString())
    let layer2 = createGSPTile(LayerStr.LayerUrl, "emap");
    layer2.id = "baseLayer_" + LayerStr.Id;
    map.addLayer(layer2);
  } else {
    var layer = createGSPTile(LayerStr.LayerUrl);
    layer.id = "baseLayer_" + LayerStr.Id;
    map.addLayer(layer);
  }

}

/**
 * @author: wyt
 * @description:添加日新图底图
 * @export
 * @param {*} data_id id
 * @param {*} data_version 版本
 * @param {*} type 类型
 */
export function addBaseLayer(data_id, data_version, type, name) {
  let Id = 1;
  let allLayers = store.state.allLayerData;
  let user = store.state.user;
  if (allLayers.length > 0) {
    Id = Math.max.apply(
      Math,
      allLayers.map(item => {
        return item.Id;
      })
    );
  }
  var LayerStr = {
    Id: Id + 1,
    LayerName: "日新图" + name,
    LayerType: "影像",
    GeoType: type,
    LayerUrl: "",
    LayerField: "[]",
    Label: "",
    LayerAliasName: "日新图" + name,
    RenderType: "",
    LayerIndex: 0,
    Symbol: "",
    Opacity: 100,
    OpenState: 0,
    MaxScale: 0,
    MinScale: 0,
    IsChoice: 1,
    Isedit: 1,
    IsPicked: 1,
    GDataId: "",
    ParentId: 0,
    Executor: user.UserId,
    SceneNumber: data_id,
    Ver: data_version,
    IsConcealed: 0
  };
  if (store.state.pageType == "data") {
    handleSaveBaseLayer(LayerStr);
  } else {
    if (store.state.SingleData.MapDocs.Userid != store.state.user.UserId) {
      handleSaveBaseLayer(LayerStr);
    } else {
      addBaseLayerByDoc(LayerStr);
    }
  }
}

/**
 * @author: wyt
 * @description:添加底图（地图页面）
 * @param {*} LayerStr 图层数据
 */
function addBaseLayerByDoc(LayerStr) {
  let params = {
    LayerName: LayerStr.LayerName,
    LayerType: LayerStr.LayerType,
    GeoType: LayerStr.GeoType,
    LayerUrl: LayerStr.LayerUrl,
    LayerAliasName: LayerStr.LayerName,
    RenderType: LayerStr.RenderType,
    Symbol: LayerStr.Symbol,
    Executor: store.state.user.UserId,
    MapDocUnitCode: store.state.SingleData.MapDocs.UnitCode,
    GDataId: "",
    Isedit: LayerStr.Isedit,
    IsChoice: LayerStr.IsChoice,
    IsPicked: LayerStr.IsPicked,
    SceneNumber: LayerStr.SceneNumber,
    Ver: LayerStr.Ver
  };
  addLayer(params).then(res => {

    if (res.data.Status == 1) {
      Message({
        message: "添加成功！",
        type: "success"
      });
      LayerStr.Id = res.data.Data;
      handleSaveBaseLayer(LayerStr);
    } else {
      Message({
        message: res.data.Msg,
        type: "error"
      });
    }
  });
}

/**
 * @author: wyt
 * @description:添加插值图层
 * @export
 * @param {*} data
 * @return {*}
 */
export async function saveInterpolationLayer(data) {
  let Id = 1;
  let layer = "";
  let allLayers = store.state.allLayerData;
  let user = store.state.user;
  if (allLayers.length > 0) {
    Id = Math.max.apply(
      Math,
      allLayers.map(item => {
        return item.Id;
      })
    );
  }
  var LayerStr = {
    Id: Id + 1,
    LayerName: data.layerName,
    LayerType: "矢量",
    GeoType: "面",
    LayerUrl: "",
    LayerField: "[]",
    Label: "",
    LayerAliasName: data.layerName,
    RenderType: data.type,
    LayerIndex: 0,
    Symbol: JSON.stringify(data),
    Opacity: 100,
    OpenState: 0,
    MaxScale: 0,
    MinScale: 0,
    IsChoice: 1,
    Isedit: 1,
    IsPicked: 1,
    GDataId: data.GdataId,
    ParentId: 0,
    Executor: data.UserId,
    IsConcealed: 0,
    TaskDataId: "",
    HeatMap: "",
    IsTileMode: data.IsTileMode
  };
  if (store.state.pageType == "data") {
    layer = handleSaveInterpolation(LayerStr);
  } else {
    if (store.state.SingleData.MapDocs.Userid != store.state.user.UserId) {
      layer = handleSaveInterpolation(LayerStr);
    } else {
      layer = addInterpolationByDoc(LayerStr);
    }
  }
  return layer;
}

/**
 * @author: wyt
 * @description:保存插值图层
 * @export
 * @param {*} LayerStr 图层数据
 * @return {*}
 */
export function handleSaveInterpolation(LayerStr) {
  var allLayers = store.state.allLayerData;
  let esriModule = store.state.esriModule;
  let tree3 = store.state.dataTreeData;
  var sortData = sortLayerIndex(allLayers, "矢量");
  sortData.push(LayerStr);
  store.commit("setAllLayerData", sortData);
  let node = getLegend(
    LayerStr.GeoType,
    LayerStr.RenderType,
    JSON.parse(LayerStr.Symbol),
    1
  );
  var pNode = {
    id: LayerStr.Id,
    label: LayerStr.LayerName,
    layerUnitCode: LayerStr.LayerName,
    labelField: "",
    labelChecked: "", //热力图
    heatMapChecked: "",
    heatMapField: "",
    renderField: "",
    type: "shapefileLayer",
    geoType: LayerStr.GeoType,
    targetType: "dataLayer",
    gDataId: LayerStr.GDataId,
    taskDataId: LayerStr.TaskDataId,
    checked: true,
    expanded: false,
    isEdit: LayerStr.Isedit,
    isSelected: LayerStr.IsChoice,
    IsPicked: LayerStr.IsPicked,
    isConcealed: 0, //图层显示
    dataLoaded: true, //数据是否已加载
    parentId: 0,
    children: node,
    renderType: LayerStr.RenderType
  };
  if (tree3[0].children.length > 0) {
    tree3[0].children.unshift(pNode);
  } else {
    tree3[0].children.push(pNode);
  }
  store.dispatch("setDataTree", tree3);
  //地图上添加相应图层
  var VectorCollection = getVectorCollection(LayerStr.GeoType);
  var dataAttr = {
    isEdit: LayerStr.Isedit,
    isSelected: LayerStr.IsChoice,
    IsPicked: LayerStr.IsPicked,
    taskDataId: LayerStr.TaskDataId,
    GDataId: LayerStr.GDataId,
    isTaskLayer: 0,
    label: LayerStr.LayerName,
    coordinate: map.spatialReference,
    isHasProperty: true
  };
  var VectorDataMap = new esriModule.FeatureLayer(VectorCollection, {
    id: "InterpolationLayer_" + LayerStr.Id,
    dataAttributes: dataAttr
  });
  map.addLayer(VectorDataMap);
  return VectorDataMap;
}

/**
 * @author: wyt
 * @description:添加插值图层（地图页面）
 * @export
 * @param {*} LayerStr 图层数据
 * @return {*}
 */
export async function addInterpolationByDoc(LayerStr) {
  let layer = "";
  let params = {
    LayerName: LayerStr.LayerName,
    LayerType: LayerStr.LayerType,
    GeoType: LayerStr.GeoType,
    LayerUrl: "",
    LayerAliasName: LayerStr.LayerName,
    RenderType: LayerStr.RenderType,
    Symbol: LayerStr.Symbol,
    Executor: store.state.user.UserId,
    MapDocUnitCode: store.state.SingleData.MapDocs.UnitCode,
    GDataId: LayerStr.GDataId,
    Isedit: LayerStr.Isedit,
    IsChoice: LayerStr.IsChoice,
    IsPicked: LayerStr.IsPicked
  };
  let result = await addLayer(params);
  if (result.data.Status == 1) {
    Message({
      message: "添加成功！",
      type: "success"
    });
    LayerStr.Id = result.data.Data;
    layer = handleSaveInterpolation(LayerStr);
  } else {
    Message({
      message: result.data.Msg,
      type: "error"
    });
  }
  return layer;
}

/**
 * @author: wyt
 * @description:初始化片区数据
 * @export
 * @param {*} data
 */
export function loadTaskFeature(data) {
  let esriModule = store.state.esriModule;
  var fdata = data.Data;
  if (fdata != null) {
    var VectorCollection = getVectorCollection("面");
    var dataAttr = {
      taskDataId: data.TaskDataId,
      isTaskLayer: 1,
      coordinate: parseInt(data.Coordinate),
      label: data.Name,
      GDataId: data.Id
    };
    taskLayer = new esriModule.FeatureLayer(VectorCollection, {
      id: "taskExtent",
      dataAttributes: dataAttr
    });
    map.addLayer(taskLayer);
    map.reorderLayer(taskLayer, 1);
    var interval = setInterval(function () {
      if (taskLayer.loaded) {
        applyTaskLayerFeature(data);
        clearInterval(interval);
      }
    }, 1000);
  }
}


/**
 * @author: wyt
 * @description:图层树形结构初始化
 * @export
 * @param {*} val
 */
export function initVectorTree(val) {
  let tree5 = [{
    id: "base",
    targetType: "baseLayer",
    type: "baseLayer",
    label: "底图图层",
    checked: true,
    children: [{
      id: "bId",
      checked: true,
      label: "底图",
      targetType: "baseLayer",
      type: "baseLayerId",
      geoType: "底图",
      editing: false,
      TitleMaxLevel: 0,
    }]
  }];
  let tree3 = [{
    id: "data",
    type: "dataLayer",
    targetType: "dataLayer",
    label: "数据图层",
    checked: true,
    expanded: true,
    children: []
  }];
  if (store.state.pageType == "data") {
    // 如果是在线资源没有数据
    if (store.state.tempPageType === "image" || store.state.tempPageType === "emap") {
      store.dispatch("setDataTree", tree3);
    } else {
      initMyDataTree(val, tree3);
    }

  } else if (store.state.pageType == "map") {
    tree5[0].children[0].checked = val.MapDocs.IsOpenBase;
    let interval = setInterval(function () {
      // 等待地图加载完成
      if (map) {
        let currentLayer = map.getLayer("baseLayer_bId");
        if (currentLayer) {
          if (val.MapDocs.IsOpenBase) {
            currentLayer.show();
          } else {
            currentLayer.hide();
          }
        }
        clearInterval(interval);
      }
    }, 1000);
    initDocTree(val.lis, tree3, tree5);
  }

}

/***projectDatail调用 重置地图taskDataId ***/
export function isHaveTaskDataId(lis) {
  let data = [];
  data = lis.filter(item => {
    return item.isDeleted == false && item.TaskDataId != "";
  });
  if (data.length > 0) {
    resetMyDocTask(data[0].TaskDataId);
  }
}
/**projectDatail调用 渲染信息 */
export function getLayerRenderInfo(layerId) {
  let layerData = store.state.allLayerData.filter(item => {
    return item.Id == layerId;
  });
  let obj = {
    geoType: layerData[0].GeoType,
    renderType: layerData[0].RenderType,
    symbol: JSON.parse(layerData[0].Symbol)
  };
  return obj;
}
/**projectDatail调用 */
export function isIntersectTaskExtent(point) {
  let esriModule = store.state.esriModule;
  var layer = map.getLayer("taskExtent");
  if (layer != undefined && layer != null) {
    point = esriModule.geometryEngine.simplify(point);
    let allgraphics = layer.graphics;
    for (let i = 0; i < allgraphics.length; i++) {
      let item = allgraphics[i];
      let geometry1 = esriModule.geometryEngine.simplify(item.geometry);
      let flag = esriModule.geometryEngine.intersects(point, geometry1);
      if (flag) {
        CurrentEditTaskGraphic = item;
        return true;
        break;
      }
    }
  }
  return false;
}
// function initOnlineSourceTree(){

// }
/**
 * @author: wyt
 * @description:图层树形结构初始化-数据页面
 * @param {*} val
 * @param {*} tree3 数据图层树形节点数据
 */
function initMyDataTree(val, tree3) {

  var layers = val.Gdata_data;
  /****  数据图层树形结构 ***/
  tree3[0].children = [];
  var geoType =
    layers.GDataType == 1 ?
      "point" :
      layers.GDataType == 2 ?
        "polyline" :
        "polygon";
  let node = [];
  let renderField = "";
  let ogeoType =
    layers.GDataType == 1 ? "点" : layers.GDataType == 2 ? "线" : "面";
  var data = store.state.allLayerData.find(ele => ele.Id == layers.Id);
  let layerSym = JSON.parse(data.Symbol);
  let renderType = "SimpleRender";
  if (layerSym.hasOwnProperty("FieldName")) {
    if (layerSym.RenderType == "ClassBreakRender") {
      renderType = "ClassBreakRender";
    } else {
      renderType = "UniqueRender";
    }
  }
  // var test = JSON.parse(data.Symbol)
  let temNode = getLegend(ogeoType, renderType, JSON.parse(data.Symbol), 1);
  if (renderType == "UniqueRender" || renderType == "ClassBreakRender") {
    renderField = JSON.parse(data.Symbol).FieldName;
  }
  node = temNode;

  let cNode = {
    id: layers.Id,
    gDataId: layers.Id,
    gDataName: layers.Name,
    label: layers.Name,
    layerUnitCode: layers.Name,
    labelChecked: "",
    labelField: "",
    heatMapChecked: "",
    heatMapField: "", //热力图
    renderField: renderField,
    expanded: true,
    checked: true,
    type: "shapefileLayer",
    targetType: "dataLayer",
    geoType: ogeoType,
    taskDataId: layers.TaskDataId,
    isEdit: 1,
    isSelected: 1,
    isDeleted: layers.IsDeleted,
    IsPicked: layers.IsPickup ? 1 : 0,
    isConcealed: 0,
    dataLoaded: true, //数据是否已经加载
    parentId: 0,
    children: node
  };
  tree3[0].children.push(cNode);
  //编辑框图层
  let layerOptions = [];
  layerOptions.push({
    value: layers.Id,
    label: layers.Name,
    type: "shapefile",
    taskDataId: layers.TaskDataId,
    labelField: layers.field,
    GDataType: geoType,
    GDataId: layers.Id,
    Id: layers.Id,
    isInDatabase: layers.IsInDatabase,
    taskId: ""
  });
  store.dispatch("setDataTree", tree3);
  if (!layers.IsRelease) {
    //未发布的可以加到下拉框中
    store.commit("setEditLayerOption", layerOptions);
  }
}
//初始化任务的树形节点
export function initTaskTree(val, tree4) {
  tree4[0].children = [];
  if (store.state.pageType == "data") {
    if (val.Gdata_data.TaskDataId != "") {
      if (val.Gdata_task != null) {
        getTaskNode(val.Gdata_data.TaskDataId, val, tree4);
      }
    }
  } else {
    if (val.MapDocs.TaskDataId != "") {
      if (val.gdata != null) {
        getTaskNode(val.MapDocs.TaskDataId, val, tree4);
      }
    }
  }
  store.commit("setTaskTree", tree4);
}
//任务区树形节点构造
export function getTaskNode(taskDataId, val, tree4) {
  var cnode = {
    id: "taskExtent",
    type: "taskLayer",
    targetType: "taskLayer",
    checked: true,
    label: store.state.pageType == "zhongbao" ? "任务范围" : "片区范围",
    taskDataId: taskDataId
  };
  var cnode1 = {
    id: "taskName",
    type: "taskName",
    targetType: "taskLayer",
    checked: false,
    label: store.state.pageType == "zhongbao" ? "任务名称" : "片区名称",
    taskDataId: taskDataId
  };
  tree4[0].children.push(cnode);
  tree4[0].children.push(cnode1);
}

/**
 * @author: wyt
 * @description:图层树形结构初始化-地图页面
 * @export
 * @param {*} layers 图层数据
 * @param {*} tree3 数据图层节点数据
 * @param {*} tree5 底图节点数据
 */
export function initDocTree(layers, tree3, tree5) {
  let ImageData = layers.filter(function (item) {
    return item.LayerType == "影像";
  });
  // LayerIndex排序（大到小）
  ImageData = _.sortBy(ImageData, function (item) {
    return -item.LayerIndex;
  });
  let OtherData = layers.filter(function (item) {
    return item.LayerType != "影像";
  });
  tree3[0].children = [];
  if (layers.length > 0) {
    var VetorData = layers.filter(function (item) {
      return item.LayerType == "矢量" && item.ParentId != 0;
    });
    var ParentIdData = _.groupBy(VetorData, function (item) {
      return item.ParentId;
    });

    /****  数据图层 ***/
    let layerOptions = [];
    for (let i = 0; i < OtherData.length; i++) {
      if (OtherData[i].LayerType == "矢量") {
        if (OtherData[i].ParentId == 0) {
          let nodeInfo = GetLayerTree([OtherData[i]], layerOptions);
          let node = nodeInfo.node;
          layerOptions = nodeInfo.layerOptions;
          tree3[0].children.push(node[0]);
        }
      } else {
        let node = [];
        var classIndex = "group" + OtherData[i].ParentId;
        var groupData = ParentIdData[OtherData[i].ParentId];
        if (groupData == undefined) {
          node = [];
        } else {
          let nodeInfo = GetLayerTree(groupData, layerOptions);
          node = nodeInfo.node;
          layerOptions = nodeInfo.layerOptions;
        }

        var groupNode = {
          id: OtherData[i].Id,
          parentId: OtherData[i].ParentId,
          label: OtherData[i].LayerAliasName,
          layerUnitCode: OtherData[i].LayerName,
          expanded: OtherData[i].OpenState == 1 ? true : false,
          checked: OtherData[i].IsConcealed == 0 ? true : false,
          type: "layerGroup",
          targetType: "dataLayer",
          isConcealed: OtherData[i].IsConcealed,
          children: node
        };
        tree3[0].children.push(groupNode);
      }
    }
    //绑定编辑工具条图层选项
    store.commit("setEditLayerOption", layerOptions);
  }
  /*** 底图图层 ***/
  //影像
  ImageData.forEach(item => {
    tree5[0].children.unshift({
      id: item.Id,
      label: item.LayerAliasName,
      checked: item.IsConcealed == 0 ? true : false,
      type: "subBaseLayer",
      targetType: "baseLayer",
      geoType: item.GeoType,
      editing: false,
      isConcealed: item.IsConcealed,
      dataLoaded: item.IsConcealed == 0 ? true : false,
      LayerUrl: item.LayerUrl,
      TitleMaxLevel: item.TitleMaxLevel
    });
  });
  store.dispatch("setDataTree", tree3);
  store.commit("setBaseLayerTree", tree5);
}

/**
 * @author: wyt
 * @description:构造树形节点
 * @param {*} NoGroupData
 * @param {*} layerOptions  编辑器下拉框-数据
 * @return {*}
 */
function GetLayerTree(NoGroupData, layerOptions) {
  var pNodeArr = [];
  NoGroupData.forEach(item => {
    var RenderField = "";
    var cNode = [];
    if (item.Symbol != "") {
      cNode = getLegend(
        item.GeoType,
        item.RenderType,
        JSON.parse(item.Symbol),
        item.Opacity / 100
      );
      if (
        item.RenderType == "UniqueRender" ||
        item.renderType == "ClassBreakRender"
      ) {
        RenderField = JSON.parse(item.Symbol).FieldName;
      }
    } else {
      cNode = getLegend(
        item.GeoType,
        item.RenderType,
        item.Symbol,
        item.Opacity / 100
      );
    }
    let labelChecked = "";
    let heatMapChecked = "";
    let labelField = "";
    let heatMapField = "";
    if (item.Label.trim() != "") {
      var layerLabel = JSON.parse(item.Label);
      labelChecked = layerLabel.Visiable;
      labelField = layerLabel.LabelField;
    }
    if (item.HeatMap.trim() != "") {
      let heatMap = JSON.parse(item.HeatMap);
      heatMapChecked = heatMap.show;
      heatMapField = heatMap.field;
    }
    var pNode = {
      id: item.Id,
      gDataId: item.GDataId,
      taskDataId: item.TaskDataId,
      label: item.LayerAliasName,
      layerUnitCode: item.LayerName,
      labelChecked: labelChecked,
      labelField: labelField,
      //heatMapData: item.HeatMap, //热力图
      heatMapChecked: heatMapChecked,
      heatMapField: heatMapField,
      renderField: RenderField,
      expanded: item.OpenState == 1 ? true : false,
      checked: item.IsConcealed == 0 ? true : false,
      type: "shapefileLayer",
      targetType: "dataLayer",
      geoType: item.GeoType,
      isEdit: item.Isedit,
      isSelected: item.IsChoice,
      IsPicked: item.IsPicked,
      isDeleted: item.isDeleted,
      isConcealed: item.IsConcealed,
      dataLoaded: item.IsConcealed == 0 ? true : false, //数据是否已经加载
      parentId: item.ParentId,
      children: cNode
    };
    if (item.Isedit == 1 && !item.isDeleted && !item.IsRelease) {
      layerOptions.push({
        value: item.Id,
        label: item.LayerAliasName,
        type: "shapefile",
        taskDataId: item.TaskDataId,
        labelField: item.field,
        GDataType: item.GeoType == "点" ?
          "point" : item.GeoType == "线" ?
            "polyline" : "polygon",
        GDataId: item.GDataId,
        Id: item.Id,
        isInDatabase: item.IsInDatabase,
        taskId: ""
      });
    }
    pNodeArr.push(pNode);
  });
  return {
    node: pNodeArr,
    layerOptions: layerOptions
  };
}
/***---图层初始化---end***/

function _isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );

  return flag ? true : false;
}

/**
 * @author: wyt
 * @description:初始化加载底图
 * @export
 * @param {*} alllayers 所有图层数据
 * @param {*} spatialID 坐标系
 */
export function initBaseMap(alllayers, spatialID) {
  //layerInfo表中的影像  作为底图
  if (alllayers.length > 0) {
    let imgLayers = alllayers.filter(item => {
      return item.LayerType == "影像";
    });
    let layers = _.sortBy(imgLayers, function (item) {
      return -item.LayerIndex;
    });
    for (let i = 0; i < layers.length; i++) {
      loadBaseLayerData(layers[i], spatialID);
    }
  }
}

/**
 * @author: wyt
 * @description:加载底图至地图
 * @param {*} layer 图层数据
 * @param {*} spatialID 坐标系
 */
function loadBaseLayerData(layer, spatialID) {
  let ImgDataMap_i = null;
  let esriModule = store.state.esriModule;
  if (layer.GeoType == "WebTile") {
    if (layer.LayerUrl != "") {
      // ImgDataMap_i = new esriModule.baseObj.GetData(
      //   spatialID,
      //   layer.LayerUrl,
      //   "baseLayer_" + layer.Id,
      //   layerLayerName
      // );
      ImgDataMap_i = new esriModule.baseObj.GetData(
        spatialID,
        layer.LayerUrl,
        "baseLayer_" + layer.Id,
        layer.LayerName
      );
      ImgDataMap_i.id = "baseLayer_" + layer.Id;
    }
  } else if (layer.GeoType == "GSPTile") {
    ImgDataMap_i = createGSPTile(layer.LayerUrl);
    ImgDataMap_i.id = "baseLayer_" + layer.Id;
  } else if (layer.GeoType == "image_tile") {
    ImgDataMap_i = new fourEarthLayer(
      layer.SceneNumber,
      layer.Ver,
      layer.GeoType
    );
    ImgDataMap_i.id = "baseLayer_" + layer.Id;
  } else if (layer.GeoType == "ArcGISDynamic") {
    if (layer.LayerUrl != "") {
      ImgDataMap_i = new esriModule.ArcGISDynamicMapServiceLayer(
        layer.LayerUrl, {
        id: "baseLayer_" + layer.Id,
        name: layer.LayerName
      }
      );
    }
  } else if (layer.GeoType == "ArcGISTile") {
    if (layer.LayerUrl != "") {
      ImgDataMap_i = new esriModule.ArcGISTiledMapServiceLayer(layer.LayerUrl, {
        id: "baseLayer_" + layer.Id,
        name: layer.LayerName
      });
    }
  } else if (layer.GeoType == "ArcGISFeatureLayer") {
    if (layer.LayerUrl != "") {
      ImgDataMap_i = new esriModule.FeatureLayer(layer.LayerUrl, {
        id: "baseLayer_" + layer.Id,
        name: layer.LayerName
      });
    }
  }
  if (!ImgDataMap_i)
    return
  map.addLayer(ImgDataMap_i);
  if (layer.IsConcealed == 1) {
    ImgDataMap_i.hide();
  }
}

/**
 * @author: wyt
 * @description:初始化加载矢量图层
 * @export
 * @param {*} layers 图层数据
 */
export async function initVetorLayer(layers) {

  //选择图层canvas
  createCanvas("selected", "scale");
  //拾取canvas
  createCanvas("highlight", "scale");

  if (layers.length > 0) {
    let allSortData = _.sortBy(layers, function (item) {
      return -item.LayerIndex;
    });
    var VetorData = allSortData.filter(function (item) {
      return item.LayerType == "矢量" && item.ParentId != 0;
    });
    var ParentIdData = _.groupBy(VetorData, function (item) {
      return item.ParentId;
    });
    let allvector = allSortData.filter(ele => {
      return ele.LayerType == "矢量";
    });
    if (allvector.length == 0) {
      store.commit("changeDataLoadState", false);
    } else {
      if (!commonB.isAllLayerClose()) {
        startDrawText();
      }
    }
    let flag = false;
    for (var i = 0; i < allSortData.length; i++) {
      flag = i == allSortData.length - 1 ? true : false;
      if (allSortData[i].LayerType == "矢量" && allSortData[i].ParentId == 0) {
        handleLayerOperation(allSortData[i], flag, "shapefile", null);
      } else if (allSortData[i].LayerType == "图层组") {
        var parentId = allSortData[i].ParentId;
        var groupData = ParentIdData[parentId];
        var SortGroupData = [];
        if (groupData != undefined) {
          SortGroupData = _.sortBy(groupData, function (item) {
            return -item.LayerIndex;
          });
          if (SortGroupData.length > 0) {
            for (var j = 0; j < SortGroupData.length; j++) {
              handleLayerOperation(
                SortGroupData[j],
                flag,
                "group",
                allSortData[i]
              );
            }
          }
        }
      }
      if (flag) {
        store.commit("changeDataLoadState", false);
      }
    }
  } else {
    store.commit("changeDataLoadState", false);
  }
}

/**
 * @author: wyt
 * @description:图层数据加载操作
 * @param {*} layerData 图层数据
 * @param {*} flag 标志
 * @param {*} type 类型
 * @param {*} groupData
 */
function handleLayerOperation(layerData, flag, type, groupData) {
  let esriModule = store.state.esriModule;
  let isHasProperty = false;
  if (layerData.RenderType == "Interpolation") {
    let VectorCollection = getVectorCollection(layerData.GeoType);
    if (!layerData.isDeleted) {
      let InterpolationLayer = new esriModule.FeatureLayer(VectorCollection, {
        id: "InterpolationLayer_" + layerData.Id
      });
      map.addLayer(InterpolationLayer);
      store.commit("changeDataLoadState", false);
    }
  } else {
    //判断是否要取属性
    if (layerData.Symbol == "") {
      isHasProperty = false;
    } else {
      let layerSym = JSON.parse(layerData.Symbol);
      if (layerSym.hasOwnProperty("FieldName")) {
        isHasProperty = true;
      } else {
        isHasProperty = false;
      }
    }
    layerData["isHasProperty"] = isHasProperty;
    if (!layerData.isDeleted) {

      //热力图层
      setHeatMapByLayer(type, layerData, groupData);

      //加载矢量数据
      loadGeoFeatureByLayer(layerData);
      if (flag) {
        store.commit("changeDataLoadState", false);
      }
    } else {
      store.commit("changeDataLoadState", false);
    }
  }
}

/**
 * @author: wyt
 * @description:设置热力图
 * @param {*} type
 * @param {*} layerData 图层数据
 * @param {*} groupData 图层组数据
 */
function setHeatMapByLayer(type, layerData, groupData) {
  if (layerData.HeatMap.trim() != "" && layerData.GeoType == "点") {
    let heatLayer = map.getLayer("heatLayer_" + layerData.Id);
    let heatData = JSON.parse(layerData.HeatMap);
    if (heatLayer == undefined) {
      heatLayer = heatMap.heatmapLayer(heatData.radius, [], heatData.field);
      heatLayer.id = "heatLayer_" + layerData.Id;
      map.addLayer(heatLayer);
    }
    if (heatData.show) {
      if (layerData.IsConcealed == 1) {
        heatLayer.hide();
      } else {
        if (type == "group") {
          if (groupData.IsConcealed == 1) {
            heatLayer.hide();
          } else {
            heatLayer.show();
          }
        }
      }
    } else {
      heatLayer.hide();
    }
  }
}

/**
 * @author: wyt
 * @description:项目页面--任务区框选完成事件
 * @export
 * @param {*} evt
 */
export function addTaskSelect(evt) {
  store.state.IsBatchSelectTaskGeo = 0;
  let taskLayer = map.getLayer("taskExtent");
  let allgraphics = taskLayer.graphics;
  let taskIdArray = [];
  allgraphics.forEach(gra => {
    var geometryType = gra.geometry.type;
    let isIntersect = false;
    try {
      isIntersect = store.state.esriModule.geometryEngine.intersects(
        gra.geometry,
        evt.geometry
      );
    } catch (e) { }
    if (isIntersect) {
      taskIdArray.push(gra.attributes.Taskid);
    }
  });
  store.dispatch("setTaskChecked", taskIdArray);
}

//编辑参数用到的
export function getState() {
  let state = 1;
  if (store.state.pageType == "public") {
    state = 0;
  }
  return state;
}
export function getmapDocId() {
  let mapDocId = -1;
  if (store.state.pageType == "map" || store.state.pageType == "project") {
    mapDocId = store.state.SingleData.MapDocs.ID;
  }
  return mapDocId;
}
export function getrowID() {
  let crowId = "";
  if (store.state.crowID != "") {
    crowId = store.state.crowID;
  }
  return crowId;
}
// ksl
export function getType() {
  return getTypeTemp();
}
// wyt
export function getPageType() {
  return getTypeTemp();
}
// 合并两个
export function getTypeTemp() {
  let type = 0;
  if (store.state.pageType == "data") {
    type = 0;
  } else if (store.state.pageType == "image") {
    type = 0;
  } else if (store.state.pageType == "map") {
    type = 1;
  } else if (store.state.pageType == "zhongbao") {
    type = 2;
  } else if (store.state.pageType == "project") {
    //项目
    type = 3;
  } else {
    //主题地图
    type = 4;
  }
  return type;

}
export function isPublicMap() {
  let res = -1;
  if (store.state.openMapId != null) {
    res = store.state.openMapId;
  }
  return res;
}
export function getError(error) {
  if (error.message == "Network Error") {
    Message({
      message: "网络错误，当前操作无法保存，请检查网络！",
      type: "error"
    });
  }
}

/**
 * @author: wyt
 * @description:设置标注
 * @export
 * @param {*} layerId 图层Id
 * @param {*} attr 属性
 * @param {*} Id 要素Id
 * @param {*} opertation  操作类型
 */
export function setGraphicLabel(layerId, attr, Id, opertation) {
  let esriModule = store.state.esriModule;
  let currentLayerLabel, currentLayer;
  let tempLayerId = layerId;
  let labelField = "";
  if (layerId == "taskExtent") {
    currentLayerLabel = taskTextGraphicLayer;
    labelField = "Name";
    currentLayer = map.getLayer(layerName);
  } else {
    tempLayerId = layerId.substring(10);
    currentLayerLabel = map.getLayer(tempLayerId + "_Label");
    var vectorLayerData = getVetorLayerNode(store.state.dataTreeData);
    var currentLayerData = vectorLayerData.filter(item => {
      return item.id == tempLayerId;
    });
    labelField = currentLayerData[0].labelField;
    currentLayer = map.getLayer("dataLayer_" + tempLayerId);
  }
  if (opertation == "add") {
    setLabel(tempLayerId, attr, Id);
  } else if (opertation == "delete") {
    deleteLabel(currentLayerLabel, Id);
  } else {
    //update
    let targetGraphic = currentLayer.graphics.find(ele => {
      return ele.attributes.ID == Id;
    });
    if (currentLayerLabel != undefined) {
      if (currentLayerLabel.graphics.length > 0) {
        deleteLabel(currentLayerLabel, Id);
        addLabel(
          attr[labelField],
          currentLayerLabel,
          currentLayer,
          targetGraphic,
          Id
        );
        currentLayerLabel.redraw();
      }
    }
  }
}



/**
 * @author: wyt
 * @description:重新加载数据
 * @export
 * @param {*} layerId 图层Id
 */
export async function reloadData(layerId) {

  var layerInfo = store.state.allLayerData.find(val => val.Id === layerId);
  if (!isShowLayer(layerId, layerInfo)) {
    return;
  }
  store.dispatch("setStopLoading", false);
  allTotalLayerHasPosted = 0;
  allTotalLayerPost = 0;
  startDrawText();
  clearArcLineArr(layerId, null, "layer");

  store.commit("changeDataLoadState", true);
  var vectorData = getVetorLayerNode(store.state.dataTreeData);
  var vectorLayerData = vectorData.find(ele => ele.id == layerId);
  var canvasCtn = document.getElementsByClassName("gispaiLayer");
  for (var i = 0; i < canvasCtn.length; i++) {
    var ids = canvasCtn[i].id.split("_");
    if (ids[0] == layerId) {
      canvasCtn[i].remove();
      i = i - 1;
    }
  }
  //清除此图层所有缓存
  TileCanvasCache = TileCanvasCache.filter(ele => ele.layerId != layerId);
  ChangedCanvasCache = ChangedCanvasCache.filter(ele => ele.layerId != layerId);
  TileData = TileData.filter(ele => ele.layerId != layerId);
  AllChangedData = AllChangedData.filter(ele => ele.layerId != layerId);
  labelData = labelData.filter(ele => ele.layerId != layerId);

  var firstTimestamp = Date.now();
  localStorage.removeItem('timestamp' + layerId)

  if (!layerInfo.IsTileMode) {
    getAllDataFromServer(layerId, "reload");
  } else {
    //加载数据库数据
    getChangedData(layerId, "reload", vectorLayerData).then(res => {
      //加载行列切片数据
      addTileData(res, "reload", firstTimestamp);
    });
  }
  store.commit("changeDataLoadState", false);
}
/**
 * @author: wyt
 * @description:重新加载插值图
 * @export
 * @param {*} layerId 图层Id
 */
export function reloadInterpolationData(layerId) {
  let esriModule = store.state.esriModule;
  let Interpolation = new InterpolationAnalyst();
  let data = store.state.allLayerData.filter(item => {
    return item.Id == layerId;
  });
  var interpoLayer = map.getLayer("InterpolationLayer_" + layerId);
  if (interpoLayer) {
    interpoLayer.clear();
    Interpolation.init(JSON.parse(data[0].Symbol), interpoLayer);
  } else {
    //地图上添加相应图层
    var VectorCollection = getVectorCollection(data[0].GeoType);
    var VectorDataMap = new esriModule.FeatureLayer(VectorCollection, {
      id: "InterpolationLayer_" + layerId
    });
    map.addLayer(VectorDataMap);
    Interpolation.init(JSON.parse(data[0].Symbol), interpoLayer);
  }
}
export function isAndroid() {
  if (currentUrl == null) {
    return false;
  }
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
  if (isAndroid) {
    return true;
  } else {
    return false;
  }
}
export async function GetWebChatLocationParamwx() {
  if (currentUrl != null) {
    if (currentUrl == window.location.href) {
      return;
    } else {
      if (isAndroid()) {
        currentUrl = window.location.href;
      } else {
        return;
      }
    }
  } else {
    currentUrl = window.location.href;
  }
  let res = await GetWebChatLocationParam({
    url: currentUrl
  });

  
}

/** 图层勾选显隐 start**/

/**
 * @author: wyt
 * @description:底图图层勾选触发事件
 * @export
 * @param {*} currentObj 勾选的节点
 */
export async function setBaseLayerVisible(currentObj, IsUpdateToDB) {
  if (currentObj.checked) {
    //全选
    if (currentObj.children && currentObj.children.length > 0) {
      for (var i = 0; i < currentObj.children.length; i++) {
        if (currentObj.children[i].checked) {
          var LayerId = currentObj.children[i].id;
          let layer = map.getLayer("baseLayer_" + LayerId);
          if (layer != undefined) {
            layer.show();
          }
        }
      }
    } else {
      if (currentObj.id == "bId") {
        setBaseVisible(currentObj, IsUpdateToDB);
      } else {
        setLayerVisible(currentObj, "baseLayer", "layerGroup", IsUpdateToDB);
      }
      judgeLayerChecked(currentObj.checked, "baseLayer", currentObj);
    }
  } else {
    if (currentObj.children && currentObj.children.length > 0) {
      for (var i = 0; i < currentObj.children.length; i++) {
        var layerId = currentObj.children[i].id;
        let layer = map.getLayer("baseLayer_" + layerId);
        if (layer != undefined) {
          layer.hide();
        }
      }
    } else {
      if (currentObj.id == "bId") {
        setBaseVisible(currentObj, IsUpdateToDB);
      } else {
        setLayerVisible(currentObj, "baseLayer", "layerGroup", IsUpdateToDB);
      }
      judgeLayerChecked(currentObj.checked, "baseLayer", currentObj);
    }
  }
}

/**
 * @author: wyt
 * @description:数据图层勾选触发事件
 * @export
 * @param {*} currentObj 勾选的节点
 */
export function setDataLayerVisible(currentObj, IsUpdateToDB) {
  if (currentObj.type == "dataLayer") {
    setAllDataLayerVisible(currentObj, IsUpdateToDB);
  } else if (currentObj.type == "layerGroup") {
    setLayerVisible(currentObj, "dataLayer", "layerGroup", IsUpdateToDB);
  } else {
    let flag = false;
    //shapefileLayer
    if (currentObj.isDeleted) {
      return;
    }
    if (currentObj.renderType == "Interpolation") {
      flag = true;
    }
    if (getPageType() != 4 && !flag) {
      setLayerVisible(currentObj, "dataLayer", "shapefile", IsUpdateToDB);
    }
  }
}

/**
 * @author: wyt
 * @description:最外层节点（即数据图层）勾选触发事件
 * @param {*} currentObj 勾选的节点
 */
function setAllDataLayerVisible(currentObj, IsUpdateToDB) {
  let tree3 = store.state.dataTreeData;
  if (currentObj.checked) {
    for (var i = 0; i < currentObj.children.length; i++) {
      var className = currentObj.children[i].type;
      if (className == "layerGroup") {
        // setGroupVisible(currentObj.children[i]);
        setLayerVisible(currentObj.children[i], "dataLayer", "layerGroup", IsUpdateToDB);
      } else {
        judgeLayerChecked(
          currentObj.children[i].checked,
          "dataLayer",
          currentObj.children[i]
        );
      }
    }
    //高亮图层显隐
    isShowSelectedCanvas(true, "dataLayer");
  } else {
    let obj = setDataNodeChecked(tree3, "checked");
    let checkedNodes = obj.checkedNodes;
    var filterNodes = checkedNodes.filter(item => {
      return item.type == "shapefileLayer";
    });
    for (var i = 0; i < filterNodes.length; i++) {
      var layerId = filterNodes[i].id;
      if (filterNodes[i].renderType == "Interpolation") {
        var interLayer = map.getLayer("InterpolationLayer_" + layerId);
        if (interLayer != undefined) {
          interLayer.hide();
        }
      } else {
        //切片图层
        var ele = document.getElementsByClassName("gispaiLayer_" + layerId);
        if (ele.length > 0) {
          ele[0].style.display = "none";
        }
        //标注图层
        var labelEle = document.getElementById(
          "gispaiLayer_labelLayer_" + layerId
        );
        if (labelEle) {
          labelEle.style.display = "none";
        }
        //临时图层显隐
        showOrHideLayer(false, layerId);
      }
    }
    //高亮图层显隐
    isShowSelectedCanvas(false, "dataLayer");
    //拾取图层
    if (lastPickedData.length > 0) {
      let pickedele = document.querySelector(".gispaiLayer_highlight");
      if (pickedele) {
        pickedele.style.display = "none";
      }
    }
  }
}

/**
 * @author: wyt
 * @description:图层组节点勾选触发事件
 * @param {*} currentObj 勾选的节点
 */
function setGroupVisible(currentObj) {
  let tree3 = store.state.dataTreeData;
  if (currentObj.checked) {
    if (tree3[0].checked) {
      for (var i = 0; i < currentObj.children.length; i++) {
        if (currentObj.children[i].checked) {
          var layerId = currentObj.children[i].id;
          //插值图
          if (currentObj.renderType == "Interpolation") {
            var interLayer = map.getLayer("InterpolationLayer_" + layerId);
            if (interLayer != undefined) {
              interLayer.show();
            }
          } else {
            //切片图层
            var ele = document.getElementsByClassName("gispaiLayer_" + layerId);
            if (ele.length > 0) {
              ele[0].style.display = "block";
            }
            //标注图层
            var labelEle = document.getElementById(
              "gispaiLayer_labelLayer_" + layerId
            );
            if (labelEle) {
              labelEle.style.display = "block";
            }

            //临时图层显隐
            showOrHideLayer(true, layerId);
            //热力图
            var heatLayer = map.getLayer("heatLayer_" + layerId);
            if (currentObj.children[i].heatMapChecked == true) {
              if (heatLayer != undefined) {
                heatLayer.show();
              }
            }
            //拾取图层
            if (lastPickedData.length > 0) {
              let pickedele = document.querySelector(".gispaiLayer_highlight");
              if (pickedele && lastPickedData[0].layerId == layerId) {
                pickedele.style.display = "block";
              }
            }
          }
        }
      }
    }
  } else {
    for (var i = 0; i < currentObj.children.length; i++) {
      var layerId = currentObj.children[i].id;
      if (currentObj.renderType == "Interpolation") {
        var interLayer = map.getLayer("InterpolationLayer_" + layerId);
        if (interLayer != undefined) {
          interLayer.hide();
        }
      } else {
        //切片图层
        var ele = document.getElementsByClassName("gispaiLayer_" + layerId);
        if (ele.length > 0) {
          ele[0].style.display = "none";
        }
        //标注图层
        var labelEle = document.getElementById(
          "gispaiLayer_labelLayer_" + layerId
        );
        if (labelEle) {
          labelEle.style.display = "none";
        }
        //临时图层显隐
        showOrHideLayer(false, layerId);
        //热力图
        var heatLayer = map.getLayer("heatLayer_" + layerId);
        if (heatLayer != undefined) {
          heatLayer.hide();
        }
        //拾取图层
        if (lastPickedData.length > 0) {
          let pickedele = document.querySelector(".gispaiLayer_highlight");
          if (pickedele && lastPickedData[0].layerId == layerId) {
            pickedele.style.display = "none";
          }
        }
      }
    }
  }
}

/**
 * @author: wyt
 * @description:最内层节点触发事件
 * @param {*} checked 是否勾选
 * @param {*} type 类型
 * @param {*} currentObj 当前节点
 */
function judgeLayerChecked(checked, type, currentObj) {
  let tree3 = store.state.dataTreeData;
  let tree5 = store.state.baseTreeData;
  var flag = checked;
  if (flag) {
    switch (type) {
      case "dataLayer":
        if (tree3[0].checked) {
          let isflag = false;
          let parentId = currentObj.parentId;
          if (parentId == 0) {
            isflag = currentObj.checked;
          } else {
            let cparent = tree3[0].children.find(ele => {
              return ele.parentId == parentId;
            });
            if (cparent.checked) {
              isflag = true;
            } else {
              isflag = false;
            }
          }
          if (currentObj.renderType == "Interpolation") {
            var interLayer = map.getLayer(
              "InterpolationLayer_" + currentObj.id
            );
            if (interLayer && isflag) {
              interLayer.show();
            }
          } else {
            //是否在比例尺范围内
            var isScaleShow = isInScale(currentObj.id);
            if (isflag && isScaleShow) {
              isflag = true;
            } else {
              isflag = false;
            }
            //切片图层
            var ele = document.getElementsByClassName(
              "gispaiLayer_" + currentObj.id
            );
            if (ele.length > 0) {
              if (isflag) {
                ele[0].style.display = "block";
              } else {
                ele[0].style.display = "none";
              }
            }
            //标注图层
            var labelEle = document.getElementById(
              "gispaiLayer_labelLayer_" + currentObj.id
            );
            if (labelEle) {
              var layerInfo = store.state.allLayerData.find(
                ele => ele.Id == currentObj.id
              );
              if (layerInfo.Label.trim() != "") {
                var label = JSON.parse(layerInfo.Label);
                if (isflag) {
                  if (label.Visiable) {
                    labelEle.style.display = "block";
                  } else {
                    labelEle.style.display = "none";
                  }
                } else {
                  labelEle.style.display = "none";
                }
              } else {
                labelEle.style.display = "block";
              }
            }
            //临时图层显隐
            showOrHideLayer(isflag, currentObj.id);
            //选择图层
            //热力图
            var heatMapChecked = currentObj.heatMapChecked;
            if (heatMapChecked == true && isflag) {
              if (heatLayer != undefined) {
                heatLayer.show();
              }
            }
            //拾取图层
            if (lastPickedData.length > 0) {
              let pickedele = document.querySelector(".gispaiLayer_highlight");
              if (pickedele && lastPickedData[0].layerId == currentObj.id) {
                pickedele.style.display = isflag ? "block" : "none";
              }
            }
          }
          //判断是否要加载数据
          //插值图
          if (currentObj.renderType == "Interpolation") {
            if (!currentObj.dataLoaded) {
              reloadInterpolationData(currentObj.id);
              currentObj.dataLoaded = true;
            }
          }
        }
        break;
      case "baseLayer":
        if (tree5[0].checked) {
          var currentLayer = map.getLayer("baseLayer_" + currentObj.id);
          if (currentLayer != undefined) {
            currentLayer.show();
          }
        }
        break;
    }
  } else {
    switch (type) {
      case "baseLayer":
        var currentLayer = map.getLayer("baseLayer_" + currentObj.id);
        if (currentLayer != undefined) {
          currentLayer.hide();
        }
        break;
      case "dataLayer":
        if (currentObj.renderType == "Interpolation") {
          var interLayer = map.getLayer("InterpolationLayer_" + currentObj.id);
          if (interLayer != undefined) {
            interLayer.hide();
          }
        } else {
          var ele = document.getElementsByClassName(
            "gispaiLayer_" + currentObj.id
          );
          if (ele.length > 0) {
            ele[0].style.display = "none";
          }
          //标注图层
          var labelEle = document.getElementById(
            "gispaiLayer_labelLayer_" + currentObj.id
          );
          if (labelEle) {
            labelEle.style.display = "none";
          }
          //临时图层显隐
          showOrHideLayer(false, currentObj.id);
          var heatLayer = map.getLayer("heatLayer_" + currentObj.id);
          if (heatLayer != undefined) {
            heatLayer.hide();
          }
          //拾取图层
          if (lastPickedData.length > 0) {
            let pickedele = document.querySelector(".gispaiLayer_highlight");
            if (pickedele && lastPickedData[0].layerId == currentObj.id) {
              pickedele.style.display = "none";
            }
          }
        }
        break;
    }
  }
}

/**
 * @author: wyt
 * @description:判断图层是否显隐
 * @export
 * @param {*} layerId 图层Id
 * @return {*}
 */
export function initLayerVisible(layerId) {
  let tree3 = store.state.dataTreeData;
  let allLayerData = store.state.allLayerData;
  let curLayerData = allLayerData.filter(ele => {
    return ele.Id == layerId;
  });
  let parentId = curLayerData[0].ParentId;
  let fchecked = tree3[0].checked;
  let flag = false;
  if (parentId == 0) {
    //1级
    flag = fchecked;
  } else {
    //套在图层组中，2级
    let cparent = tree3[0].children.find(ele => {
      return ele.parentId == parentId && ele.type == "layerGroup";
    });
    if (fchecked) {
      if (cparent.checked) {
        flag = curLayerData[0].IsConcealed == 0 ? true : false;
      } else {
        flag = false;
      }
    } else {
      flag = false;
    }
  }
  return flag;
}

/**
 * @author: wyt
 * @description:更新图层显隐
 * @export
 * @param {*} currentObj 当前节点
 * @param {*} ptype
 * @param {*} type 类型
 * @param {*} IsUpdateToDB 是否更新到数据库
 * @return {*}
 */
export function setLayerVisible(currentObj, ptype, type, IsUpdateToDB) {
  let layerId = currentObj.id;
  let userId = store.state.user.UserId;
  if (getPageType() != 0) {
    let mapDocId = -1;
    let visible = currentObj.checked ? 0 : 1;
    if (getPageType() == 1 || getPageType() == 3) {
      mapDocId = store.state.SingleData.MapDocs.ID;
      if (store.state.SingleData.MapDocs.Userid !== userId) {
        setVisible(currentObj, ptype, type);
        return false;
      }
    } else if (getPageType() == 4) {
      mapDocId = store.state.openMapData.MapDocs.ID;
      if (store.state.openMapData.MapDocs.Userid !== userId) {
        setVisible(currentObj, ptype, type);
        return false;
      }
    } else {
      mapDocId = store.state.zbAllData.MapDocs.ID;
      if (store.state.zbAllData.MapDocs.Userid !== userId) {
        setVisible(currentObj, ptype, type);
        return false;
      }
    }

    if (IsUpdateToDB) {
      let params = {
        MapDocId: mapDocId,
        UserId: store.state.user.UserId,
        LayerInfoId: layerId,
        IsConcealed: visible
      };
      updateLayerVisible(params).then(res => {
        if (res.data.Status == 1) {
          let data = store.state.allLayerData;
          let index = data.findIndex(ele => {
            return ele.Id == layerId;
          });
          data[index].IsConcealed = visible;
          store.commit("setAllLayerData", data);
          let checkedData = data.filter(ele => {
            return ele.Id == currentObj.id;
          });
          store.commit("set_baseCheckedData", checkedData);
          //高亮图层显隐
          if (ptype == "dataLayer") {
            if (type == "layerGroup") {
              setGroupVisible(currentObj);
            } else {
              judgeLayerChecked(currentObj.checked, "dataLayer", currentObj);
            }
            isShowSelectedCanvas(currentObj.checked, type);
          }
        } else {
          Message({
            message: res.data.Msg,
            type: "error"
          });
        }
      });

    } else {
      setVisible(currentObj, ptype, type);

    }

  } else {
    setVisible(currentObj, ptype, type);
  }
}

/**
 * @author: wyt
 * @description:显隐操作
 * @param {*} currentObj 当前节点
 * @param {*} ptype
 * @param {*} type 类型
 */
function setVisible(currentObj, ptype, type) {
  let layerId = currentObj.id;
  let visible = currentObj.checked ? 0 : 1;
  let data = store.state.allLayerData;
  let index = data.findIndex(ele => {
    return ele.Id == layerId;
  });
  data[index].IsConcealed = visible;
  store.commit("setAllLayerData", data);
  let checkedData = data.filter(ele => {
    return ele.Id == currentObj.id;
  });
  store.commit("set_baseCheckedData", checkedData);
  //高亮图层显隐
  if (ptype == "dataLayer") {
    if (type == "layerGroup") {
      setGroupVisible(currentObj);
    } else {
      judgeLayerChecked(currentObj.checked, "dataLayer", currentObj);
    }
    isShowSelectedCanvas(currentObj.checked, type);
  }
}

/**
 * @author: wyt
 * @description:底图显隐操作
 * @export
 * @param {*} currentObj 当前节点
 * @return {*}
 */
// FIXME 请求后端显隐图层
export function setBaseVisible(currentObj, IsUpdateToDB) {
  let pageType = getPageType();
  if (pageType == 1 || pageType == 2 || pageType == 3) {
    let mapDocId = -1;
    let visible = currentObj.checked;
    let layerId = currentObj.id;
    let userId = store.state.user.UserId;
    if (getPageType() == 1 || getPageType() == 3) {
      mapDocId = store.state.SingleData.MapDocs.ID;
      if (store.state.SingleData.MapDocs.Userid !== userId) {
        return false;
      }
    } else if (getPageType() == 4) {
      mapDocId = store.state.openMapData.MapDocs.ID;
      if (store.state.openMapData.MapDocs.Userid !== userId) {
        return false;
      }
    } else {
      mapDocId = store.state.zbAllData.MapDocs.ID;
      if (store.state.zbAllData.MapDocs.Userid !== userId) {
        return false;
      }
    }
    let params = {
      MapDocId: mapDocId,
      UserId: store.state.user.UserId,
      IsOpenBase: visible
    };
    if (IsUpdateToDB) {
      updateBaseLayerVisible(params).then(res => {
        if (res.data.Status == 1) { } else {

        }
      });
    }

  }
}
/** 图层勾选显隐 end**/

/**
 * @author: wyt
 * @description:设置任务区为可编辑
 * @export
 */
export function setTaskEditing() {
  let esriModule = store.state.esriModule;
  if (oldCurrentEditTaskGraphic) {
    let Symbol = getDefaultSymbol("面", "task");
    oldCurrentEditTaskGraphic.setSymbol(Symbol);
  }
  oldCurrentEditTaskGraphic = CurrentEditTaskGraphic;
  EditTaskID = CurrentEditTaskGraphic.attributes.Taskid;
  EditTaskExtent = CurrentEditTaskGraphic.geometry;
  let editorSymbol = new esriModule.SimpleFillSymbol(
    esriModule.SimpleFillSymbol.STYLE_SOLID,
    new esriModule.SimpleLineSymbol(
      esriModule.SimpleLineSymbol.STYLE_SOLID,
      new esriModule.Color([255, 0, 0, 1]),
      2
    ),
    new esriModule.Color([0, 0, 0, 0])
  );
  CurrentEditTaskGraphic.setSymbol(editorSymbol);
}

/**
 * @author: wyt
 * @description:获取属性字段
 * @export
 * @param {*} layer 图层
 * @param {*} attr 属性
 * @return {*}
 */
export function getAttributefield(layer, attr) {
  let datas = store.state.allLayerData;
  let id = layer.id.substring(10);
  let filedlayer = datas.find(x => x.Id == id);
  let field = JSON.parse(filedlayer.field);
  field.forEach(element => {
    if (element.FildName != "ID") {
      if (
        element.FildType == "Short Integer" ||
        element.FildType == "Long Integer" ||
        element.FildType == "Double" ||
        element.FildType == "Float"
      ) {
        if (attr[element.FildName] != undefined) {
          attr[element.FildName] = attr[element.FildName];
        } else {
          attr[element.FildName] = 0;
          if (element.DefaultValue != "") {
            attr[element.FildName] = element.DefaultValue;
          }
        }
      } else {
        if (attr[element.FildName] != undefined) {
          attr[element.FildName] = attr[element.FildName];
        } else {
          attr[element.FildName] = "";
          if (element.DefaultValue != "") {
            attr[element.FildName] = element.DefaultValue;
          }
        }
      }
    }
  });
  if (layer.dataAttributes.taskDataId != "") {
    attr.TaskId = EditTaskID;
  }
  return attr;
}

/**
 * @author: wyt
 * @description:右键属性-字段tab，属性表字段拖拽排序
 * @export
 * @param {*} fieldData 字段数据
 * @param {*} id
 * @param {*} GDataId
 */
export function updateGDataField(fieldData, id, GDataId) {
  var tmpData = store.state.allLayerData.filter(item => {
    return item.Id == id;
  });
  let user = store.state.user;
  if (tmpData.length > 0) {
    if (tmpData[0].Executor != user.UserId) {
      handleUpdateField(fieldData, id);
    } else {
      updateField(fieldData, id, GDataId);
    }
  }
}

/**
 * @author: wyt
 * @description:更新排序字段
 * @param {*} fieldList 字段信息
 * @param {*} id Id
 * @param {*} GDataId
 */
function updateField(fieldList, id, GDataId) {
  let params = {
    userid: store.state.user.UserId,
    field: JSON.stringify(fieldList),
    gDataId: GDataId
  };
  updateFieldOrder(params).then(res => {
    if (res.data.Status == 1) {
      handleUpdateField(fieldList, id);
    } else {
      Message({
        type: "error",
        message: res.data.Msg
      });
    }
  });
}
/**
 * @author: wyt
 * @description:更新字段后操作
 * @param {*} fieldList 字段信息
 * @param {*} id Id
 */
function handleUpdateField(fieldList, id) {
  var tmpData = store.state.allLayerData.map(item => {
    if (item.Id == id) {
      item.field = JSON.stringify(fieldList);
    }
    return item;
  });
  store.commit("setAllLayerData", tmpData);
}

/**
 * @author: wyt
 * @description:将对象的属性按字母顺序排序
 * @export
 * @param {*} obj
 * @return {*}
 */
export function objKeySort(obj) {
  var newkey = Object.keys(obj).sort();
  var newObj = {};
  for (var i = 0; i < newkey.length; i++) {
    //遍历newkey数组
    newObj[newkey[i]] = obj[newkey[i]]; //向新创建的对象中按照排好的顺序依次增加键值对
  }
  return newObj; //返回排好序的新对象
}

//秘钥
/**
 * @author: wyt
 * @description:md5加密
 * @export
 * @param {*} params
 * @return {*}
 */
export function getSecretkey(params) {
  let obj = objKeySort(params);
  let urlParams = "";
  for (let key in obj) {
    if (key != "secretkey") {
      urlParams += key + "=" + obj[key] + "&";
    }
  }
  urlParams = urlParams.substring(0, urlParams.length - 1);
  let secretkey = md5(urlParams + "12345678");

  return secretkey;
}

/**
 * @author: wyt
 * @description:设置热力图数据
 * @export
 * @param {*} data
 * @param {*} features
 * @return {*}
 */
export function setHeatMapData(data, features) {
  let esriModule = store.state.esriModule;
  if (data.HeatMap && data.HeatMap.trim() != "" && data.GeoType == "点") {
    let heatLayer = map.getLayer("heatLayer_" + data.Id);
    if (heatLayer == undefined) {
      return;
    }
    for (let i = 0; i < features.length; i++) {
      let attributes = features[i].attributes;
      let geo = features[i].geometry;
      let graphic = new esriModule.Graphic(geo, null, attributes);
      heatLayer.add(graphic);
    }
  }
}
/**导出shp */
export function exportShapfile(GdataId, name) {
  exportShp({
    gdataId: GdataId
  })
    .then(res => {
      if (res.data.Status == 0) {
        let url = myConfig.baseUrl + res.data.Data;
        let a = document.createElement("a");
        a.download = name;
        a.href = url;
        a.click();
      } else {
        Message({
          message: res.data.Msg,
          type: "error"
        });
      }
    })
    .catch(error => {
      getError(error);
    });
}
//导出成cad
export function exportCadfile(GdataId, name) {
  exportCad({
    GDataId: GdataId,
    UserId: store.state.user.UserId
  })
    .then(res => {
      if (res.data.Status == 1) {
        let url = myConfig.baseUrl + "\\" + res.data.Data;
        let a = document.createElement("a");
        a.download = name;
        a.href = url;
        a.click();
      } else {
        Message({
          message: res.data.Msg,
          type: "error"
        });
      }
    })
    .catch(error => {
      getError(error);
    });
}
export function getDistinguishAttribute(layer, attr) {
  let datas = store.state.allLayerData;
  let id = layer.id.substring(10);
  if (id == "POI") {
    let newattr = {};
    for (let item in attr) {
      if (item != "ObjectID") {
        newattr[item] = attr[item];
      }
    }
    return newattr;
  } else {
    let filedlayer = datas.find(x => x.Id == id);
    let field = JSON.parse(filedlayer.field);
    let newattr = {};
    field.forEach(element => {
      if (element.FildName != "ID") {
        newattr[element.FildName] = attr[element.FildName];
      }
    });
    newattr.ID = attr.ID;
    newattr.TaskId = attr.TaskId;
    return newattr;
  }
}

/**
 * @author: wyt
 * @description:添加热力图
 * @export
 * @param {*} LayerStr 图层数据
 */
export function addHeatLayer(LayerStr) {
  if (LayerStr.HeatMap.trim() != "" && LayerStr.GeoType == "点") {
    let heatLayer = map.getLayer("heatLayer_" + LayerStr.Id);
    let heatData = JSON.parse(LayerStr.HeatMap);
    if (heatLayer == undefined) {
      heatLayer = heatMap.heatmapLayer(heatData.radius, [], heatData.field);
      heatLayer.id = "heatLayer_" + LayerStr.Id;
      map.addLayer(heatLayer);
    }
    if (heatData.show) {
      if (LayerStr.IsConcealed == 1) {
        heatLayer.hide();
      } else {
        if (LayerStr.IsConcealed == 1) {
          heatLayer.hide();
        } else {
          heatLayer.show();
        }
      }
    } else {
      heatLayer.hide();
    }
  }
}

/**
 * @author: wyt
 * @description:添加label图层
 * @export
 * @param {*} LayerStr
 */
export function addLableLayer(LayerStr) {
  if (LayerStr.Label.trim() != "") {
    let tempLabelLayer = map.getLayer(LayerStr.Id + "_Label");
    if (tempLabelLayer == undefined) {
      tempLabelLayer = store.state.esriModule.GraphicsLayer({
        id: LayerStr.Id + "_Label"
      });
      map.addLayer(tempLabelLayer);
      tempLabelLayer.setOpacity(parseInt(LayerStr.Opacity) / 100);
      tempLabelLayer.setMaxScale(parseInt(LayerStr.MaxScale));
      tempLabelLayer.setMinScale(parseInt(LayerStr.MinScale));
    }
    if (LayerStr.IsConcealed == 1) {
      tempLabelLayer.hide();
    }
  }
}

/**
 * @author: wyt
 * @description:动态服务查询
 * @export
 * @param {*} geometry
 */
export async function identifyTask(geometry) {
  var results = [];
  var layerTree = [];
  let esriModule = store.state.esriModule;
  var dynamicServiceQueryData = store.state.dynamicServiceQueryData;
  for (var i = 0; i < dynamicServiceQueryData.length; i++) {
    //定义空间查询对象，注意他的参数是整个地图服务，而不是单个图层
    var identifyTask = new esriModule.IdentifyTask(
      dynamicServiceQueryData[i].LayerUrl
    );
    //定义空间查询参数对象
    var params = new esriModule.IdentifyParameters();
    //容差
    params.tolerance = 5;
    //是否返回几何信息
    params.returnGeometry = true;
    //空间查询的图层
    //params.layerIds = [0, 1, 2, 3];
    //空间查询的条件
    params.layerOption = esriModule.IdentifyParameters.LAYER_OPTION_ALL;
    params.width = map.width;
    params.height = map.height;
    //空间查询的几何对象
    params.geometry = geometry;
    params.mapExtent = map.extent;
    //执行空间查询
    await identifyTask.execute(params, function (idResults) {
      results = results.concat(idResults);
    });
  }
  for (var i = 0; i < results.length; i++) {
    layerTree[i] = {
      label: results[i].layerName,
      layerId: results[i].layerId,
      children: [{
        label: results[i].displayFieldName,
        attributes: results[i].feature.attributes
      }]
    };
  }
  store.commit("set_dynamicServiceQueryfillter", layerTree);
}

/**
 * @author: wyt
 * @description:切片服务查询
 * @export
 * @param {*} evt
 */
export async function tiledQueryTask(evt) {
  var geometry = evt.mapPoint;
  var layerTree = [];
  let esriModule = store.state.esriModule;
  var level = map.getLevel();
  var pageType = getPageType();
  var tiledServiceQueryData = store.state.tiledServiceQueryData;
  store.commit("changeDataLoadState", true);
  for (var i = 0; i < tiledServiceQueryData.length; i++) {
    var layerId = tiledServiceQueryData[i].Id;
    var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
    let params = {
      lon: geometry.x,
      lat: geometry.y,
      Level: level,
      UserId: store.state.user.userid,
      GDataId: tiledServiceQueryData[i].GDataId,
      mapDocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1,
      type: pageType == 1 ? 1 : 0
    };
    await getPointExtentGData(params).then(res => {
      if (res.data.length > 0) {
        var features = getFeatures(
          tiledServiceQueryData[i].GeoType,
          res.data,
          layerInfo.coordinate,
          tiledServiceQueryData[i].Id,
          tiledServiceQueryData[i].GDataId
        );
        addGraphicToHighlightLayer(features);
        setTimeout(function () {
          clearHighlightLayer();
        }, 1000);
        store.commit("set_tiledServiceQueryFeatureData", features);
        var obj = {
          label: tiledServiceQueryData[i].LayerName,
          layerId: tiledServiceQueryData[i].Id,
          children: []
        };
        for (var j = 0; j < res.data.length; j++) {
          var ch = {
            label: res.data[j].ID,
            id: res.data[j].ID,
            attributes: res.data[j].Attr
          };
          obj.children.push(ch);
        }
        layerTree.push(obj);
      }
    });
  }
  if (i == tiledServiceQueryData.length) {
    store.commit("changeDataLoadState", false);
  }
  store.commit("set_tiledServiceQueryfillter", layerTree);
}


/**
 * @author: wyt
 * @description:转换数据（点转屏幕）
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} olddata
 * @param {*} geoType 数据类型
 * @return {*}
 */
export function convertData(row, col, olddata, geoType) {
  // var data = allData.filter(x=>x.J[i].G != null &&x.J[i].G.length == 0);
  // var data = {};
  // data = JSON.parse(JSON.stringify(olddata));
  var data = commonB.deepClone(olddata);
  // var data = olddata;
  var newData = [];
  var obj = {};

  if (data == "") {
    let d = {
      J: []
    };
    return d;
  }
  if (!data.J || !data.J.length) {
    data.J = [];
    return data;
  }
  for (var i = 0; i < data.J.length; i++) {
    if (data.J[i].G == null || data.J[i].G.length == 0) {
      continue;
    }
    if (data.J[i].G.length > 0) {
      var gdata = data.J[i].G;
      var newd = [];
      for (var k = 0; k < gdata.length; k++) {
        var singledata = gdata[k];
        singledata = singledata.filter(ele => {
          return ele != null;
        });
        if (geoType == "面") {
          // if (singledata.length < 4) {
          //   continue;
          // } else {
          newd.push(singledata);
          // }
        } else if (geoType == "线") {
          if (singledata.length < 2) {
            continue;
          } else {
            newd.push(singledata);
          }
        } else {
          // var rowcol = getRowCol(map.extent);
          // var pdata = []
          // for (var j = 0; j < singledata.length; j++) {
          //   var rowcol = getRowCol(map.extent);
          //   var x = singledata[j][0] + 256 * (col - rowcol.minCol);
          //333333333333   var y = singledata[j][1] + 256 * (rowcol.maxRow - row);
          //   pdata.push([x, y])
          // }
          // newd.push(pdata)
          newd.push(singledata);
        }
      }
      if (newd.length > 0) { }
      data.J[i].G = newd;
    }
  }
  return data;
}

/**
 * @author: wyt
 * @description:地图缩放事件
 * @export
 * @param {*} firstTimestamp 时间戳
 */
export function extentChange(firstTimestamp) {
  commonB.addBaseLayerToCanvas("extent")

  store.dispatch("setStopLoading", false);

  clearCancleToken();

  //绘制等待文本效果
  allTotalLayerPost = 0;
  allTotalLayerHasPosted = 0;

  clearArcLineArr(null, null, "all");
  //获取矢量图层
  var vectorLayerData = getVetorLayerNode(store.state.dataTreeData);
  //选择图层canvas
  createCanvas("selected", "scale");

  //拾取canvas
  createCanvas("highlight", "scale");

  // 点.选择图层
  if (vectorLayerData.length > 0 && !commonB.isAllLayerClose()) {
    startDrawText();
  } else {
    stopDrawText();
  }

  //清除存在全局变量中的标注数据
  labelData = [];

  var type = store.state.pageType == "data" ? 1 : 2;
  var val = store.state.SingleData;

  for (var i = vectorLayerData.length - 1; i >= 0; i--) {
    var layerId = vectorLayerData[i].id;
    let layerInfo = store.state.allLayerData.find(x => x.Id == layerId);
    //次数不一样，清除
    if (lastNumber != currentNumber) {
      var canvasCtn = document.getElementsByClassName("gispaiLayer");
      for (let j = 0; j < canvasCtn.length; j++) {
        canvasCtn[j].remove();
        j = j - 1;
      }
      TileCanvasCache = [];
      ChangedCanvasCache = [];
    }

    lastNumber = 0;
    currentNumber = 0;
    //选中的数据
    selectedAllData = selectedAllData.filter(ele => ele.layerId != layerId);

    //清除label
    DTPLabel.clearLabelCanvas(layerId);

    //点label偏移
    DTPLabel.labelCanvasoffset(layerId);

    //过滤全局数据
    TileData = TileData.filter(ele => ele.layerId != layerId);
    //缓存数据
    TileCanvasCache = TileCanvasCache.filter(ele => ele.layerId != layerId);

    ChangedCanvasCache = ChangedCanvasCache.filter(ele => {
      return ele.layerId != layerId;
    });
    if (selectedAllData.length > 0) {
      if (current_tool === "movepolygons") {
        // 绘制平移数据
        commonB.createMoveCanvas(selectedAllData);
      }
    }
    //监听缩放
    store.dispatch("zoomEndTimestamp", firstTimestamp);

    //判断当前图层是否可见
    if (!isShowLayer(layerId, layerInfo)) {
      continue;
    }

    //标记这个图层数据已加载
    layerInfo.hasLoadData = true

    if (!layerInfo.IsTileMode) {
      getAllDataFromServer(layerId, "scale");
    } else {
      //加载数据库数据
      getChangedData(layerId, "scale", vectorLayerData[i]).then(res => {
        //加载行列切片数据
        addTileData(res, "scale", firstTimestamp);
      });

    }




  }
}

/**
 * 数组去重
 * @param {*} arr 接收的原数组
 * @param {*} key 如果是对象数组[{id: 1}, {id: 2}, {id: 3}]，则需要以什么key作为重复的标准，普通数组[1,2,3,2]不需要
 */
export function arrUnique(arr, key) {
  // let returnArr = [];
  // if (key) {
  //   // 对象数组去重
  //   const obj = {};
  //   returnArr = arr.reduce((cur, next) => {
  //     obj[next[key]] ? '' : obj[next[key]] = true && cur.push(next);
  //     return cur;
  //   }, []);
  //   return returnArr;
  // }
  // // 普通数组去重
  // returnArr = arr.reduce((cur, next) => {
  //   !cur.includes(next) && cur.push(next);
  //   return cur;
  // }, []);
  // return returnArr;
  // if(arr.length>0){
  for (var i = 0; i < arr.length; i++) {
    for (var j = 0; j < arr.length; j++) {
      if (arr[i].layerId == arr[j].layerId) {
        var newarr = MergeArray(arr[i].IDs, arr[j].IDs)

        var Obj = {
          layerId: arr[j].layerId,
          IDs: newarr
        }
        arr.push(Obj)
        arr.splice(i, 1)
        arr.splice(j, 1)
        i--;
        j--;
        if (i < 0) {
          i = 0
        }
        if (j < 0) {
          j = 0
        }
      }
    }
    // }
  }
  return arr
}
export function MergeArray(arr1, arr2) {
  var _arr = new Array();
  for (var i = 0; i < arr1.length; i++) {
    _arr.push(arr1[i]);
  }
  for (var i = 0; i < arr2.length; i++) {
    var flag = true;
    for (var j = 0; j < arr1.length; j++) {
      if (arr2[i] == arr1[j]) {
        flag = false;
        break;
      }
    }
    if (flag) {
      _arr.push(arr2[i]);
    }
  }
  return _arr;
}

/**
 * @author: wyt
 * @description:加载数据库数据
 * @export
 * @param {*} layerId 图层Id
 * @param {*} type 类型
 */
export function getChangedData(layerId, type, otherData) {
  return new Promise(function (resolve, reject) {
    if (!isInScale(layerId)) {
      return;
    }
    store.dispatch("setStopLoading", false);
    clearArcLineArr(layerId, null, "layer");
    ChangedCanvasCache = ChangedCanvasCache.filter(ele => ele.layerId != layerId);
    var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
    if (layerInfo == undefined) {
      return;
    }
    var pageType = getPageType();
    //转换map的extent
    let coordinate = layerInfo.coordinate;
    var extent = map.extent;
    // if (mapCoordinate != coordinate) {
    //   extent = convertMapExtent(coordinate);
    // }
    if (extent == null) {
      return;
    }

    allTotalLayerPost++;
    if (type == "drag") {
      totalPostCounts++;
    }

    var timeStamp = localStorage.getItem('timestamp' + layerId)
    var clienttimestamp = localStorage.getItem('clienttimestamp' + layerId)
    var nowtimestamp = new Date().getTime()
    //if (Math.abs(nowtimestamp - clienttimestamp) < Intervaltime && type != "reload") {
    //修改后：只有手动重新加载图层数据，才会去服务器获取新数据
    if (type != "init" && type != "reload") {

      var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
      //单独更新ChangedData
      updateChangedData(extent, layerId, layerInfo)
      if (type === "drag") {
        hasPostedCounts++;
      }
      allTotalLayerHasPosted++;
      //绘制数据库数据，并对现有的切片canvas进行纠偏
      drawChangedData(layerInfo.Id);
      //拖拽后清除超出部份标注数据
      DTPLabel.clearPointLableData(layerInfo.Id);
      //标注canvas重置位置
      DTPLabel.labelCanvasoffset(layerInfo.Id);
      DTPLabel.clearLabelCanvas(layerInfo.Id);
      resolve(otherData)
      //绘制还在范围内的标注（数据库数据除外）
      DTPLabel.drawTilelabelData(layerInfo.Id);
      if (type === "drag") {
        var changeD = AllChangedData.find(val => val.layerId === layerId)
        if (!changeD)
          return
        var viewdata = changeD.data.filter(ele => ele.IsInView == true)
        //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
        if (viewdata) {
          DTPLabel.appendLabelData(layerId, viewdata, "Attribute").then(labelData => {
            (layerId, viewdata, "Attribute", type);
            DTPLabel.DrawLayerLabel(layerId, viewdata, "Attribute", type);
          });
        } else {
          // await DTPLabel.appendLabelData(layerId, [], "Attribute").then(labelData => {
          //   DTPLabel.virtuaCoutRefreshLabel(layerId, [], "Attribute", type);
          // });
        }
      } else {
        if (type != "redraw") {
          var changeD = AllChangedData.find(val => val.layerId === layerId)
          if (changeD) {
            DTPLabel.DrawLayerLabel(layerId, changeD.data, "Attribute", type);
            if (type === "scale") {
              if (allTotalLayerHasPosted == allTotalLayerPost) {
                stopDrawText();
              }
            }
          }
        }
      }
      return
    }


    let params = {
      UserId: store.state.user.userid,
      GDataId: layerInfo.GDataId,
      GDataName: "",
      type: pageType == 1 ? 1 : 0,
      mapDocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1
      // timestamp: timeStamp
    };
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    cancleToken.push(source);
    newReqs.getAllTableData(params, source.token).then(async res => {
      //保存下次请求的时间戳      
      //localStorage.setItem('timestamp' + layerId, res.data.timestamp)
      //localStorage.setItem('clienttimestamp' + layerId, new Date().getTime())

      //更新切片版本
      var newCacheVersion = {
        layerId: layerId,
        CacheVersion: res.data.CacheVersion
      }
      var CacheVersionIndex = CacheVersionArray.findIndex(val => val.layerId == layerId);
      if (CacheVersionIndex > -1) {
        CacheVersionArray.splice(CacheVersionIndex, 1)
        CacheVersionArray.push(newCacheVersion)
      } else {
        CacheVersionArray.push(newCacheVersion)
      }

      ZHT_ChangedDelData = res.data.deleteids

      if (res.data != '') {

        var notDrawArr = []
        var deleteArr = []

        if (res.data.lis) {
          for (var i = 0; i < res.data.lis.length; i++) {
            notDrawArr.push(res.data.lis[i].ID) //不绘制的ID
          }
        }
        if (res.data.deleteids) {
          notDrawArr.push(...res.data.deleteids)
          deleteArr.push(...res.data.deleteids) //删除的ID       
        }
      }
      deleteArr = deleteArr ? deleteArr : []
      notDrawArr = notDrawArr ? notDrawArr : []

      var deleteObj = {
        layerId: layerId,
        IDs: deleteArr
      }
      var notDrawObj = {
        layerId: layerId,
        IDs: notDrawArr
      }
      //获取所有删除IDs
      if (deleteIDs.findIndex(val => val.layerId == layerId) > -1) {
        var repeatIndex = deleteIDs.findIndex(val => val.layerId == layerId)
        deleteIDs[repeatIndex].IDs = MergeArray(deleteIDs[repeatIndex].IDs, deleteArr)
      } else {
        deleteIDs.push(deleteObj)
      }
      //获取所有不绘制的IDs
      if (notDrawIDs.findIndex(val => val.layerId == layerId) > -1) {
        var repeatIndex = notDrawIDs.findIndex(val => val.layerId == layerId)
        notDrawIDs[repeatIndex].IDs = MergeArray(notDrawIDs[repeatIndex].IDs, notDrawArr)
      } else {
        notDrawIDs.push(notDrawObj)
      }
      //   var deleteArr = []
      //   if (res.data.lis) {
      //     for (var i = 0; i < res.data.lis.length; i++) {
      //       deleteArr.push(res.data.lis[i].ID)
      //     }
      //   }
      //   if (res.data.deleteids) {
      //     deleteArr.push(...res.data.deleteids)
      //   }
      // }
      // deleteArr = deleteArr ? deleteArr : []
      // var deleteObj = {
      //   layerId: layerId,
      //   IDs: deleteArr
      // }
      // if (notDrawIDs.findIndex(val => val.layerId == layerId) > -1) {
      //   var repeatIndex = notDrawIDs.findIndex(val => val.layerId == layerId)
      //   notDrawIDs[repeatIndex].IDs = MergeArray(notDrawIDs[repeatIndex].IDs, deleteArr)
      // } else {         
      //   notDrawIDs.push(deleteObj)
      // }
      resolve(otherData)
      var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
      //处理数据库缓存数据,更新AllChangedData

      if (res.data.lis && res.data.lis.length > 0 || res.data.deleteids && res.data.deleteids.length > 0) {
        updateAllChangedData(res.data.lis, extent, layerId, layerInfo)
      } else {
        //单独更新ChangedData
        updateChangedData(extent, layerId, layerInfo)
      }
      //设置该图层已加载数据
      layerInfo.hasLoadData = true

      if (type === "drag") {
        hasPostedCounts++;
      }
      allTotalLayerHasPosted++;
      //绘制数据库数据，并对现有的切片canvas进行纠偏
      drawChangedData(layerInfo.Id);
      //拖拽后清除超出部份标注数据
      DTPLabel.clearPointLableData(layerInfo.Id);
      //标注canvas重置位置
      DTPLabel.labelCanvasoffset(layerInfo.Id);
      DTPLabel.clearLabelCanvas(layerInfo.Id);
      //绘制还在范围内的标注（数据库数据除外）
      DTPLabel.drawTilelabelData(layerInfo.Id);
      if (type === "drag") {
        var changeD = AllChangedData.find(val => val.layerId === layerId)
        if (!changeD)
          return
        var viewdata = changeD.data.filter(ele => ele.IsInView == true)
        //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
        if (viewdata) {
          await DTPLabel.appendLabelData(layerId, viewdata, "Attribute").then(labelData => {
            (layerId, viewdata, "Attribute", type);
            DTPLabel.DrawLayerLabel(layerId, viewdata, "Attribute", type);
          });
        } else {
          // await DTPLabel.appendLabelData(layerId, [], "Attribute").then(labelData => {
          //   DTPLabel.virtuaCoutRefreshLabel(layerId, [], "Attribute", type);
          // });
        }
      } else {
        if (type != "redraw") {
          var changeD = AllChangedData.find(val => val.layerId === layerId)
          if (changeD) {
            DTPLabel.DrawLayerLabel(layerId, changeD.data, "Attribute", type);
            if (type === "scale") {
              if (allTotalLayerHasPosted == allTotalLayerPost) {
                stopDrawText();
              }
            }
          }
        }
      }
    });
  })
}


/**
 * @author: wyt
 * @description:加载原始数据
 * @export
 * @param {*} layerId 图层Id
 * @param {*} type 类型
 */
export function getAllDataFromServer(layerId, type, otherData) {
  return new Promise(function (resolve, reject) {
    if (!isInScale(layerId)) {
      return;
    }
    store.dispatch("setStopLoading", false);

    clearArcLineArr(layerId, null, "layer");
    ChangedCanvasCache = ChangedCanvasCache.filter(ele => ele.layerId != layerId);
    var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
    if (layerInfo == undefined) {
      return;
    }
    var pageType = getPageType();
    //转换map的extent
    let coordinate = layerInfo.coordinate;
    var extent = map.extent;
    // if (mapCoordinate != coordinate) {
    //   extent = convertMapExtent(coordinate);
    // }
    if (extent == null) {
      return;
    }

    allTotalLayerPost++;
    if (type == "drag") {
      totalPostCounts++;
    }
    var timeStamp = localStorage.getItem('timestamp' + layerId)
    if (type != "init" && type != "reload") {
      var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
      //单独更新ChangedData
      updateChangedData(extent, layerId, layerInfo)
      //绘制数据库数据，并对现有的切片canvas进行纠偏
      drawChangedData(layerInfo.Id);
      //标注canvas重置位置
      DTPLabel.labelCanvasoffset(layerInfo.Id);
      DTPLabel.clearLabelCanvas(layerInfo.Id);
      if (type === "drag") {
        var changeD = AllChangedData.find(val => val.layerId === layerId)
        if (!changeD)
          return
        var viewdata = changeD.data.filter(ele => ele.IsInView == true)
        //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
        if (viewdata) {
          DTPLabel.appendLabelData(layerId, viewdata, "Attribute").then(labelData => {
            (layerId, viewdata, "Attribute", type);
            DTPLabel.DrawLayerLabel(layerId, viewdata, "Attribute", type);
          });
        }
      } else {
        if (type != "redraw") {
          var changeD = AllChangedData.find(val => val.layerId === layerId)
          if (changeD) {
            DTPLabel.DrawLayerLabel(layerId, changeD.data, "Attribute", type);
            if (type === "scale") {
              if (allTotalLayerHasPosted == allTotalLayerPost) {
                stopDrawText();
              }
            }
          }
        }
      }
      stopDrawText();
      return
    }
    let params = {
      UserId: store.state.user.userid,
      GDataId: layerInfo.GDataId,
      GDataName: "",
      type: pageType == 1 ? 1 : 0,
      mapDocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1,
      //timestamp: timeStamp,
      layerId: layerInfo.Id
    };
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    cancleToken.push(source);
    getDataText();
    newReqs.GetGData(params, source.token).then(async res => {
      // 保存下次请求的时间戳
      //localStorage.setItem('timestamp' + layerId, res.data.timestamp)
      //localStorage.setItem('clienttimestamp' + layerId, new Date().getTime())

      ZHT_ChangedDelData = res.data.deleteids

      resolve(otherData)
      var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
      //处理数据库缓存数据,更新AllChangedData和ChangedData
      var reslist = []
      if (res.data.Data) {
        reslist = JSON.parse(res.data.Data)
      }

      if (reslist && reslist.length > 0 || !timeStamp) {
        updateAllChangedData(reslist, extent, layerId, layerInfo)
      } else {
        //单独更新ChangedData
        updateChangedData(extent, layerId, layerInfo)
      }
      //设置该图层已加载数据
      layerInfo.hasLoadData = true
      //绘制数据库数据，并对现有的切片canvas进行纠偏
      drawChangedData(layerInfo.Id);


      //标注canvas重置位置
      DTPLabel.labelCanvasoffset(layerInfo.Id);
      DTPLabel.clearLabelCanvas(layerInfo.Id);
      if (type === "drag") {

        var changeD = AllChangedData.find(val => val.layerId === layerId)
        if (!changeD)
          return

        var viewdata = changeD.data.filter(ele => ele.IsInView == true)

        //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
        if (viewdata) {
          await DTPLabel.appendLabelData(layerId, viewdata, "Attribute").then(labelData => {
            (layerId, viewdata, "Attribute", type);
            DTPLabel.DrawLayerLabel(layerId, viewdata, "Attribute", type);
          });
        } else {
          // await DTPLabel.appendLabelData(layerId, [], "Attribute").then(labelData => {
          //   DTPLabel.virtuaCoutRefreshLabel(layerId, [], "Attribute", type);
          // });
        }
      } else {
        if (type != "redraw") {
          var changeD = AllChangedData.find(val => val.layerId === layerId)
          if (changeD) {
            var viewdata = changeD.data.filter(ele => ele.IsInView == true)
            DTPLabel.DrawLayerLabel(layerId, viewdata, "Attribute", type);
            if (type === "scale") {
              if (allTotalLayerHasPosted == allTotalLayerPost) {
                stopDrawText();
              }
            }
          }
        }
      }
      stopDrawText();
    });
  })
}


/**
 * @author: jfx
 * @description:用前端已缓存的数据重新绘制非切片图层
 * @export
 * @param {*} layerId 图层Id
 */
export function reDrawLayer(layerId, type) {
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  if (!layerInfo)
    return

  //转换map的extent
  let coordinate = layerInfo.coordinate;
  var extent = map.extent;
  // if (mapCoordinate != coordinate) {
  //   extent = convertMapExtent(coordinate);
  // }
  if (extent == null) {
    return;
  }
  //更新当前范围的数据库数据ChangedData
  updateChangedData(extent, layerId, layerInfo)
  //绘制数据库数据，并对现有的切片canvas进行纠偏
  drawChangedData(layerInfo.Id);

  if (layerInfo.IsTileMode) {
    //拖拽后清除超出部份标注数据
    DTPLabel.clearPointLableData(layerInfo.Id);
  }

  //标注canvas重置位置
  DTPLabel.labelCanvasoffset(layerInfo.Id);
  DTPLabel.clearLabelCanvas(layerInfo.Id);
  if (layerInfo.IsTileMode) {
    //绘制还在范围内的标注（数据库数据除外）
    DTPLabel.drawTilelabelData(layerInfo.Id);
  }
  //绘制标注
  if (type === "drag") {
    var changeD = AllChangedData.find(val => val.layerId === layerId)
    if (!changeD)
      return
    var viewdata = changeD.data.filter(ele => ele.IsInView == true)
    //如果近期有新的修改，则要将修改信息更新到缓存，再进行数据库标注绘制
    if (viewdata) {
      DTPLabel.appendLabelData(layerId, viewdata, "Attribute").then(labelData => {
        (layerId, viewdata, "Attribute", type);
        DTPLabel.DrawLayerLabel(layerId, viewdata, "Attribute", type);
      });
    }
  } else {
    if (type != "redraw") {
      var changeD = AllChangedData.find(val => val.layerId === layerId)
      if (changeD) {
        DTPLabel.DrawLayerLabel(layerId, changeD.data, "Attribute", type);
        if (type === "scale") {
          if (allTotalLayerHasPosted == allTotalLayerPost) {
            stopDrawText();
          }
        }
      }
    }
  }
  stopDrawText();

}


/**
 * 更新ChangedData
 * @export
 * @param {*} data 数据库数据
 * @param {*} layerId
 * @return {*}
 */
export function updateChangedData(extent, layerId, layerInfo) {
  var singlechangeData = [];
  var currentchangeData = [];
  var changeDataIndex = AllChangedData.findIndex(item => item.layerId === layerId);
  //var currentchangeDataIndex = ChangedData.findIndex(item => item.layerId === layerId);
  var data = [];
  if (changeDataIndex > -1) {
    data = AllChangedData[changeDataIndex].data;
  }
  var tolerance = (extent.xmax - extent.xmin + extent.ymax - extent.ymin) / 1000;
  for (let index = 0; index < data.length; index++) {
    // 将数据缓存 在label中使用
    var lisVal = data[index];
    var _data = lisVal;
    let extentArr = _data.Extent.split(",")
    // 获取范围内的数据
    var params = {
      xmin: parseFloat(extentArr[0]),
      ymin: parseFloat(extentArr[1]),
      xmax: parseFloat(extentArr[2]),
      ymax: parseFloat(extentArr[3])
    }
    if (isInExtent(params, extent, layerInfo, tolerance)) {
      // currentchangeData.push(lisVal)
      lisVal.IsInView = true
    } else {
      lisVal.IsInView = false

    }
  }

  // //更新ChangeData
  // if (currentchangeDataIndex > -1) {
  //   ChangedData[currentchangeDataIndex].data = currentchangeData
  // } else {
  //   var newData = {
  //     layerId: layerId,
  //     data: currentchangeData
  //   }
  //   ChangedData.push(newData)
  // }

}

/**
 * 修改存在前端的数据库数据AllChangedData（包括修改和删除的数据）
 * @export
 * @param {*} data 数据库数据
 * @param {*} layerId
 * @return {*}
 */
export function updateAllChangedData(data, extent, layerId, layerInfo) {

  var singlechangeData = [];
  var currentchangeData = [];
  var changeDataIndex = AllChangedData.findIndex(item => item.layerId === layerId);
  //var currentchangeDataIndex = ChangedData.findIndex(item => item.layerId === layerId);
  if (changeDataIndex > -1) {
    singlechangeData = AllChangedData[changeDataIndex].data;
  }
  // if (currentchangeDataIndex > -1) {
  //   currentchangeData = ChangedData[currentchangeDataIndex].data;
  // }
  var tolerance = (extent.xmax - extent.xmin + extent.ymax - extent.ymin) / 1000;
  data = convertChangedData(data, layerId, layerInfo, extent, tolerance)
  for (let index = 0; index < data.length; index++) {
    // 将数据缓存 在label中使用
    var lisVal = data[index];
    var changeFeatureIndex = singlechangeData.findIndex(val => val.Attr.ID === lisVal.Attr.ID);
    if (changeFeatureIndex > -1) {
      singlechangeData.splice(changeFeatureIndex, 1)
      singlechangeData.push(lisVal)
    } else {
      singlechangeData.push(lisVal)
    }
  }
  //更新AllChangedData
  if (changeDataIndex > -1) {
    AllChangedData[changeDataIndex].data = singlechangeData
  } else {
    var newData = {
      layerId: layerId,
      data: singlechangeData
    }
    AllChangedData.push(newData)
  }



  // 去除删除掉的数据
  if (ZHT_ChangedDelData && ZHT_ChangedDelData.length > 0) {
    var _changeDataIndex = AllChangedData.findIndex(item => item.layerId === layerId);
    if (_changeDataIndex > -1) {
      var _changeData = AllChangedData[_changeDataIndex].data;
      for (let i = 0; i < _changeData.length; i++) {
        var val = _changeData[i];
        if (ZHT_ChangedDelData && ZHT_ChangedDelData.length) {
          for (let k = 0; k < ZHT_ChangedDelData.length; k++) {
            var delId = ZHT_ChangedDelData[k];
            if (delId === val.Attr.ID) {
              _changeData.splice(i, 1);
              i--;
            }
          }
        }
      }
    }

  }
}
/**
 * @author: wyt
 * @description:创建canvas、绘制数据库读取的数据
 * @param {*} data 数据
 * @param {*} layerId 图层id
 */
export function drawChangedData(layerId) {
  //数据排序
  // commonB.sortChangeHandle(data, layerId);
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  var pdiv = document.querySelector("#mapView");
  var canvasCtn = createTiledCanvas(layerId);
  var canvas = document.getElementById(layerId + "_changed");

  const tempCanvas = document.createElement("canvas"); //缓存 canvas
  tempCanvas.width = pdiv.clientWidth;
  tempCanvas.height = pdiv.clientHeight;
  tempCanvas.style.left = "0px";
  tempCanvas.style.top = "0px";
  tempCanvas.style.position = "absolute";

  var index = AllChangedData.findIndex(x => x.layerId == layerId)
  var newData = []
  if (index >= 0) {
    newData = AllChangedData[index].data.filter(ele => ele.IsInView == true);
  }

  if (canvas) {
    // 当图层中最后一个数据被删除的时候清理canvas
    if (newData && !newData.length) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stopDrawText();
    }
  } else {
    canvas = document.createElement("canvas");
    canvas.className = "gispaiLayer" + " changedCanvas";
    canvas.style.left = "0px";
    canvas.style.top = "0px";
    canvas.setAttribute("id", layerId + "_changed");
    canvas.setAttribute("targetType", "data");
    canvas.width = pdiv.clientWidth;
    canvas.height = pdiv.clientHeight;
    canvas.style.position = "absolute";
    canvasCtn.append(canvas);
  }

  //若范围内没有数据库数据，对所有切片数据canvas进行纠正偏移，若有数据库数据，则统一在数据库数据绘制后纠偏
  if (newData.length > 0) {
    // 先绘制到 tempCanvas
    drawData_Changed(layerId, tempCanvas, layerInfo, newData, canvas);
  } else {
    //对切片数据canvas进行纠偏
    canvas.parentElement.style.top = "0px";
    canvas.parentElement.style.left = "0px";
    var ctnelement = canvas.parentElement.childNodes;
    if (ctnelement && ctnelement.length > 0) {
      var ele = ctnelement;
      for (var k = 0; k < ele.length; k++) {
        if (ele[k].id.indexOf("changed") == -1) {
          var ids = ele[k].id.split("_");
          var eLayerId = +ids[0];
          var eRow = +ids[1];
          var eCol = +ids[2];
          //全局数据在当前范围的行列要做偏移
          var offset = getCoordByRowCol(eRow, eCol);
          ele[k].style.left = offset.offsetX + "px";
          ele[k].style.top = offset.offsetY + "px";
          if (layerInfo.GeoType === "点" || layerInfo.GeoType === "线") {
            ele[k].style.left = offset.offsetX - pointSpace + "px";
            ele[k].style.top = offset.offsetY - pointSpace + "px";
          }
        }
      }
    }

    if (allTotalLayerHasPosted == allTotalLayerPost) {
      stopDrawText();
    }
  }
}

// 获取缓存范围内的数据
function getCanvasChangedNewData(extent, layerInfo, layerId) {
  var newDatalist = [];

  //从全部数据库数据AllChangedData中提取出本次范围内数据
  AllChangedData.forEach(val => {
    if (val.layerId === layerId) {
      for (let index = 0; index < val.data.length; index++) {
        var _data = val.data[index];
        let extentArr = _data.Extent.split(",")
        // 获取范围内的数据
        var params = {
          xmin: parseFloat(extentArr[0]),
          ymin: parseFloat(extentArr[1]),
          xmax: parseFloat(extentArr[2]),
          ymax: parseFloat(extentArr[3])
        }
        if (isInExtent(params, extent, layerInfo)) {
          newDatalist.push(_data)
        }
      }
    }
  })
  // 删除
  // newDatalist.forEach(val => {
  //   if (val.layerId === layerId) {
  //     for (let index = 0; index < val.data.length; index++) {
  //       var _data = val.data[index];
  //       if (ZHT_ChangedDelData) {
  //         ZHT_ChangedDelData.forEach(Id => {
  //           if (Id === _data.Attr.ID) {
  //             val.data.splice(index, 1)
  //             index--;
  //           }
  //         })
  //       }
  //     }
  //   }
  // })

  return newDatalist
}
//判断数据是不是在地图范围内
function isInExtent(dataExtent, extent, layerInfo, tolerance) {
  var cross = false;
  if (layerInfo.GeoType === "点") {
    if (dataExtent.xmin > extent.xmin + tolerance && dataExtent.xmin < extent.xmax - tolerance && dataExtent.ymin > extent.ymin + tolerance && dataExtent.ymin < extent.ymax - tolerance)
      cross = true
  } else {
    var polygon1 = trufPolygon([
      [
        [extent.xmin, extent.ymin],
        [extent.xmin, extent.ymax],
        [extent.xmax, extent.ymax],
        [extent.xmax, extent.ymin],
        [extent.xmin, extent.ymin]
      ]
    ]);
    var polygon2 = trufPolygon([
      [
        [dataExtent.xmin, dataExtent.ymin],
        [dataExtent.xmin, dataExtent.ymax],
        [dataExtent.xmax, dataExtent.ymax],
        [dataExtent.xmax, dataExtent.ymin],
        [dataExtent.xmin, dataExtent.ymin]
      ]
    ]);
    cross = booleanIntersects(polygon1, polygon2);
  }
  return cross
}
/**
 * @author: wyt
 * @description:绘制canvas(数据库返回的数据) Attribute
 * @param {*} layerId 图层Id
 * @param {*} canvas 临时canvas
 * @param {*} layerInfo 当前图层Id数据
 * @param {*} data 数据
 * @param {*} realCanvas 真实canvas
 * @param {*} drawType 绘制类型：export 导出大图数据类型
 */
export async function drawData_Changed(layerId, canvas, layerInfo, data, realCanvas, drawType) {
  if (!isInScale(layerId)) {
    await stopDrawText();
    return;
  } else {
    startDrawText();
  }

  var cacheContext = ""
  var cacheCanvas = ""
  var esriModule = store.state.esriModule;
  //用于拾取
  if (!drawType) {
    cacheCanvas = document.createElement("canvas");
    cacheCanvas.className = "gispaiLayer";
    cacheCanvas.setAttribute("id", layerId + "_changedTemp");
    cacheCanvas.width = realCanvas.width;
    cacheCanvas.height = realCanvas.height;
    cacheCanvas.style.left = "0px";
    cacheCanvas.style.top = "0px";
    cacheCanvas.style.position = "absolute";
    cacheContext = cacheCanvas.getContext("2d");
  }
  var tmp = ChangedCanvasCache.findIndex(ele => {
    return ele.layerId == layerId;
  });

  if (tmp === -1) {
    var obj = {
      layerId: layerId,
      geoType: layerInfo.GeoType,
      cacheContext: cacheContext,
      cacheCanvas: cacheCanvas //,
      //data: data
    };
    ChangedCanvasCache.push(obj);
  }
  let context = ""
  if (canvas) {
    context = canvas.getContext("2d");
  }


  var symbol = layerInfo.Symbol != "" ? JSON.parse(layerInfo.Symbol) : "";
  var isRender = false;
  let layerSym = symbol
  //判断是否有字段
  if (layerSym.hasOwnProperty("FieldName")) {
    isRender = true;
  }
  var style = {};
  if (!isRender) {
    style = getCanvasStyle(layerInfo, "", symbol);
    if (layerInfo.GeoType === "线") {

      if (style.set.lineStyles.length) {
        style.set.lineStyles.forEach(async val => {
          for (let key in val.style) {
            context[key] = val.style[key];
          }
          await commonB.drawData_Changed_noRenderDraw(layerId, canvas, layerInfo, data, val, context,
            cacheContext, esriModule, realCanvas, cacheCanvas, drawType);
        })

      } else {
        for (let key in style.style) {
          context[key] = style.style[key];
        }
        await commonB.drawData_Changed_noRenderDraw(layerId, canvas, layerInfo, data, style, context, cacheContext,
          esriModule, realCanvas, cacheCanvas, drawType);
      }
    } else if (layerInfo.GeoType === "面") {
      if (style.set.lineStyles && style.set.lineStyles.length) {
        style.set.lineStyles.forEach(async val => {
          for (let key in val.style) {
            context[key] = val.style[key];
          }
          commonB.drawData_Changed_noRenderDraw(layerId, canvas, layerInfo, data, val, context, cacheContext,
            esriModule, realCanvas, cacheCanvas, drawType);
        })
      } else {
        for (let key in style.style) {
          context[key] = style.style[key];
        }
        commonB.drawData_Changed_noRenderDraw(layerId, canvas, layerInfo, data, style, context, cacheContext,
          esriModule, realCanvas, cacheCanvas, drawType);
      }

    } else {
      for (let key in style.style) {
        context[key] = style.style[key];
      }
      commonB.drawData_Changed_noRenderDraw(layerId, canvas, layerInfo, data, style, context, cacheContext,
        esriModule, realCanvas, cacheCanvas, drawType);
    }

  } else {
    commonB
      .getUniRenderLabelVals(layerId, data, layerSym.FieldName, "Attribute")
      .then(async res => {
        var keys = Object.keys(res);
        commonB.drawData_Changed_noRenderDraw(layerId, canvas, layerInfo, data, style, context, cacheContext,
          esriModule, realCanvas, cacheCanvas, drawType, keys, res, symbol)
      });
  }
  stopDrawText();
}

/**
 * @author: wyt
 * @description:数据转化（数据库数据）
 * @param {*} oldData
 * @param {*} layerId
 * @param {*} layerInfo
 */
function convertChangedData(oldData, layerId, layerInfo, viewExtent, tolerance) {
  let esriModule = store.state.esriModule;
  let arcline = store.state.arcLineArr;
  var basemapID = store.state.SingleData.BMPId;
  var newData = [];
  let TransformPosition = new LonLatConversion();
  for (var i = 0; i < oldData.length; i++) {
    if (oldData[i].Shape != null && oldData[i].Shape.length > 0) {
      let newGeo;
      if (layerInfo.GeoType == "点") {
        let geometry = oldData[i].Shape;
        newGeo = new esriModule.Point({
          x: geometry[0],
          y: geometry[1],
          spatialReference: layerInfo.coordinate
        });
        newGeo = convertLngLat(layerInfo.coordinate, newGeo, basemapID, TransformPosition);
      } else if (layerInfo.GeoType == "线") {
        let geometry = RepairGeo(
          oldData[i].Shape,
          oldData[i].ID,
          layerId,
          layerInfo.coordinate
        );
        let onj = arcline.find(
          x => x.featureId == oldData[i].ID && x.layerId == layerId
        );
        if (onj != undefined && onj != null) {
          newGeo = new esriModule.Polyline({
            paths: onj.convertNodes,
            spatialReference: map.spatialReference
          });
        } else {
          newGeo = new esriModule.Polyline({
            paths: geometry,
            spatialReference: layerInfo.coordinate
          });
          newGeo = convertLngLat(layerInfo.coordinate, newGeo, basemapID, TransformPosition);
        }
      } else {
        let geometry = RepairGeo(
          oldData[i].Shape,
          oldData[i].ID,
          layerId,
          layerInfo.coordinate
        );
        let onj = arcline.find(
          x => x.featureId == oldData[i].ID && x.layerId == layerId
        );
        if (onj != undefined && onj != null) {
          newGeo = new esriModule.Polygon({
            rings: onj.convertNodes,
            spatialReference: map.spatialReference
          });
        } else {
          newGeo = new esriModule.Polygon({
            rings: geometry,
            spatialReference: layerInfo.coordinate
          });
          newGeo = convertLngLat(layerInfo.coordinate, newGeo, basemapID, TransformPosition);
        }
      }
      //判断不会空，防止报错
      if (newGeo) {
        var rings =
          layerInfo.GeoType == "点" ? [
            [
              [newGeo.x, newGeo.y]
            ]
          ] :
            layerInfo.GeoType == "线" ?
              newGeo.paths :
              newGeo.rings;
        var _attr = oldData[i].Attr
        if (_attr == null) {
          _attr = {
            ID: oldData[i].ID
          }
        }

        let IsInView = false
        let extentArr = oldData[i].Extent.split(",")
        //重新获取要素图形的范围，以地图坐标系为准
        //if (extentArr.length == 1) {
        let geom = new esriModule.Polygon({
          rings: rings,
          spatialReference: newGeo.spatialReference //new esriModule.SpatialReference(layerInfo.coordinate)
        })
        let extent = geom.getExtent()
        let eArr = []
        eArr.push(extent.xmin)
        eArr.push(extent.ymin)
        eArr.push(extent.xmax)
        eArr.push(extent.ymax)
        extentArr = eArr
        oldData[i].Extent = eArr.join(',')
        // }

        // 获取范围内的数据
        var params = {
          xmin: parseFloat(extentArr[0]),
          ymin: parseFloat(extentArr[1]),
          xmax: parseFloat(extentArr[2]),
          ymax: parseFloat(extentArr[3])
        }
        if (isInExtent(params, viewExtent, layerInfo, tolerance)) {
          IsInView = true
        }
        newData.push({
          ID: oldData[i].ID,
          Shape: rings,
          Attr: _attr,
          Extent: oldData[i].Extent,
          IsInView: IsInView
        });
      }
    }
  }
  return newData;
}

/**
 * @author: wyt
 * @description:根据属性获取对应的样式
 * @param {*} layerInfo 图层数据
 * @param {*} attributes 属性
 * @return {*}
 */
export function getAttrStyle(layerInfo, attrValue, symbol) {
  var allSymbols = symbol.Symbols;
  var newSys;
  var style = {};
  if (getPageType() == 1) {
    //索引值
    if (layerInfo.RenderType == "UniqueRender") {
      var index = symbol.Symbols.findIndex(
        (ele, index) => ele.Value === attrValue
      );
    } else {
      index = allSymbols.findIndex(ele => {
        let arr = ele.Value.split("-");
        return (
          parseFloat(attrValue) > parseFloat(arr[0]) &&
          parseFloat(attrValue) <= parseFloat(arr[1])
        );
      });
    }
  } else {
    //value值
    var index = -1;
    if (layerInfo.RenderType == "UniqueRender") {
      index = allSymbols.findIndex(ele => ele.Value === attrValue);
    } else {
      index = allSymbols.findIndex(ele => {
        let arr = ele.Value.split("-");
        if (arr.length > 1) {
          return (
            parseFloat(attrValue) > parseFloat(arr[0]) &&
            parseFloat(attrValue) <= parseFloat(arr[1])
          );
        } else {
          return parseFloat(attrValue) == parseFloat(arr[0]);
        }
      });
    }
  }

  if (index > -1) {
    newSys = allSymbols[index];
  } else {
    newSys = allSymbols[0];
  }
  if (newSys) {
    if (layerInfo.GeoType == "面") {
      style = getPolygonStyle(newSys.Symbol, newSys.SymbolsType);
    } else if (layerInfo.GeoType == "线") {
      style = getPolylineStyle(newSys.Symbol);
    } else {
      style = getPointStyle(newSys.Symbol, newSys.SymbolsType);
    }
  }
  return style;
}

/**
 * @author: wyt
 * @description:判断是否在比例尺内
 * @export
 * @param {*} layerId 图层Id
 * @return {*}
 */
export function isInScale(layerId) {
  var layerInfo = store.state.allLayerData.find(item => item.Id == layerId);
  if (layerInfo == undefined) {
    return;
  }
  var scale = map.getScale();
  var maxScale = parseFloat(layerInfo.MaxScale);
  var minScale = parseFloat(layerInfo.MinScale);
  if (minScale != 0 && maxScale != 0) {
    if (scale >= maxScale && scale <= minScale) {
      return true;
    } else {
      return false;
    }
  } else {
    if (minScale == 0 && maxScale == 0) {
      return true;
    } else {
      if (minScale == 0) {
        if (scale >= maxScale) {
          return true;
        } else {
          return false;
        }
      } else {
        if (scale <= minScale) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
}

/**
 * @author: wyt
 * @description:获取渲染对象renderer
 * @export
 * @param {*} layerInfo 图层数据
 * @return {*}
 */
export function setRenderer(layerInfo) {
  var renderer = "",
    defaultsymbol;
  if (layerInfo[0].Symbol != "") {
    renderer = getRenderer(
      layerInfo[0].GeoType,
      layerInfo[0].RenderType,
      JSON.parse(layerInfo[0].Symbol)
    );
  } else {
    defaultsymbol = getDefaultSymbol(layerInfo[0].GeoType);
    renderer = new esriModule.SimpleRenderer(defaultsymbol);
  }
  return renderer;
}

/**
 * @author: wyt
 * @description:判断节点是否勾选
 * @export
 * @param {*} node 节点
 * @param {*} data
 * @return {*}
 */
export function getChecked(node, data) {
  let flag = false;
  if (!node) {
    return;
  }
  if (node.parentId == 0) {
    //没有图层组嵌套
    // if (data.IsConcealed == 1) { //隐藏
    //     flag = false;
    // } else {
    //     flag = true;
    // }
    if (node.checked) {
      flag = true;
    } else {
      //隐藏
      flag = false;
    }
  } else {
    var pnode = getParentNode(store.state.dataTreeData, node.parentId);
    if (pnode.length > 0) {
      //if (pnode[0].checked && data.IsConcealed == 0) {
      if (pnode[0].checked && node.checked) {
        flag = true;
      } else {
        flag = false;
      }
    }
  }
  return flag;
}

/**
 * @author: wyt
 * @description:缩放过程显隐
 * @export
 */
export function scaleHandleChange() {
  var vectorLayerData = getVetorLayerNode(store.state.dataTreeData);
  for (var i = 0; i < vectorLayerData.length; i++) {
    var layerId = vectorLayerData[i].id;
    setVisibleByScale(layerId, vectorLayerData[i]);
  }
}
// 取消请求
export function clearCancleToken() {
  if (cancleToken.length > 0) {
    cancleToken.forEach(ele => {
      ele.cancel("取消请求");
    });
    cancleToken = [];
  }
}

/**
 * @author: jfx
 * @description:地图拖拽完成事件
 * @export
 * @param {*} lastExtent 前一次地图范围
 * @param {*} nowExtent 当前地图范围
 * @param {*} firstDragTimestamp 时间戳
 */
export async function dragChange(lastExtent, nowExtent, firstDragTimestamp) {

  var lastrowcol = getRowCol(lastExtent);
  var rowcol = getRowCol(nowExtent);

  //移除不在当前范围的未绘制的行列
  hasnotDrawRowCol = hasnotDrawRowCol.filter(
    x =>
      x.row >= rowcol.minRow &&
      x.row <= rowcol.maxRow &&
      x.col >= rowcol.minCol &&
      x.col <= rowcol.maxCol
  )

  //去重
  hasnotDrawRowCol = _.uniqWith(hasnotDrawRowCol, _.isEqual);


  ZHT_curtentExtent = nowExtent;
  ZHT_LabelDrawData = [];
  store.dispatch('setBaseLayerDraging', false)
  //添加或更新无级放大底图
  commonB.addBaseLayerToCanvas();
  totalPostCounts = 0;
  hasPostedCounts = 0;

  //所有图层请求次数
  allTotalLayerPost = 0;
  allTotalLayerHasPosted = 0;
  //取消上次请求未完成的请求
  clearCancleToken();

  var layerNodes = getVetorLayerNode(store.state.dataTreeData);
  if (layerNodes.length > 0 && !commonB.isAllLayerClose()) {
    startDrawText();
  }

  //高亮层的canvas增减，超出的减去，新范围增加
  createCanvas("highlight", "drag");
  //高亮层中继续保留的canvas偏移
  resetPickedCanvasByDrag("highlight");
  commonB.resetPointPickedCanvasByDrag("highlight");
  //选择层增减，超出的减去，新范围增加
  createCanvas("selected", "drag");
  //选择层中继续保留的canvas偏移
  resetPickedCanvasByDrag("selected");
  commonB.resetPointPickedCanvasByDrag("selected");

  selectedAllData = selectedAllData.filter(
    ele => ele.type != "vector" && ele.type == "screen" && ele.geoType != "点"
  );


  var nowoffset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);
  nowOffsetX = nowoffset.offsetX;
  nowOffsetY = nowoffset.offsetY;


  //清空数据库canvas数据
  ChangedCanvasCache = [];
  //移除范围外的切片数据缓存
  TileData = TileData.filter(
    x =>
      x.row >= rowcol.minRow &&
      x.row <= rowcol.maxRow &&
      x.col >= rowcol.minCol &&
      x.col <= rowcol.maxCol
  );
  //移除范围外的切片缓存缓存
  TileCanvasCache = TileCanvasCache.filter(
    x =>
      x.row >= rowcol.minRow &&
      x.row <= rowcol.maxRow &&
      x.col >= rowcol.minCol &&
      x.col <= rowcol.maxCol
  )

  labelData = labelData.filter(
    x =>
      x.type == "Vector"
  )



  //移除不在当前范围的切片canvas
  var ctnelement = document.getElementsByClassName("gispaiLayer");
  if (ctnelement && ctnelement.length > 0) {
    var ele = ctnelement;
    for (var k = 0; k < ele.length; k++) {
      if (ele[k].id.indexOf("changed") == -1) {
        var ids = ele[k].id.split("_");
        var eLayerId = +ids[0];
        var eRow = +ids[1];
        var eCol = +ids[2];
        //不在当前范围的行列移除
        if (
          eRow < rowcol.minRow ||
          eRow > rowcol.maxRow ||
          eCol < rowcol.minCol ||
          eCol > rowcol.maxCol
        ) {
          ele[k].remove();
          k = k - 1;
        } else if (
          eRow >= rowcol.minRow &&
          eRow <= rowcol.maxRow &&
          eCol >= rowcol.minCol &&
          eCol <= rowcol.maxCol
        ) {
          //在当前范围行列
          //全局数据在当前范围的行列要做偏移
          var offset = getCoordByRowCol(eRow, eCol);
          TileData.map(item => {
            if (
              item.layerId == eLayerId &&
              item.row == eRow &&
              item.col == eCol
            ) {
              item.offset = offset;
            }
            return item;
          });
        }
      }
    }
  }



  selectedAllData = selectedAllData.filter(x =>
    x.data.filter(
      y =>
        y.row >= rowcol.minRow &&
        y.row <= rowcol.maxRow &&
        y.col >= rowcol.minCol &&
        y.col <= rowcol.maxCol
    )
  );

  var type = store.state.pageType == "data" ? 1 : 2;
  var val = store.state.SingleData;

  for (var i = 0; i < layerNodes.length; i++) {

    var layerId = layerNodes[i].id;
    var layerInfo = store.state.allLayerData.find(val => val.Id == layerId);
    //显隐
    if (!isShowLayer(layerId, layerInfo)) {
      //如果图层是关闭，则将此图层的IsExtentChange设置为true
      layerInfo.IsExtentChange = true
      continue;
    }

    //标记这个图层数据已加载
    layerInfo.hasLoadData = true

    //判断图层数据按切片加载还是按原始数据全部加载模式
    if (!layerInfo.IsTileMode) {
      getAllDataFromServer(layerId, "drag");
    } else {

      //当前图层当前范围新增的行列号,加入到未绘制行列
      for (var r = rowcol.minRow; r <= rowcol.maxRow; r++) {
        for (var c = rowcol.minCol; c <= rowcol.maxCol; c++) {
          if (!store.state.stopLoading) {
            if (
              r < lastrowcol.minRow ||
              r > lastrowcol.maxRow ||
              c < lastrowcol.minCol ||
              c > lastrowcol.maxCol
            ) {
              hasnotDrawRowCol.push({
                row: r,
                col: c,
                layerId: layerId
              });
            }
          }
        }
      }

      //拖拽完成操作
      ProcessAfterDrag(
        layerNodes[i],
        firstDragTimestamp,
        lastExtent,
        nowExtent, hasnotDrawRowCol
      );
    }
  }
}
// 判断是否显示图层  比例，图层选中
export function isShowLayer(layerId, layerInfo) {
  var layerNodes = getVetorLayerNode(store.state.dataTreeData);
  var index = layerNodes.findIndex(node => node.id === layerId);
  if (!layerInfo) {
    layerInfo = store.state.allLayerData.find(val => val.Id == layerId);
  }
  let flag = getChecked(layerNodes[index], layerInfo);
  return !(!flag || !isInScale(layerId));
}
/**
 * @author: wyt
 * @description:拖拽过程偏移操作 偏移量
 * @export
 * @param {*} evt 地图evt
 * @param {*} clientX 上一次X值
 * @param {*} clientY 上一下Y值
 */
export function handleOffsetEvent(evt, clientX, clientY) {
  var cX = evt.clientX;
  var cY = evt.clientY;

  var OffsetX = cX - clientX;
  var OffsetY = cY - clientY;
  // 平移
  if (current_tool == "movepolygons") {
    var ele = document.getElementsByClassName("moveScreenLayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, OffsetX, OffsetY);
      unlockClock()
    }
  } else {
    var ele = document.getElementById("sucaiLayerId");
    if (ele) {
      var newLeft = ele.offsetLeft + OffsetX;
      var newTop = ele.offsetTop + OffsetY;
      ele.style.top = newTop + "px";
      ele.style.left = newLeft + "px";
    }

    var ele = document.getElementsByClassName("gsplayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, OffsetX, OffsetY);
    }

    var ele = document.getElementsByClassName("datalayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, OffsetX, OffsetY);
    }

    //label标注
    var labelEle = document.getElementsByClassName("labelLayer");
    if (labelEle && labelEle.length > 0) {
      setCanvasOffset(labelEle, OffsetX, OffsetY);
    }

    // 底图
    var ele = document.getElementsByClassName("baseLayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, OffsetX, OffsetY);
    }

    return;
    var ele = document.getElementsByClassName("gispaiLayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, offsetX, offsetY);
    }


    //拾取高亮的canvas
    var highlightEle = document.getElementsByClassName("highlightLayer");
    if (highlightEle && highlightEle.length > 0) {
      setCanvasOffset(highlightEle, offsetX, offsetY);
    }


    //选择图层
    var ele = document.getElementsByClassName("selectedLayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, offsetX, offsetY);
    }
    // 平移
    var ele = document.getElementsByClassName("moveScreenLayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, offsetX, offsetY);
    }
    // 底图
    var ele = document.getElementsByClassName("baseLayer");
    if (ele && ele.length > 0) {
      setCanvasOffset(ele, offsetX, offsetY);
    }
  }
}

/**
 * @author: wyt
 * @description:canvas偏移设置
 * @param {*} ele canvas元素
 * @param {*} offsetX  x偏移值
 * @param {*} offsetY  y偏移值
 */
function setCanvasOffset(ele, offsetX, offsetY) {
  for (var i = 0; i < ele.length; i++) {
    var newLeft = ele[i].offsetLeft + offsetX;
    var newTop = ele[i].offsetTop + offsetY;
    ele[i].style.top = newTop + "px";
    ele[i].style.left = newLeft + "px";
  }
}

/**
 * @author: wyt
 * @description:前后2个范围相交的部分
 * @param {*} nowExtent 当前范围
 * @param {*} lastExtent 上一次范围
 * @return {*}
 */
function getIntersectGeo(nowExtent, lastExtent) {
  let esriModule = store.state.esriModule;
  var nrings = [
    [
      [nowExtent.xmin, nowExtent.ymin],
      [nowExtent.xmin, nowExtent.ymax],
      [nowExtent.xmax, nowExtent.ymax],
      [nowExtent.xmax, nowExtent.ymin],
      [nowExtent.xmin, nowExtent.ymin]
    ]
  ];
  var oldrings = [
    [
      [lastExtent.xmin, lastExtent.ymin],
      [lastExtent.xmin, lastExtent.ymax],
      [lastExtent.xmax, lastExtent.ymax],
      [lastExtent.xmax, lastExtent.ymin],
      [lastExtent.xmin, lastExtent.ymin]
    ]
  ];
  let npolygon = new esriModule.Polygon({
    rings: nrings,
    spatialReference: map.spatialReference
  });
  let oldpolygon = new esriModule.Polygon({
    rings: oldrings,
    spatialReference: map.spatialReference
  });
  let geo = esriModule.geometryEngine.intersect(npolygon, oldpolygon);
  return geo;
}

/**
 * @author: wyt
 * @description:缩放过程显隐设置
 * @export
 * @param {*} layerId 图层Id
 */
export function setVisibleByScale(layerId) {
  var layerInfo = store.state.allLayerData.filter(val => {
    return val.Id == layerId;
  });
  setScale(layerId, layerInfo[0]);
}

/**
 * @author: wyt
 * @description:前后2个范围相交的部分,比例
 * @export
 * @param {*} layerId 图层Id
 * @param {*} layerInfo 图层数据
 */
export function setScale(layerId, layerInfo) {
  var nodeData = getVetorLayerNode(store.state.dataTreeData);
  let node = nodeData.find(ele => ele.id == layerId);
  var ele = document.getElementsByClassName("gispaiLayer_" + layerId);
  var labelEle = document.getElementById("gispaiLayer_labelLayer_" + layerId);
  let pNode = store.state.dataTreeData[0];
  let pChecked = pNode.checked;

  //判断是否在图层的当前比例尺内
  var flag = isInScale(layerId);
  if (pChecked) {
    let isShow = getChecked(node, layerInfo);
    if (!isShow) {
      if (ele.length > 0) {
        ele[0].style.display = "none";
      }
    } else {
      if (flag === true) {
        if (ele.length > 0) {
          ele[0].style.display = "block";
        }
      } else if (flag === false) {
        if (ele.length > 0) {
          ele[0].style.display = "none";
        }
      }
    }
  } else {
    if (ele.length > 0) {
      ele[0].style.display = "none";
    }
  }

  if (labelEle && ele.length) {
    labelEle.style.display = ele[0].style.display;
  }
  //树形数据中标记不显示的图层
  var dataTrees = store.state.dataTreeData;
  commonB.filterDataTrees(dataTrees[0].children, layerId, flag);
  store.dispatch("setDataTree", dataTrees);
}

//根据三点形成的弧或圆返回所有个点集
export function setArcline(tmp, type) {
  let list = [];
  let obj = locate(tmp);
  if (!obj)
    return list
  if (type == "circle") {
    list = [];
    let steps = 360;
    let ct = trufPoint([obj.x, obj.y]);
    //ct = toMercator(ct)
    let center = {
      x: ct.geometry.coordinates[0],
      y: ct.geometry.coordinates[1]
    };
    let radius = obj.radius;

    let alfa = 360;
    let i = 0;
    while (alfa >= 0) {
      let pt = getArcPt(center, radius, alfa);
      list.push(pt);
      i++;
      alfa = 360 - (i * 360) / steps;
    }
    // if (alfa > 360) {
    //   let pt = getArcPt(center, radius, 360);
    //   list.push(pt);
    // }
    return list;
  } else {
    list = DrawArcFromThreePoint(obj);
    return list;
  }
}

export function gettanVal(startx, starty, endx, endy) {
  let tan =
    (Math.atan(Math.abs((starty - endy) / (startx - endx))) * 180) / Math.PI;
  //正北方向为x轴,顺时针
  if (startx > endx && starty > endy) {
    //1
    return 90 - tan;
  } else if (startx < endx && starty > endy) {
    //4
    // return 360 - tan;
    return 270 + tan;
  } else if (startx < endx && starty < endy) {
    //3

    return 270 - tan;
  } else {
    //2
    return 90 + tan;
  }
}
//清除有关弧线的相关信息
export function clearArcLineArr(layerId, Id, type) {
  let arcLineArr = store.state.arcLineArr;
  if (type == "all") {
    store.commit("set_arcLineArr", []);
  } else if (type == "layer") {
    let temp = [];
    for (let i = 0; i < arcLineArr.length; i++) {
      if (arcLineArr[i].layerId != layerId) {
        temp.push(arcLineArr[i]);
      }
    }
    store.commit("set_arcLineArr", temp);
  } else {
    let index = arcLineArr.findIndex(
      x => x.layerId == layerId && x.featureId == Id
    );
    if (index != -1 && index != undefined) {
      arcLineArr.splice(index, 1);
    }
    store.commit("set_arcLineArr", arcLineArr);
  }
}

/**
 * @author: wyt
 * @description:加载行列切片数据
 * @export
 * @param {*} vectorLayerData 图层数据
 * @param {*} mouseType 类型
 * @param {*} firstTimestamp 时间戳
 */
export function addTileData(vectorLayerData, mouseType, firstTimestamp) {
  var layerId = vectorLayerData.id;

  //删除当前图层的缓存数据
  // TileData = TileData.filter(ele => ele.layerId != layerId);
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  if (layerInfo == undefined) {
    return;
  }
  var rowcol = getRowCol(map.extent);
  //hasnotDrawRowCol = [];
  for (var i = rowcol.minRow; i <= rowcol.maxRow; i++) {
    for (var j = rowcol.minCol; j <= rowcol.maxCol; j++) {
      allTotalLayerPost++;
      hasnotDrawRowCol.push({
        row: i,
        col: j,
        layerId:layerId
      });
      getTileData(
        i,
        j,
        mouseType,
        vectorLayerData,
        layerInfo.coordinate,
        firstTimestamp
      );
    }
  }
}

/**
 * @author: wyt
 * @description:取行列切片数据
 * @export
 * @param {*} i 行号
 * @param {*} j 列号
 * @param {*} mouseType 类型
 * @param {*} vectorLayerData 图层数据
 * @param {*} coordinate 坐标
 * @param {*} firstTimestamp 时间戳
 */
export async function getTileData(
  i,
  j,
  mouseType,
  vectorLayerData,
  coordinate,
  firstTimestamp
) {
  var level = map.getLevel();
  var pageType = getPageType();
  var layerId = vectorLayerData.id;
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  if (layerInfo == undefined) {
    return;
  }
  var para = isAddToParams(layerId);
  var isImg = "v";

  if (mouseType == "drag") {
    totalPostCounts++;
  } else {
    lastNumber++;
  }
  var basemapID = -1;
  if (pageType == 0) {
    // store.state.SingleData.BMPID  在线影像的时候用这个
    basemapID = store.state.SingleData.Gdata_data ? store.state.SingleData.Gdata_data.BMPId : store.state.SingleData
      .BMPID;
  } else {
    basemapID = store.state.SingleData.BMPId;
  }
  var CacheVersion = ""
  var CacheVersionIndex = CacheVersionArray.findIndex(val => val.layerId == layerId);
  if (CacheVersionIndex > -1) {
    CacheVersion = CacheVersionArray[CacheVersionIndex].CacheVersion
  }


  var params = {
    UserId: store.state.user.userid,
    GDataId: vectorLayerData.gDataId,
    layerId:layerId,
    Coordinate: coordinate,
    Level: level,
    Row: i,
    Column: j,
    type: pageType == 1 ? 1 : 0,
    mapDocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1,
    tiletype: isImg,
    BMPId: basemapID,
    CacheVersion: CacheVersion
  };
  params = Object.assign(params, para);
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  cancleToken.push(source);

  getGDataObject(params, source.token)
    .then(async result => {
      if (mouseType == "drag") {
        hasPostedCounts++;
      } else {
        currentNumber++;
      }
       
      allTotalLayerHasPosted++;
      var obj = result.config.params;
      var nCol = obj.Column;
      var nRow = obj.Row;
      var nLevel = obj.Level;
      if (result.data.T != 0) {
        var offset = getCoordByRowCol(nRow, nCol);
        var flag = true;
        if (mouseType == "scale") {
          if (firstTimestamp != zoomEndTimestamp) {
            flag = false;
          }
        }
        if (flag) {
          //图片切片
          if (result.data.T == 1) {
            //绘制图片
            startDrawImage(
              nRow,
              nCol,
              offset,
              result.data,
              layerId,
              mouseType,
              firstTimestamp
            );
          }
          //矢量切片因数据量过大，还未生成切片
          else if (result.data.T === 3) {
            var canvas = ZHT_creatCanvas(layerId, offset, nRow, nCol, true);
            if (canvas) {
              canvas.style.border = "1px solid red";
              var ctx = canvas.getContext("2d");
              ctx.font = '12px "微软雅黑"';
              ctx.fillStyle = "red";
              var space = 256 / 2;
              ctx.fillText("此区域数据量过大，", space - 40, space);
              ctx.fillText("需手动切片后显示", space - 40, space + 20);
            }
          }
          //正常矢量切片
          else {
            var newData = convertData(
              nRow,
              nCol,
              result.data,
              layerInfo.GeoType
            );
            var obj = {
              layerId: layerId,
              geoType: vectorLayerData.geoType,
              data: result.data,
              row: nRow,
              col: nCol,
              offset: offset
            };
            //剔除修改或删除的要素
            obj = changeObjData(obj)
            //判断共享类型，剔除不可显示要素
            var shareIndex = shareStatus.findIndex(val => parseInt(val.gDataId) == layerInfo.GDataId)
            if (shareIndex >= 0) {
              if (shareStatus[shareIndex].status == 3 || shareStatus[shareIndex].status == 4 || shareStatus[shareIndex].status == 5) {
                obj = getShareObj(obj)
              }
            }

            if (obj) {
              TileData.push(obj);
            }

            //开始绘制图形
            if (shareIndex >= 0 && (shareStatus[shareIndex].status == 3 || shareStatus[shareIndex].status == 5)) {
              startDraw(
                nRow,
                nCol,
                offset,
                obj.data,
                layerId,
                mouseType,
                firstTimestamp
              );
            } else {
              startDraw(
                nRow,
                nCol,
                offset,
                newData,
                layerId,
                mouseType,
                firstTimestamp
              );
            }

            //判断图层是否有标注
            let alllayers = store.state.allLayerData;
            let obj2 = alllayers.find(x => x.Id === layerId);
            if (obj2 == undefined || obj2.Label == "") {
              return;
            }
            let labels = JSON.parse(obj2.Label);
            if (!labels.Visiable) {
              return;
            }

            //切片上的坐标转换成canvas上要绘制的坐标
            var newData2 = DTPLabel.labelConvertData(
              nRow,
              nCol,
              result.data,
              layerInfo.GeoType
            );
            //开始绘制标注
            DTPLabel.DrawLayerLabel(layerId, newData2.J, "Vector", mouseType);
          }
        }
      } else {
        //标注图层渲染
        // if (mouseType == "drag") {
        //   if (allTotalLayerHasPosted === allTotalLayerPost) {
        //
        //     DTPLabel.virtuaCoutRefreshLabel(layerId, [], "Vector", mouseType);
        //   }
        // }
        if (allTotalLayerHasPosted === allTotalLayerPost) {
          stopDrawText();
        }
      }
      //绘制完后，将此行列从未绘制行列hasnotDrawRowCol中移除
      var index = hasnotDrawRowCol.findIndex(x => x.row = obj.Row && x.col == obj.Column && x.layerId == obj.layerId)
      hasnotDrawRowCol.splice(index, 1)
    })
    .catch(e => {
      if (axios.isCancel(e)) { } else { }
    });
}
//切片数据中移出
export function changeObjData(obj) {
  if (notDrawIDs.findIndex(val => val.layerId == obj.layerId) > -1) {
    var repeatIndex = notDrawIDs.findIndex(val => val.layerId == obj.layerId)
    for (var i = 0; i < obj.data.J.length; i++) {
      for (var j = 0; j < notDrawIDs[repeatIndex].IDs.length; j++) {
        if (obj.data.J[i].O == notDrawIDs[repeatIndex].IDs[j]) {
          obj.data.J.splice(i, 1);
          i--;
          if (i < 0) {
            i = 0
          }
          continue
        } else {
          continue
        }
      }
    }
  }
  return obj
}

export function getShareObj(obj) {
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == obj.layerId);

  shareIDS.forEach(items => {
    if (parseInt(items.gDataId) == layerInfo.GDataId) {
      obj.data.J = obj.data.J.filter(function (v) {
        return items.shareId.indexOf(v.O) !== -1 // 利用filter方法来遍历是否有相同的元素
      })
    }
  })
  return obj
}

/**
 * @author: wyt
 * @description:判断是否需要加参数
 * @export
 * @param {*} layerId 图层Id
 * @return {*}
 */
export function isAddToParams(layerId) {
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  if (layerInfo == undefined) {
    return;
  }
  let layerSym = JSON.parse(layerInfo.Symbol);
  var para = {
    isrender: false,
    fieldname: "",
    layerid: 0,
    isTag: false
    // Tagname: ""
  };
  if (layerSym.hasOwnProperty("FieldName")) {
    var obj = {
      isrender: true,
      fieldname: "",
      layerid: getPageType() == 1 ? layerId : 0
    };
    para = Object.assign(para, obj);
  }
  if (layerInfo.Label.trim() != "") {
    var labelInfo = JSON.parse(layerInfo.Label);
    var obj = {
      isTag: true,
      // Tagname: labelInfo.LabelField,
      layerid: getPageType() == 1 ? layerId : 0
    };
    para = Object.assign(para, obj);
  }
  return para;
}

/**
 * @author: wyt
 * @description:判断是图片/切片
 * @param {*} layerId 图层Id
 * @return {*}
 */
function isImageOrData(layerId) {
  var isImg = "v";
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  var levelRange = layerInfo.levelRange;
  if (levelRange != "") {
    var temp = JSON.parse(levelRange);
    var clevel = map.getLevel();
    var max =
      temp.VecMaxLevel >= temp.PicMaxLevel ?
        temp.VecMaxLevel :
        temp.PicMaxLevel;
    var lods = map.__tileInfo.lods;
    if (clevel >= temp.VecMinLevel && clevel <= temp.VecMaxLevel) {
      isImg = "v";
    } else if (clevel >= temp.PicMinLevel && clevel <= temp.PicMaxLevel) {
      isImg = "p";
    }
  }
  return isImg;
}

/**
 * @author: wyt
 * @description:拖拽后执行的操作
 * @param {*} vectorLayerData 图层数据
 * @param {*} firstTimestamp 时间戳
 * @param {*} lastExtent 上一次地图范围
 * @param {*} nowExtent 当前地图范围
 * @return {*}
 */
async function ProcessAfterDrag(
  layerNode,
  firstTimestamp,
  lastExtent,
  nowExtent, hasnotDrawRowCol
) {
  var layerId = layerNode.id;
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  var coordinate = layerInfo.coordinate;
  store.dispatch("setStopLoading", false);

  // if (hasnotDrawRowCol.length > 0) {

  //   //拖拽后清除超出部份标注数据
  //   DTPLabel.clearPointLableData(layerId);
  //   //标注canvas重置位置
  //   DTPLabel.labelCanvasoffset(layerId);
  //   DTPLabel.clearLabelCanvas(layerId);
  //   //绘制还在范围内的标注
  //   DTPLabel.drawTilelabelData(layerId);
  // }

  //先获取数据库数据，再获取切片数据
  await getChangedData(layerId, "drag").then(res => {
    // 行列数据
    drag_getTileData(hasnotDrawRowCol, layerNode, layerInfo, coordinate, firstTimestamp);
  });
}
//新增以及之前未绘制的行列号
function drag_getTileData(
  arr,
  layerNode,
  layerInfo,
  coordinate,
  firstTimestamp
) {
  let notDrawRCArray = arr.filter(x => x.layerId == layerNode.id);
  for (var i = 0; i < notDrawRCArray.length; i++) {
    if (layerInfo.GeoType == "点") {
      if (firstTimestamp != dragEndTimestamp) {
        return false;
      }
    }
    allTotalLayerPost++;
    getTileData(
      notDrawRCArray[i].row,
      notDrawRCArray[i].col,
      "drag",
      layerNode,
      coordinate,
      firstTimestamp
    );
  }
}

/**
 * @author: wyt
 * @description:点数据绘制
 * @param {*} layerInfo 图层数据
 * @param {*} layerId 图层Id
 * @param {*} rowcol 行列号
 * @param {*} firstTimestamp 时间戳
 * @param {*} lastrowcol 上一次范围的行列号
 * @param {*} lastExtent
 * @return {*}
 */
function resetPointCanvas(
  layerInfo,
  layerId,
  rowcol,
  firstTimestamp,
  lastrowcol,
  lastExtent
) {
  var alllayers = store.state.allLayerData;
  let layer = alllayers.find(x => x.Id == layerId);
  if (layerInfo.Label) {
    let labels = JSON.parse(layerInfo.Label);
    if (!labels.Visiable) {
      return;
    }
  } else {
    return;
  }
  //添加平移后不变的point数据
  var canvas = document.getElementById(layerId + "_point_changed");
  var canvasCtn = document.querySelector(".gispaiLayer_" + layerId);
  if (layerInfo.GeoType == "点") {
    //点数据优化
    TileData = TileData.filter(
      x =>
        x.row >= rowcol.minRow &&
        x.row <= rowcol.maxRow &&
        x.col >= rowcol.minCol &&
        x.col <= rowcol.maxCol
    );
    var newPointData = TileData.filter(x => x.layerId == layerId);

    let allPointData = TileData.filter(x => x.layerId == layerId);
    let flag = isCopyCanvas(allPointData);
    // let flag = false;
    if (flag) {
      //超过10000条
      //取相交（前后2个extent）
      let geo = getIntersectGeo(map.extent, lastExtent);
      if (!geo) {
        return;
      }
      var instersectP = geo.getExtent();
      var noChangeRolCol = getRowCol(instersectP); //相交部分的行列号
      //在canvas中左上角坐标
      var nowPX = getRowColPixel(
        noChangeRolCol.maxRow,
        noChangeRolCol.minCol,
        rowcol
      );
      var lastPX = getRowColPixel(
        noChangeRolCol.maxRow,
        noChangeRolCol.minCol,
        lastrowcol
      );

      let context = canvas.getContext("2d");
      var width = 256 * (noChangeRolCol.maxCol - noChangeRolCol.minCol + 1);
      var height = 256 * (noChangeRolCol.maxRow - noChangeRolCol.minRow + 1);
      //取上个canvas不变的行列号范围数据
      var imgData = context.getImageData(lastPX.x, lastPX.y, width, height);
      //移除重新创建canvas(extent范围变了);
      canvas.remove();
      canvas = createPointCanvas(canvasCtn, rowcol, "gispai", layerId);
      //取消绘制
      if (firstTimestamp != dragEndTimestamp) {
        return false;
      }
      context = canvas.getContext("2d");
      context.putImageData(imgData, nowPX.x, nowPX.y);
      //绘制选中的数据
      for (let i = 0; i < newPointData.length; i++) {
        var tempData = DTPLabel.labelConvertData(
          newPointData[i].row,
          newPointData[i].col,
          newPointData[i].data,
          layerInfo.GeoType
        );
        DTPLabel.appendLabelData(layerId, tempData.J, "Vector");
        for (let j = 0; j < tempData.J.length; j++) {
          if (tempData.J[j].G == null || tempData.J[j].G.length == 0) {
            continue;
          }
          if (tempData.J[j].G.length > 0) {
            //是否有选中的数据
            if (selectedIdData.length > 0) {
              redrawSelectedCanvas(
                "screen",
                tempData.J[j],
                layerId,
                newPointData[i].row,
                newPointData[i].col,
                layerInfo.GeoType
              );
            }
          }
        }
      }
    } else {
      noDrawData = noDrawData.filter(e => e.layerId != layerId);
      if (canvas) canvas.remove();
      createPointCanvas(canvasCtn, rowcol, "gispai", layerId);
      //取消绘制
      if (firstTimestamp != dragEndTimestamp) {
        return false;
      }
      for (var i = 0; i < newPointData.length; i++) {
        var tempData = DTPLabel.labelConvertData(
          newPointData[i].row,
          newPointData[i].col,
          newPointData[i].data,
          layerInfo.GeoType
        );
        DTPLabel.appendLabelData(layerId, tempData.J, "Vector");
        //startDrawPoint(newPointData[i].row, newPointData[i].col, tempData, newPointData[i].data, layerId, "drag", firstTimestamp)
      }
    }
  } else {
    TileData = TileData.filter(
      x =>
        x.row >= rowcol.minRow &&
        x.row <= rowcol.maxRow &&
        x.col >= rowcol.minCol &&
        x.col <= rowcol.maxCol
    );
  }
}

/**
 * @author: wyt
 * @description:判断点数据是否超过10000条
 * @param {*} data
 * @return {*}
 */
function isCopyCanvas(data) {
  let sum = 0;
  sum = data.reduce(function (a, b) {
    if (b.data.J != null && b.data.J.length > 0) {
      return a + b.data.J.length;
    } else {
      return a;
    }
  }, 0);
  if (sum > 10000) {
    return true;
  } else {
    return false;
  }
}

/**
 * @author: wyt
 * @description:绘制点canvas
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} data 转换后数据
 * @param {*} oridata 旧数据
 * @param {*} layerId 图层Id
 * @param {*} mouseType 类型
 * @param {*} firstTimestamp 时间戳
 */
export function startDrawPoint(row, col, data, layerId, mouseType, firstTimestamp) {

  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  var canvasCtn = createTiledCanvas(layerId);

  var canvas = document.getElementById(layerId + "_point_changed");
  var rowcol = getRowCol(map.extent);
  var offset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);
  if (canvas) {
    canvas.style.left = offset.offsetX + "px";
    canvas.style.top = offset.offsetY + "px";
  } else {
    // canvas = createPointCanvas(canvasCtn, rowcol, "gispai", layerId);
  }
  drawOnCanvas(
    layerId,
    row,
    col,
    canvas,
    layerInfo,
    data,
    "real",
    mouseType,
    firstTimestamp
  );
  if (mouseType != "redraw") {
    drawPolygonOnCacheCanvas(
      row,
      col,
      layerId,
      data,
      layerInfo,
      mouseType,
      firstTimestamp,
      offset
    );
  }
}

/**
 * @author: wyt
 * @description:绘制canvas
 * @export
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} offset 偏移量
 * @param {*} data
 * @param {*} oridata 旧数据
 * @param {*} layerId 图层Id
 * @param {*} mouseType 类型
 * @param {*} firstTimestamp 时间戳
 * @return {*}
 */
export function startDraw(
  row,
  col,
  offset,
  data,
  layerId,
  mouseType,
  firstTimestamp
) {
  var canvas = ZHT_creatCanvas(layerId, offset, row, col);
  let layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  // commonB.sortVirtualHandle(layerId, data);
  drawOnCanvas(
    layerId,
    row,
    col,
    canvas,
    layerInfo,
    data,
    "real",
    mouseType,
    firstTimestamp
  );
  if (mouseType != "redraw") {
    drawPolygonOnCacheCanvas(
      row,
      col,
      layerId,
      data,
      layerInfo,
      mouseType,
      firstTimestamp,
      offset
    );
  }
}
/**
 *创建一块256的canvas
 * @param {图层id} layerId
 * @param {偏移量} offset
 * @param {行} row
 * @param {列} col
 * @param {是否是边框样式} isBorder
 * @returns
 */
export function ZHT_creatCanvas(layerId, offset, row, col, isBorder) {
  let layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  var canvasCtn = createTiledCanvas(layerId);
  var ele = document.getElementById(layerId + "_" + row + "_" + col);
  if (ele) {
    ele.style.left = offset.offsetX + "px";
    ele.style.top = offset.offsetY + "px";
    if (layerInfo.GeoType === "点" || layerInfo.GeoType === "线") {
      ele.style.left = offset.offsetX - pointSpace + "px";
      ele.style.top = offset.offsetY - pointSpace + "px";
    }
    return;
  }
  var canvas = document.createElement("canvas");
  canvas.className = "gispaiLayer";
  canvas.style.left = offset.offsetX + "px";
  canvas.style.top = offset.offsetY + "px";
  canvas.setAttribute("id", layerId + "_" + row + "_" + col);
  canvas.setAttribute("targetType", "data");
  canvasCtn.append(canvas);
  canvas.width = 256;
  canvas.height = 256;
  if ((layerInfo.GeoType === "点" || layerInfo.GeoType === "线") && !isBorder) {
    canvas.width = pointCanvasWidth;
    canvas.height = pointCanvasWidth;
    canvas.style.left = offset.offsetX - pointSpace + "px";
    canvas.style.top = offset.offsetY - pointSpace + "px";
  }
  canvas.style.position = "absolute";
  return canvas;
}

/**
 * @author: wyt
 * @description:绘制图片canvas
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} offset 偏移量
 * @param {*} data
 * @param {*} layerId 图层Id
 * @param {*} mouseType 类型
 * @param {*} firstTimestamp 时间戳
 * @return {*}
 */
function startDrawImage(
  row,
  col,
  offset,
  data,
  layerId,
  mouseType,
  firstTimestamp
) {
  var canvas = document.createElement("canvas");
  var ele = document.getElementById(layerId + "_" + row + "_" + col);
  //创建canvas
  var canvasCtn = createTiledCanvas(layerId);
  if (ele) {
    ele.style.left = offset.offsetX + "px";
    ele.style.top = offset.offsetY + "px";
    return;
  }
  canvas.className = "gispaiLayer";
  canvas.style.left = offset.offsetX + "px";
  canvas.style.top = offset.offsetY + "px";
  canvas.setAttribute("id", layerId + "_" + row + "_" + col);
  canvasCtn.append(canvas);
  canvas.width = 256;
  canvas.height = 256;
  canvas.style.position = "absolute";
  canvas.setAttribute("targetType", "image");

  let context = canvas.getContext("2d");
  var image = new Image();
  image.src = "data:image/png;base64," + data.I;
  image.onload = function () {
    var flag = true;
    if (mouseType == "scale") {
      //缩放情况
      if (firstTimestamp != zoomEndTimestamp) {
        //停止绘制
        flag = false;
        stopDrawText();
      }
    } else { }
    if (flag) {
      noDrawData.push({
        layerId: layerId,
        row: row,
        col: col
      });
      context.drawImage(image, 0, 0, image.width, image.height);
      if (allTotalLayerHasPosted == allTotalLayerPost) {
        stopDrawText();
      }
    }
  };
}

/**
 * @author: wyt
 * @description:创建数据图层外层div
 * @param {*} layerId 图层Id
 */
function createTiledCanvas(layerId) {
  var div = document.querySelector("#mapView_gc");
  if (div == null) return;
  var canvasCtn = document.querySelector(".gispaiLayer_" + layerId);
  if (!canvasCtn) {
    canvasCtn = document.createElement("div");
    canvasCtn.className = "gispaiLayer_" + layerId + " datalayer";
    canvasCtn.style.position = "absolute";
    div.before(canvasCtn);
    //图层排序
    reorderCanvasLayer();
  }
  let flag = store.state.dataTreeData[0].checked;
  if (!flag) {
    canvasCtn.style.display = "none";
  }
  return canvasCtn;
}

/**
 * @author: wyt
 * @description: 鼠标拾取事件 （已经不再使用，在main.js自动开启拾取 mouseMoveEvent）
 * @param {*} type 是否开启工具
 * @return {*}
 */
var timeOutId = null;
export function pickUpEvent(type) {
  map.on("mouse-move", move2);

  function move2(evt) {
    if (!isMouseMovePickedEvent)
      return;

    if (type == "on") {
      let mappoint = evt.mapPoint;
      let point = map.toScreen(mappoint);
      mouseMoveEvent(point);
    } else {
      lastPickedData = [];
      var ele = document.getElementsByClassName("highlightLayer");
      if (ele && ele.length > 0) {
        for (var i = 0; i < ele.length; i++) {
          var ctx = ele[i].getContext("2d");
          ctx.clearRect(0, 0, ele[i].width, ele[i].height);
        }
      }
    }
    // map.onMouseMove = null;
    // timeOutId = setTimeout(() => {
    //   map.onMouseMove = move2;
    // }, 100);
  }
}
/**
 * @author: wyt
 * @description: 鼠标拾取canvas
 * @param {*} evt 地图屏幕坐标
 */
export function mouseMoveEvent(evt) {

  let toolList = ["multi_point", "point", "polyline", "polygon", "CIRCLE", "rectangle", "arc_line", "sectors",
    "drawCircle", "splittool",
    "reshapetool", "SplitLine", "AddInnerRing", "movepvetex", "movelvetex", "movepolygons", "moveline"
  ]
  let selectTool = ["SelectByRectangle", "SelectByPolygon", "SelectByCircle", "SelectByPolyline",
    "SelectNodeByRectangle", "measure"
  ]
  if (selectTool.indexOf(current_tool) != -1) {
    return
  }
  if (ISStartEditing && IsToolActive && toolList.indexOf(current_tool) != -1) {
    return
  }
  map.setMapCursor("default");
  var ele = document.getElementsByClassName("highlightLayer");
  if (ele && ele.length > 0) {
    for (var i = 0; i < ele.length; i++) {
      var ctx = ele[i].getContext("2d");
      ctx.clearRect(0, 0, ele[i].width, ele[i].height);
    }
  }
  lastPickedData = [];
  //图层排序
  reorderPickedLayer("highlight");
  //总图层关闭
  if (store.state.dataTreeData.length > 0 && !store.state.dataTreeData[0].checked) {
    return;
  }
  //按图层顺序，从上往下
  var vNodes = getVetorLayerNode(store.state.dataTreeData);
  var layerArr = [];
  var layerCacheArr = [];
  for (var i = 0; i < vNodes.length; i++) {
    let flag = getChecked(vNodes[i]);
    if (flag && vNodes[i].IsPicked) {
      let cd = TileCanvasCache.filter(ele => ele.layerId === vNodes[i].id);
      layerArr = layerArr.concat(cd);
      let ccd = ChangedCanvasCache.find(ele => ele.layerId === vNodes[i].id);
      if (ccd) {
        layerCacheArr.push(ccd);
      }
    }
  }

  layerCacheArr.length > 0 ?
    pickupTmpCanvas(layerCacheArr, layerArr, evt) :
    pickedCanvasSelected(layerArr, evt);
}
/**
 * 拾取全屏canvas
 * @param {*} layerCacheArr 临时canvas / 缓存canvas
 * @param {*} layerArr 切片canvas/行列
 * @param {*} evt
 */
function pickupTmpCanvas(layerCacheArr, layerArr, evt) {

  var canvas = document.getElementById("highlight_changed");
  for (var i = 0; i < layerCacheArr.length; i++) {
    var position = {
      x: evt.x,
      y: evt.y
      // x: evt.layerX,
      // y: evt.layerY
    };
    var color = getCacheColor(position, layerCacheArr[i].cacheContext);
    if (color) {
      // 取消禁止加载
      store.dispatch("setStopLoading", false);
      var selectIndex = ex16hex(color);
      if (selectIndex != 0 && selectIndex != NaN) {
        var ChangedData = AllChangedData.filter(ele => ele.layerId == layerCacheArr[i].layerId)
        var viewdata = ChangedData[0].data.filter(ele => ele.IsInView == true)
        var shape = viewdata[selectIndex - 1];
        if (shape) {
          let param = {
            layerId: layerCacheArr[i].layerId,
            data: shape,
            Id: shape.Attr.ID,
            type: "vector",
            geoType: layerCacheArr[i].geoType
          };
          lastPickedData.push(param);
          //若canvas关闭，则开启
          let pickedele = document.querySelector(".gispaiLayer_highlight");
          if (pickedele && pickedele.style.display == "none") {
            pickedele.style.display = "block";
          }
          map.setMapCursor("pointer");
          if (!store.state.keyCode.ctrlKey) {
            drawOnCanvasByChangeData(shape, canvas, layerCacheArr[i].layerId);
          }
          break;
        }
      }
    } else {
      // 拾取行列号canvas
      if (pickedCanvasSelected(layerArr, evt)) {
        break;
      }
    }
  }
}
/**
 * @author: wyt
 * @description: 拾取行列号canvas
 * @param {*} tmp 满足当前行列的数据
 * @param {*} position x,y坐标
 */
function pickedCanvasSelected(layerArr, evt) {
  var isVlaue = false;
  var position;
  //var obj = getSingleRowCol(evt.layerX, evt.layerY)
  var curRowCol = getSingleRowCol(evt.x, evt.y); //当前所在行列

  var tmp = layerArr.filter(ele => {
    return ele.row == curRowCol.row && ele.col == curRowCol.col;
  });

  if (tmp.length > 0) {
    position = {
      x: curRowCol.colp,
      y: curRowCol.rowp
    };
  }
  for (var i = 0; i < tmp.length; i++) {
    var color = "";
    if (tmp[i].geoType == "点" || tmp[i].geoType == "线") {
      //var rowcol = getRowCol(map.extent);
      var pos = {};
      // pos.x = position.x + 256 * (tmp[i].col - rowcol.minCol);
      // pos.y = position.y + 256 * (rowcol.maxRow - tmp[i].row);
      pos.x = position.x + pointSpace;
      pos.y = position.y + pointSpace;
      color = getCacheColor(pos, tmp[i].cacheContext);
    } else {
      color = getCacheColor(position, tmp[i].cacheContext);
    }
    if (color) {
      isVlaue = true;
      var selectIndex = ex16hex(color);
      if (selectIndex != 0 && selectIndex != NaN) {
        var shape = tmp[i].data.J[selectIndex - 1];
        if (shape) {
          map.setMapCursor("pointer");
          var dataID = shape.O;
          var tmpD = TileCanvasCache.filter(ele => ele.layerId == tmp[i].layerId);
          var newData = [];
          let newPointData = [];
          for (var j = 0; j < tmpD.length; j++) {
            if (tmpD[j].data.J != null) {
              var tempJ = convertData(
                tmpD[j].row,
                tmpD[j].col,
                tmpD[j].data,
                tmpD[j].geoType
              );
              var temp = tempJ.J;
              if (tmp[i].geoType == "点") {
                let pdata = temp.filter(
                  ele => ele.G != null && ele.G.length > 0 && ele.O == dataID
                );
                if (pdata.length > 0) {
                  let obj = {
                    row: tmpD[j].row,
                    col: tmpD[j].col,
                    data: pdata
                  };
                  newPointData.push(obj);
                }
              }
              var data = temp.filter(
                ele => ele.G != null && ele.G.length > 0 && ele.O == dataID
              );
              if (data.length > 0) {
                let obj = {
                  row: tmpD[j].row,
                  col: tmpD[j].col,
                  data: data
                };
                newData.push(obj);
              }
            }
          }
          let pickedObj = {
            layerId: tmp[i].layerId,
            data: newData,
            Id: dataID,
            type: "screen",
            geoType: tmp[i].geoType,
            data: tmp[i].geoType == "点" ? newPointData : newData
            // data: newData
          };
          lastPickedData.push(pickedObj);
          //若canvas关闭，则开启
          let pickedele = document.querySelector(".gispaiLayer_highlight");
          if (pickedele && pickedele.style.display == "none") {
            pickedele.style.display = "block";
          }
          if (!store.state.keyCode.ctrlKey) {
            redrawData(tmp[i].layerId, newData, "highlight");
          }
          break;
        }
      }
    }
  }
  return isVlaue;
}

/**
 * @author: wyt
 * @description: 根据屏幕坐标取缓存canvas颜色
 * @export
 * @param {*} positon
 * @param {*} cacheContext 缓存canvas的context
 * @return {*}
 */
export function getCacheColor(positon, cacheContext) {
  if (!cacheContext) {
    return
  }
  var color = cacheContext.getImageData(positon.x, positon.y, 1, 1).data;
  var hex = "";
  if (color[3] === 255) {
    hex = rgbToHex(color[0], color[1], color[2]);
  }
  return hex;
}

// 16进制数转10进制
function ex16hex(hex) {
  if (!hex) {
    return
  }
  var len = hex.length,
    a = new Array(len),
    code;
  for (var i = 0; i < len; i++) {
    code = hex.charCodeAt(i);
    if (48 <= code && code < 58) {
      code -= 48;
    } else {
      code = (code & 0xdf) - 65 + 10;
    }
    a[i] = code;
  }
  return a.reduce(function (acc, c) {
    acc = 16 * acc + c;
    return acc;
  }, 0);
}

/**
 * @author: wyt
 * @description: rgb转hex
 * @param {*} r
 * @param {*} g
 * @param {*} b
 * @return {*}
 */
function rgbToHex(r, g, b) {
  return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

/**
 * @author: wyt
 * @description: 绘制选择的数据/高亮
 * @export
 * @param {*} layerId 图层Id
 * @param {*} newdata 数据
 * @param {*} name canvas id
 */
export async function redrawData(layerId, newdata, name) {
  if (!isInScale(layerId) || !commonB.isLayerSelect(layerId)) {
    stopDrawText();
    return;
  } else {
    startDrawText();
  }

  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  let layerSym = JSON.parse(layerInfo.Symbol);
  var symbol = layerInfo.Symbol != "" ? JSON.parse(layerInfo.Symbol) : "";

  var isRender = false;
  let style = {};
  var canvas;
  if (layerSym.hasOwnProperty("FieldName")) {
    isRender = true;
  }
  // 点符号特殊处理
  if (layerInfo.GeoType === "点" && isRender) {
    for (var l = 0; l < newdata.length; l++) {

      await commonB
        .getUniRenderLabelVals(
          layerId,
          newdata[l].data,
          layerSym.FieldName,
          "Vector"
        )
        .then(res => {
          var alldata = newdata[l].data,
            context,
            pointContext,
            pointSelectedCanvas;
          canvas = document.getElementById(
            name + "_" + newdata[l].row + "_" + newdata[l].col
          );
          if (layerInfo.GeoType === "点") {
            pointSelectedCanvas = document.getElementById(
              name + "_" + newdata[l].row + "_" + newdata[l].col + "_point"
            );
          }
          if (pointSelectedCanvas) {
            pointContext = pointSelectedCanvas.getContext("2d");
            pointContext.beginPath();
          }
          if (canvas) {
            context = canvas.getContext("2d");
          }
          // var context = canvas.getContext("2d")
          context.beginPath();
          var keys = Object.keys(res);
          for (var k = 0; k < alldata.length; k++) {
            let index = keys.findIndex(key => key === alldata[k].O + "");
            var attrValue = res[keys[index]];
            var data = alldata[k];
            style = commonB.newGetCanvasStyle(layerInfo, attrValue, symbol);
            for (var i = 0; i < data.G.length; i++) {
              if (data.G[i] == null || data.G[i].length == 0) {
                continue;
              }
              var singledata = data.G[i];
              singledata = singledata.filter(ele => {
                return ele != null;
              });
              for (var j = 0; j < singledata.length; j++) {

                if (layerInfo.GeoType == "点") {
                  var x = singledata[j][0] + pointSpace;
                  var y = singledata[j][1] + pointSpace;
                  if (style.set.url) {
                    pointContext.fillStyle = "#00FFFF";
                    pointContext.arc(
                      x + cacheImageOffset,
                      y + cacheImageOffset,
                      style.set.width / 2,
                      0,
                      Math.PI * 2
                    );
                    pointContext.fill();
                    // loadCompleted("../../../static/images/arc.png").then((img) => {
                    //   context.drawImage(img, singledata[j][0], singledata[j][1], style.set.width, style.set.height);
                    // })
                  } else {
                    let _style = commonB.deepClone(style);
                    _style.set.color = "#00FFFF";
                    pointCtx.ctx.iconFont(
                      pointSelectedCanvas,
                      pointCtx.ctx.iconFontStyle(_style, x, y)
                    );
                  }
                } else {
                  if (layerInfo.GeoType == "面") {
                    // if (singledata.length < 4) {
                    //   continue;
                    // }
                  } else {
                    if (singledata.length < 2) {
                      continue;
                    }
                  }
                  if (singledata.length < 2) {
                    context.moveTo(singledata[j][0], singledata[j][1]);
                    context.lineTo(singledata[j][0] + 1, singledata[j][1]);
                  } else {
                    if (j == 0) {
                      context.moveTo(singledata[j][0], singledata[j][1]);
                    } else {
                      context.lineTo(singledata[j][0], singledata[j][1]);
                    }
                  }
                }
              }
              setCanvasPicked(layerInfo.GeoType, context, style);
            }
          }
        });
    }
  } else {
    // 获取样式
    style = commonB.newGetCanvasStyle(layerInfo, "", symbol);
    for (var l = 0; l < newdata.length; l++) {
      if (layerInfo.GeoType === "线") {
        if (style.set.lineStyles.length) {
          style.set.lineStyles.forEach(val => {
            commonB.redrawData_noRender(
              layerInfo,
              canvas,
              newdata[l],
              name,
              val
            );
          })
        } else {
          commonB.redrawData_noRender(
            layerInfo,
            canvas,
            newdata[l],
            name,
            style
          );
        }
      } else {
        commonB.redrawData_noRender(
          layerInfo,
          canvas,
          newdata[l],
          name,
          style
        );
      }
    }
  }
}

/**
 * @author: wyt
 * @description: 设置选中的符号样式
 * @param {*} geoType 数据类型
 * @param {*} context
 * @param {*} style 样式
 */
export function setCanvasPicked(geoType, context, style) {
  if (geoType == "面") {
    context.lineWidth = style.style.lineWidth + 1; //比原本宽度+1
    context.strokeStyle = "#00FFFF";
    // context.fillStyle = "rgba(0,0,0,0)";
    // context.fill();
    context.stroke();
    context.closePath();
  } else if (geoType == "线") {
    context.strokeStyle = "#00FFFF";
    context.lineWidth = style.style.lineWidth + 1; //比原本宽度+1
    context.stroke();
  } else {
    // context.strokeStyle = "#00FFFF";
    // context.fillStyle = "#00FFFF";
    // context.fill();
    // context.stroke();
    // context.closePath();
  }
}

/**
 * @author: wyt
 * @description: 绘制缓存的canvas
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} layerId 图层Id
 * @param {*} data
 * @param {*} oridata 旧数据
 * @param {*} layerInfo 图层数据
 * @param {*} mouseType 类型
 * @param {*} firstTimestamp 时间戳
 * @param {*} offset 偏移量
 */
function drawPolygonOnCacheCanvas(
  row,
  col,
  layerId,
  data,
  layerInfo,
  mouseType,
  firstTimestamp,
  offset
) {
  if (!isInScale(layerId)) {
    return;
  }
  var tmp = -1;
  tmp = TileCanvasCache.findIndex(ele => {
    return ele.layerId == layerId && ele.row == row && ele.col == col;
  });
  var canvas = document.createElement("canvas");
  canvas.setAttribute("id", layerId + "_" + row + "_" + col);
  canvas.width = 256;
  canvas.height = 256;
  canvas.style.left = offset.offsetX + "px";
  canvas.style.top = offset.offsetY + "px";
  if (layerInfo.GeoType == "点" || layerInfo.GeoType == "线") {
    canvas.width = pointCanvasWidth;
    canvas.height = pointCanvasWidth;
    canvas.style.left = offset.offsetX + pointSpace + "px";
    canvas.style.top = offset.offsetY + pointSpace + "px";
  }
  if (tmp == -1) {
    var context = canvas.getContext("2d");
    var obj = {
      layerId: layerId,
      geoType: layerInfo.GeoType,
      cacheContext: context,
      cacheCanvas: canvas,
      data: data,
      row: row,
      col: col
    };
    drawOnCanvas(layerId, row, col, canvas, layerInfo, data, "cache", mouseType, firstTimestamp);
    TileCanvasCache.push(obj);
  }
}

/**
 * @author: wyt
 * @description: 获取canvas的符号样式
 * @param {*} layerInfo 图层数据
 * @param {*} attrIndex  属性index
 * @return {*}
 */
function getCanvasStyle(layerInfo, attrIndex, symbol) {

  var style = {};
  if (layerInfo.RenderType == "SimpleRender") {
    var newSys = symbol.Symbol;
    if (layerInfo.GeoType == "面") {
      style = getPolygonStyle(newSys, symbol.SymbolType);
    } else if (layerInfo.GeoType == "线") {
      style = getPolylineStyle(newSys);
    } else {
      style = getPointStyle(newSys, symbol.SymbolType);
    }
  } else {
    var isMap = getPageType() == 1 ? true : false;
    var allSymbols = symbol.Symbols;
    var newSys;
    if (isMap) {
      newSys = allSymbols[+attrIndex - 1];
    } else {
      var index = -1;
      if (layerInfo.RenderType == "UniqueRender") {
        index = allSymbols.findIndex(ele => ele.Value == attrIndex);
      } else {
        if (attrIndex == "") {
          index = -1;
        } else {
          index = allSymbols.findIndex(ele => {
            let arr = ele.Value.split("-");
            return (
              parseFloat(attrIndex) > parseFloat(arr[0]) &&
              parseFloat(attrIndex) <= parseFloat(arr[1])
            );
          });
        }
      }
      if (index > -1) {
        newSys = allSymbols[index];
      } else {
        newSys = allSymbols[0];
      }
    }
    if (newSys) {
      if (layerInfo.GeoType === "面") {
        style = getPolygonStyle(newSys.Symbol, newSys.SymbolsType);
      } else if (layerInfo.GeoType === "线") {
        style = getPolylineStyle(newSys.Symbol);
      } else {
        style = getPointStyle(newSys.Symbol, newSys.SymbolsType);
      }
    }
  }

  return style;
}

/**
 * @author: wyt
 * @description: 面符号样式
 * @param {*} newSys 符号样式
 * @param {*} symbolType 符号类型
 * @return {*}
 */
export function getPolygonStyle(newSys, symbolType) {
  var style = {};
  var styles = getStyles(newSys);
  if (symbolType == "Simple") {
    var fcolorStr =
      newSys.color.r +
      "," +
      newSys.color.g +
      "," +
      newSys.color.b +
      "," +
      newSys.color.a;
    var scolorStr = newSys.outline ?
      newSys.outline.color.r +
      "," +
      newSys.outline.color.g +
      "," +
      newSys.outline.color.b +
      "," +
      newSys.outline.color.a :
      fcolorStr;

    style = {
      style: {
        fillStyle: "rgba(" + fcolorStr + ")",
        strokeStyle: "rgba(" + scolorStr + ")",
        lineWidth: newSys.outline ? newSys.outline.width : 0,
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu
      },
      set: {
        lineDash: newSys.outline ?
          newSys.outline.style == "solid" ? [] : [5, 5] : [],
        lineStyles: styles,
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu
      }
    };
  } else {
    var scolorStr = newSys.outline ?
      newSys.outline.color.r +
      "," +
      newSys.outline.color.g +
      "," +
      newSys.outline.color.b +
      "," +
      newSys.outline.color.a :
      0;
    var imageUrl = newSys.url
    // 查找缓存图片
    var index = store.state.layerImages.findIndex(item => item.url === imageUrl);
    var fillImg = ""
    if (index > -1) {
      fillImg = store.state.layerImages[index].image;
    }
    style = {
      style: {
        strokeStyle: "rgba(" + scolorStr + ")",
        lineWidth: newSys.outline ? newSys.outline.width : 0,
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu
      },
      set: {
        lineDash: newSys.outline ?
          newSys.outline.style == "solid" ? [] : [5, 5] : [],
        url: commonB.getImgPathUrl() + imageUrl,
        height: newSys.height,
        width: newSys.width,
        image: fillImg,
        lineStyles: styles,
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu
      }
    };
  }
  return style;
}
/**
 * 获取样式
 * @param {*} newSys
 * @returns
 */
function getStyles(newSys) {
  var styles = []
  if (newSys.lineStyles && newSys.lineStyles.length) {
    newSys.lineStyles.forEach(val => {
      var imageUrl = val.ployImage ? val.ployImage : val.imgUrl
      var index = store.state.layerImages.findIndex(item => item.url === imageUrl);
      var param = {
        style: {
          fillStyle: imageUrl ? '' : val.fillColor,
          strokeStyle: val.borderWidth ? val.borderColor : "rbga(0)",
          lineWidth: val.borderWidth,
          fluorescence: newSys.fluorescence,
          isflu: newSys.isflu
        },
        set: {
          lineDash: val.borderStyle == "solid" ? [] : [5, 5],
          url: imageUrl ? commonB.getImgPathUrl() + imageUrl : '',
          height: val.size + val.space,
          width: val.size + val.space,
          image: index > -1 ? store.state.layerImages[index].image : "",
          bgroundColor: "rgba(0,0,0,0)"
        },
      }
      styles.push(param)
    })
    if (newSys.lineStyles[0].backgroundColor && newSys.lineStyles[0].backgroundColor != "rgba(0,0,0,0)") {
      var val = newSys.lineStyles[0]
      var imageUrl = val.ployImage ? val.ployImage : val.imgUrl
      var index = store.state.layerImages.findIndex(item => item.url === imageUrl);
      var param = {
        style: {
          fillStyle: imageUrl ? '' : val.fillColor,
          strokeStyle: val.borderColor,
          lineWidth: val.borderWidth,
          fluorescence: newSys.fluorescence,
          isflu: newSys.isflu
        },
        set: {
          lineDash: val.borderStyle == "solid" ? [] : [5, 5],
          url: imageUrl ? commonB.getImgPathUrl() + imageUrl : '',
          height: val.size + val.space,
          width: val.size + val.space,
          image: index > -1 ? store.state.layerImages[index].image : "",
          bgroundColor: val.backgroundColor
        },
      }
      styles.unshift(param)
    }
  }
  return styles
}
/**
 * @author: wyt
 * @description: 线符号样式
 * @param {*} newSys 符号样式
 * @param {*} symbolType 符号类型
 * @return {*}
 */
export function getPolylineStyle(newSys, symbolType) {

  var style = {};
  var scolorStr =
    newSys.color.r +
    "," +
    newSys.color.g +
    "," +
    newSys.color.b +
    "," +
    newSys.color.a;
  var styles = []
  if (newSys.lineStyles && newSys.lineStyles.length) {
    newSys.lineStyles.forEach(val => {
      // 查找缓存图片
      var index = store.state.layerImages.findIndex(item => item.url === val.imgUrl);
      var fillImg = ""
      if (index > -1) {
        fillImg = store.state.layerImages[index].image;
      }

      var param = {
        style: {
          lineWidth: val.borderWidth,
          strokeStyle: val.borderColor,
          fluorescence: newSys.fluorescence,
          isflu: newSys.isflu
        },
        set: {
          lineDash: val.borderStyle == "solid" ? [] : [5, 5],
          spaceList: val.spaceList && val.spaceList.length ? val.spaceList : [],
          symobolType: val.type,
          space: val.space,
          unicode: val.type === "Simple" && val.unicode ? eval(
            '("' +
            `${val.unicode}`.replace("&#x", "\\u").replace(";", "") +
            '")'
          ) : "",
          // unicode: val.type === "Simple" && val.unicode ? val.unicode : "",
          angle: val.angle,

          url: val.type === "Picture" && val.imgUrl ? myConfig.baseUrl + val.imgUrl : "",
          color: val.fillColor,
          offsetX: val.offsetX,
          offsetY: val.offsetY,
          size: val.size,
          height: val.imgheight,
          width: val.imgwidth,
          lineDirection: val.lineDirection,
          image: fillImg
        },
        angle: val.angle,
      }
      styles.push(param)
    })
  }
  style = {
    style: {
      strokeStyle: "rgba(" + scolorStr + ")",
      lineWidth: newSys.width
    },
    set: {
      lineDash: newSys.style == "solid" ? [] : [5, 5],
      lineStyles: styles
    }
  };
  return style;
}

/**
 * @author: wyt
 * @description: 点符号样式
 * @param {*} newSys 符号样式
 * @param {*} symbolType 符号类型
 * @return {*}
 */
export function getPointStyle(newSys, symbolType) {
  var style = {};

  // 查找缓存图片
  var imageUrl = newSys.url
  var index = store.state.layerImages.findIndex(item => item.url === imageUrl);
  var fillImg = ""
  if (index > -1) {
    fillImg = store.state.layerImages[index].image;
  }
  if (symbolType == "Simple") {
    var fcolorStr =
      newSys.color.r +
      "," +
      newSys.color.g +
      "," +
      newSys.color.b +
      "," +
      newSys.color.a;
    var scolorStr = "";
    if (newSys.outline.color) {
      var scolorStr =
        newSys.outline.color.r +
        "," +
        newSys.outline.color.g +
        "," +
        newSys.outline.color.b +
        "," +
        newSys.outline.color.a;
    }
    if (newSys.unicode) {
      if (newSys.unicode.indexOf("&amp;") !== -1) {
        newSys.unicode = newSys.unicode.replace("&afmp;", "&");
      }
      if (newSys.unicode.indexOf("&amp") !== -1) {
        newSys.unicode = newSys.unicode.replace("&amp", "&");
      }
    }
    style = {
      style: {
        fillStyle: "rgba(" + fcolorStr + ")",
        strokeStyle: "rgba(" + scolorStr + ")",
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu
      },
      set: {
        lineDash: newSys.outline.style == "solid" ? [] : [5, 5],
        radius: newSys.size,
        size: newSys.size,
        unicode: eval(
          '("' +
          `${newSys.unicode}`.replace("&#x", "\\u").replace(";", "") +
          '")'
        ),
        color: "rgba(" + fcolorStr + ")",
        offsetX: newSys.offsetX,
        offsetY: newSys.offsetY,
        angle: newSys.angle,
        image: fillImg
      }
    };
  } else {
    style = {
      style: {
        fluorescence: newSys.fluorescence,
        isflu: newSys.isflu
      },
      set: {
        url: newSys.url ? commonB.getImgPathUrl() + newSys.url : "",
        height: newSys.height,
        width: newSys.width,
        image: fillImg
      }
    };
  }
  return style;
}

/**
 * @author: wyt
 * @description:  *绘制不规则图形 *canvas:画布对象*style:样式/格式对象*data:三维数组
 * @param {*} layerId 图层Id
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} canvas
 * @param {*} layerInfo 图层数据
 * @param {*} data
 * @param {*} type 数据类型
 * @param {*} mouseType 操作类型
 * @param {*} firstTimestamp 时间戳
 * @return {*} drawType 绘制类型:  导出大图“export”
 */
export async function drawOnCanvas(layerId, row, col, canvas, layerInfo, data, type, mouseType, firstTimestamp,
  drawType) {
  // 判断图层在范围内
  if (!isInScale(layerId)) {
    // if (allTotalLayerHasPosted === allTotalLayerPost) {
    stopDrawText();
    // }
    return;
  } else {
    startDrawText();
  }
  if (!canvas) {
    return;
  }
  let context = canvas.getContext("2d");
  let layerSym = JSON.parse(layerInfo.Symbol);
  var color;
  var symbol = layerInfo.Symbol != "" ? JSON.parse(layerInfo.Symbol) : "";
  var label = "";

  if (layerInfo.Symbol) {
    label = JSON.parse(layerInfo.Symbol).FieldName;
  }

  var isRender = false;
  if (layerSym.hasOwnProperty("FieldName")) {
    isRender = true;
  }
  if (type != "cache") {
    //未绘制的行列号数据
    noDrawData.push({
      layerId: layerId,
      row: row,
      col: col
    });
  }
  var style = {
    set: {
      url: ""
    }
  };
  //if (type != "cache") {
  // 简单渲染
  if (!isRender) {
    // 获取点线面的符号样式
    style = getCanvasStyle(layerInfo, "", symbol);
    for (let key in style.style) {
      context[key] = style.style[key];
    }

    if (layerInfo.GeoType === "线") {
      // 复合线样式有值，遍历多条线绘制形成复合线
      if (style.set.lineStyles.length) {
        style.set.lineStyles.forEach(val => {
          for (let key in val.style) {
            context[key] = val.style[key];
          }
          commonB.drawOnCanvas_noRenderDraw(layerId, row, col, canvas, layerInfo, data, type, mouseType,
            firstTimestamp, val, color, context, "", "", "", drawType);
        });
      } else {
        commonB.drawOnCanvas_noRenderDraw(layerId, row, col, canvas, layerInfo, data, type, mouseType, firstTimestamp,
          style, color, context, "", "", "", drawType);
      }
    } else if (layerInfo.GeoType === "面") {
      if (style.set.lineStyles && style.set.lineStyles.length) {
        style.set.lineStyles.forEach(async val => {
          commonB.drawOnCanvas_noRenderDraw(layerId, row, col, canvas, layerInfo, data, type, mouseType,
            firstTimestamp, val, color, context, "", "", "", drawType);
        })
      } else {
        commonB.drawOnCanvas_noRenderDraw(layerId, row, col, canvas, layerInfo, data, type, mouseType, firstTimestamp,
          style, color, context, "", "", "", drawType);
      }
    } else {
      commonB.drawOnCanvas_noRenderDraw(layerId, row, col, canvas, layerInfo, data, type, mouseType, firstTimestamp,
        style, color, context, "", "", "", drawType);
    }

  } else {
    //唯一值、分级渲染情况下，单独获取渲染值字段进行绘制
    commonB.getUniRenderLabelVals(layerId, data.J, label, "vector").then(res => {

      var keys = Object.keys(res);
      commonB.drawOnCanvas_noRenderDraw(layerId, row, col, canvas, layerInfo, data, type, mouseType,
        firstTimestamp, style, color, context, keys, res, symbol, drawType);
    });

  }
}
// 开始绘图文字
export function startDrawText() {
  store.dispatch("setDrawingText", "正在绘制...");
  //监听图层显隐
  var draVal = store.state.dragParams;
  store.dispatch("zoomEndTimestamp", draVal.firstTimestamp);
}
// 停止绘图文字
export function stopDrawText() {
  setTimeout(() => {
    store.dispatch("setDrawingText", "");
  }, 1000);
}
// 获取数据文字
export function getDataText() {
  store.dispatch("setDrawingText", "正在获取数据...");
}
/**
 * @author: wyt
 * @description: 图片异步获取
 * @param {*} src 图片路径
 * @return {*}
 */
export async function loadCompleted(src) {
  return new Promise(resolve => {
    var img = new Image();
    img.src = src;
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      resolve(img);
    };
  });
}

/**
 * @author: wyt
 * @description: 获取颜色
 * @param {*} number
 * @return {*}
 */
export function getColor(number) {
  // const alpha = number >> 24 & 0xff;
  const alpha = 1;
  const red = (number >> 16) & 0xff;
  const green = (number >> 8) & 0xff;
  const blue = number & 0xff;
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

/**
 * @author: wyt
 * @description: 根据extent计算行列号 最大行列和最小行列 左下角最小
 * @export
 * @param {*} extent 范围
 * @return {*}
 */
export function getRowCol(extent) {

  var level = map.getLevel();
  var OriginX = -20037508.342787;
  var OriginY = -20037508.342787;
  if (
    extent.ymax <= 200 &&
    extent.xmax <= 360 &&
    extent.ymax >= -200 &&
    extent.xmax >= -360
  ) {
    OriginX = -180;
    OriginY = -90;
  }

  var res = map.__tileInfo.lods[level].resolution;
  var minrow = Math.floor((extent.ymin - OriginY) / (res * 256));
  var maxrow = Math.floor((extent.ymax - OriginY) / (res * 256));
  var mincol = Math.floor((extent.xmin - OriginX) / (res * 256));
  var maxcol = Math.floor((extent.xmax - OriginX) / (res * 256));

  return {
    minRow: minrow,
    maxRow: maxrow,
    minCol: mincol,
    maxCol: maxcol
  };
}

/**
 * @author: wyt
 * @description: 根据屏幕坐标，计算相应的行列号中的x，y
 * @export
 * @param {*} x
 * @param {*} y
 * @return {*}
 */
export function getSingleRowCol(x, y) {
  var esriModule = store.state.esriModule;
  // var resolution = 1.4078260157100582;
  // var level = map.getLevel();
  // var OriginX = -180;
  // var OriginY = -90;
  // if (map.spatialReference.wkid == 102100) {
  //     resolution = 156543.03392800014;
  //     OriginX = -20037508.342787;
  //     OriginY = -20037508.342787;
  // }

  var level = map.getLevel();
  var OriginX = -20037508.342787;
  var OriginY = -20037508.342787;
  var extent = map.extent;
  if (
    extent.ymax <= 200 &&
    extent.xmax <= 360 &&
    extent.ymax >= -200 &&
    extent.xmax >= -360
  ) {
    OriginX = -180;
    OriginY = -90;
  }
  var res = map.__tileInfo.lods[level].resolution;
  let screenPoint = new esriModule.ScreenPoint(x, y);
  let point = map.toMap(screenPoint);
  var col = Math.floor((point.x - OriginX) / (res * 256));
  var row = Math.floor((point.y - OriginY) / (res * 256));
  var minx = col * res * 256 + OriginX;
  var miny = (row + 1) * res * 256 + OriginY;
  var colp = Math.abs((point.x - minx) / res);
  var rowp = Math.abs((point.y - miny) / res);
  return {
    row: row,
    col: col,
    colp: colp,
    rowp: rowp
  };
}

/**
 * @author: wyt
 * @description: 当前点在相应的行列号中的x，y值
 * @export
 * @param {*} point
 * @param {*} row 行号
 * @param {*} col 列号
 * @return {*}
 */
export function getPixelOnRowCol(point, row, col) {
  var esriModule = store.state.esriModule;
  // var resolution = 1.4078260157100582;
  // var level = map.getLevel();
  // var OriginX = -180;
  // var OriginY = -90;
  // if (map.spatialReference.wkid == 102100) {
  //     resolution = 156543.03392800014;
  //     OriginX = -20037508.342787;
  //     OriginY = -20037508.342787;
  // }
  // var res = resolution / (Math.pow(2, level));

  var level = map.getLevel();
  var OriginX = -20037508.342787;
  var OriginY = -20037508.342787;
  var extent = map.extent;
  if (
    extent.ymax <= 200 &&
    extent.xmax <= 360 &&
    extent.ymax >= -200 &&
    extent.xmax >= -360
  ) {
    OriginX = -180;
    OriginY = -90;
  }
  var res = map.__tileInfo.lods[level].resolution;
  var minx = col * res * 256 + OriginX;
  var miny = (row + 1) * res * 256 + OriginY;
  var colp = Math.floor((point.x - minx) / res);
  var rowp = Math.floor((miny - point.y) / res);
  return {
    x: colp,
    y: rowp
  };
}

/**
 * @author: wyt
 * @description: 根据行列号获取canvas中左上角坐标
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} rowcol 行列号
 * @return {*}
 */
function getRowColPixel(row, col, rowcol) {
  var x = (col - rowcol.minCol) * 256;
  var y = (rowcol.maxRow - row) * 256;
  return {
    x: x,
    y: y
  };
}

/**
 * @author: wyt
 * @description: 计算某行某列偏移
 * @export
 * @param {*} row 行号
 * @param {*} col 列号
 * @return {*}
 */
export function getCoordByRowCol(row, col) {
  var esriModule = store.state.esriModule;
  var level = map.getLevel();
  // 原点
  var OriginX = -20037508.342787;
  var OriginY = -20037508.342787;

  var extent = map.extent;

  if (
    extent.ymax <= 200 &&
    extent.xmax <= 360 &&
    extent.ymax >= -200 &&
    extent.xmax >= -360
  ) {
    OriginX = -180;
    OriginY = -90;
  }
  // 地图分辨率
  var res = map.__tileInfo.lods[level].resolution;
  // 计算出当前分辨率行列的起始点
  var x = col * res * 256 + OriginX;
  var y = (row + 1) * res * 256 + OriginY;

  //像素偏移量的xy
  var offsetX = (extent.xmin - x) / res;
  var offsetY = (extent.ymin - y) / res;

  var point = new esriModule.Point(
    extent.xmin,
    extent.ymin,
    map.spatialReference
  );
  var screenPoint = map.toScreen(point);
  // 像素偏移量
  return {
    offsetX: screenPoint.x - offsetX,
    offsetY: screenPoint.y + offsetY
  };
}
/**
 * @author:
 * @description: pogint计算某行某列偏移
 * @export
 * @param {*} row 行号
 * @param {*} col 列号
 * @return {*}
 */
export function getCoordByPointRowCol(row, col) {
  var esriModule = store.state.esriModule;
  var level = map.getLevel();
  var OriginX = -20037508.342787;
  var OriginY = -20037508.342787;
  var extent = map.extent;
  if (
    extent.ymax <= 200 &&
    extent.xmax <= 360 &&
    extent.ymax >= -200 &&
    extent.xmax >= -360
  ) {
    OriginX = -180;
    OriginY = -90;
  }
  var res = map.__tileInfo.lods[level].resolution;
  var x = col * res * 256 + OriginX;
  var y = (row + 1) * res * 256 + OriginY;
  var offsetX = (extent.xmin - x) / res;
  var offsetY = (extent.ymin - y) / res;
  var point = new esriModule.Point(
    extent.xmin,
    extent.ymin,
    map.spatialReference
  );
  var screenPoint = map.toScreen(point);
  return {
    offsetX: screenPoint.x - offsetX,
    offsetY: screenPoint.y + offsetY
  };
}
//圆弧边上一点到圆的最近距离和垂足点
//center:圆心  pt:点  radius:半径 返回切点坐标和点到圆的最近距离
export function tangentPointCoor(center, pt, radius) {
  radius = parseFloat(radius);
  let dd = pt.x - center.x;
  let yy = pt.y - center.y;
  let l = radius - Math.sqrt(Math.pow(dd, 2) + Math.pow(yy, 2));
  let direction = Math.atan2(dd, yy);
  let points = {
    x: pt.x,
    y: pt.y
  };
  if (l == 0) {
    points = {
      x: pt.x,
      y: pt.y
    };
  } else {
    let x = parseFloat(pt.x + l * Math.sin(direction));
    let y = parseFloat(pt.y + l * Math.cos(direction));
    points = {
      x: x,
      y: y
    };
  }
  let dist = Math.sqrt(
    Math.pow(pt.x - points.x, 2) + Math.pow(pt.y - points.y, 2)
  );
  if (l < 0) {
    dist = -dist;
  }
  return {
    point: points,
    dist: dist
  };
}

export function addPts(p) {
  let esriModule = store.state.esriModule;
  let po = new esriModule.Point(p.x, p.y, map.spatialReference);
  let g = new esriModule.Graphic(po, new esriModule.SimpleMarkerSymbol());
  map.graphics.add(g);
}

export function GetAngle(x, y) {
  if (x > 0 && y == 0) {
    return 0;
  } else if (x > 0 && y > 0) {
    return (Math.atan(y / x) * 180) / Math.PI;
  } else if (x == 0 && y > 0) {
    return 90;
  } else if (x < 0 && y > 0) {
    return 180 - (Math.atan(y / -x) * 180) / Math.PI;
  } else if (x < 0 && y == 0) {
    return 180;
  } else if (x < 0 && y < 0) {
    return 180 + (Math.atan(y / x) * 180) / Math.PI;
  } else if (x == 0 && y < 0) {
    return 270;
  } else if (x > 0 && y < 0) {
    return 360 - (Math.atan(-y / x) * 180) / Math.PI;
  }
}
//三点绘弧线
export function DrawArcFromThreePoint(obj) {
  let list = [];
  let steps = 360;

  var radius = obj.radius;
  var fangle = obj.angle1; //第一点角度
  var sangle = obj.angle2; //第二点角度
  var tangle = obj.angle3; //第三点角度
  let ct = trufPoint([obj.x, obj.y]);
  //ct = toMercator(ct)
  let center = {
    x: ct.geometry.coordinates[0],
    y: ct.geometry.coordinates[1]
  };
  if (fangle > tangle && fangle > sangle && sangle > tangle) {
    //fangle一直减到tangle
    let i = 0;
    let alfa = fangle;
    while (alfa > tangle) {
      let pt = getArcPt(center, radius, alfa);
      list.push(pt);
      i++;
      alfa = fangle - (i * 360) / steps;
    }
    if (alfa < tangle) {
      let pt = getArcPt(center, radius, tangle);
      list.push(pt);
    }
  } else if (fangle > tangle && (fangle < sangle || sangle < tangle)) {
    //fangle一直加到360，再从0加到tangle
    tangle = tangle + 360;
    let alfa = fangle;
    let i = 0;
    while (alfa < tangle) {
      let pt = getArcPt(center, radius, alfa);
      list.push(pt);
      i++;
      alfa = fangle + (i * 360) / steps;
    }
    if (alfa > tangle) {
      let pt = getArcPt(center, radius, tangle);
      list.push(pt);
    }
  } else if (fangle < tangle && sangle > fangle && sangle < tangle) {
    //fangle一直加到tangle
    let alfa = fangle;
    let i = 0;
    while (alfa < tangle) {
      let pt = getArcPt(center, radius, alfa);
      list.push(pt);
      i++;
      alfa = fangle + (i * 360) / steps;
    }
    if (alfa > tangle) {
      let pt = getArcPt(center, radius, tangle);
      list.push(pt);
    }
  } else if (fangle < tangle && (sangle < fangle || sangle > tangle)) {
    //fangle一直减到0，再从360减到tangle
    let i = 0;
    let alfa = fangle;
    while (alfa > 0) {
      let pt = getArcPt(center, radius, alfa);
      list.push(pt);
      i++;
      alfa = fangle - (i * 360) / steps;
    }
    let j = 0;
    let alfa2 = 360;
    while (alfa2 > tangle) {
      let pt = getArcPt(center, radius, alfa2);
      list.push(pt);
      j++;
      alfa2 = 360 - (j * 360) / steps;
    }
    if (alfa2 < tangle) {
      let pt = getArcPt(center, radius, tangle);
      list.push(pt);
    }
  }
  return list;
}

export function locate(datas) {
  let x1, x2, x3, y1, y2, y3;
  let point1 = datas[0];
  let point2 = datas[1];
  let point3 = datas[2];

  if (point1.x == point3.x && point1.y == point3.y) {
    let x0 = (point1.x + point2.x) / 2;
    let y0 = (point1.y + point2.y) / 2;
    let radius = Math.sqrt(
      (point1.x - x0) * (point1.x - x0) + (point1.y - y0) * (point1.y - y0)
    );
    var angle3 = GetAngle(point2.x - x0, point2.y - y0); //中间点
    let line = lineString([
      [point1.x, point1.y],
      [x0, y0]
    ]);
    let dis = truflength(line, {
      units: "kilometers"
    });

    var obj = {
      x: x0,
      y: y0,
      angle1: 0,
      angle2: angle3,
      radius: radius,
      angle3: 360,
      radius1: dis
    };
    return obj;
  } else {
    x1 = point1.x;
    y1 = point1.y;
    x2 = point2.x;
    y2 = point2.y;
    x3 = point3.x;
    y3 = point3.y;

    let a1 = x1 - x2;
    let b1 = y1 - y2;
    let c1 = x1 - x3;
    let d = y1 - y3;
    let e = (x1 * x1 - x2 * x2 + (y1 * y1 - y2 * y2)) / 2.0;
    let f = (x1 * x1 - x3 * x3 + (y1 * y1 - y3 * y3)) / 2.0;
    let det = b1 * c1 - a1 * d;
    // if (Math.abs(det) > 0.000001) {
    let x0 = -(d * e - b1 * f) / det;
    let y0 = -(a1 * f - c1 * e) / det;
    if (!x0 || !y0) {
      x0 = 0
      y0 = 0
      return null
    }
    let pt = trufPoint([x0, y0]);
    // if (coordinate != 102100) {
    //   pt = toWgs84(pt)
    // }
    var radius = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0));
    //   if (coordinate != 102100) {
    //     radius = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0))
    //     //radius = radius / 111000
    //   } else {
    //     radius = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0))
    //   }
    var angle1 = GetAngle(x1 - x0, y1 - y0);
    var angle2 = GetAngle(x3 - x0, y3 - y0);
    var angle3 = GetAngle(x2 - x0, y2 - y0); //中间点
    let line = lineString([
      [x1, y1],
      [x0, y0]
    ]);
    let dis = truflength(line, {
      units: "kilometers"
    });
    var obj = {
      x: pt.geometry.coordinates[0],
      y: pt.geometry.coordinates[1],
      angle1: angle1,
      angle2: angle3,
      radius: radius,
      angle3: angle2,
      radius1: dis
    };
    return obj;
    // }
  }
}

export function locate2(datas) {
  let x1, x2, x3, y1, y2, y3;
  let point1 = datas[0];
  let point2 = datas[1];
  let point3 = datas[2];
  if (point1[0] == point3[0] && point1[1] == point3[1]) {
    let x0 = (point1[0] + point2[0]) / 2;
    let y0 = (point1[1] + point2[1]) / 2;
    let radius = Math.sqrt(
      (point1[0] - x0) * (point1[0] - x0) + (point1[1] - y0) * (point1[1] - y0)
    );
    var angle3 = GetAngle(point2[0] - x0, point2[1] - y0); //中间点
    var obj = {
      x: x0,
      y: y0,
      angle1: 0,
      angle2: angle3,
      radius: radius,
      angle3: 360
    };
    return obj;
  } else {
    x1 = point1[0];
    y1 = point1[1];
    x2 = point2[0];
    y2 = point2[1];
    x3 = point3[0];
    y3 = point3[1];

    let a1 = x1 - x2;
    let b1 = y1 - y2;
    let c1 = x1 - x3;
    let d = y1 - y3;
    let e = (x1 * x1 - x2 * x2 + (y1 * y1 - y2 * y2)) / 2.0;
    let f = (x1 * x1 - x3 * x3 + (y1 * y1 - y3 * y3)) / 2.0;
    let det = b1 * c1 - a1 * d;
    // if (Math.abs(det) > 0.000001) {
    let x0 = -(d * e - b1 * f) / det;
    let y0 = -(a1 * f - c1 * e) / det;

    let pt = trufPoint([x0, y0]);
    // if (coordinate != 102100) {
    //   pt = toWgs84(pt)
    // }
    var radius = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0));
    //   if (coordinate != 102100) {
    //     radius = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0))
    //     //radius = radius / 111000
    //   } else {
    //     radius = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0))
    //   }
    var angle1 = GetAngle(x1 - x0, y1 - y0);
    var angle2 = GetAngle(x3 - x0, y3 - y0);
    var angle3 = GetAngle(x2 - x0, y2 - y0); //中间点
    var obj = {
      x: pt.geometry.coordinates[0],
      y: pt.geometry.coordinates[1],
      angle1: angle1,
      angle2: angle3,
      radius: radius,
      angle3: angle2
    };
    return obj;
    // }
  }
}

export function getArcPt(center, radius, alfa) {
  //radius = radius / 111000
  let x = center.x + radius * Math.cos(((Math.PI * 2) / 360) * alfa);
  let y = center.y + radius * Math.sin(((Math.PI * 2) / 360) * alfa);
  let p = trufPoint([x, y]);
  //   if (coordinate != 102100) {
  //     p = toWgs84(p)
  //   }
  return [p.geometry.coordinates[0], p.geometry.coordinates[1]];
}
//转换坐标
export function transformationLine(paths, coordinate) {
  if (mapCoordinate == coordinate) {
    return paths;
  } else {
    let newGeo;
    var esriModule = store.state.esriModule;
    let geometry = new esriModule.Polyline({
      paths: [paths],
      spatialReference: new esriModule.SpatialReference(coordinate)
    });
    // var outSpatialReference = new esriModule.SpatialReference(coordinate)
    if (isProjectionPromise) {
      newGeo = esriModule.projection.project(geometry, map.spatialReference);
      return newGeo.paths[0];
    } else {
      var projectionPromise = esriModule.projection.load();
      projectionPromise.then(function () {
        isProjectionPromise = true;
        newGeo = esriModule.projection.project(geometry, map.spatialReference);
        return newGeo.paths[0];
      });
    }
  }
}

/**
 * @author: wyt
 * @description: 按矩形选择操作
 * @export
 * @param {*} geometry
 * @Reviser:kangsl
 */
export async function selectByTools(geometry) {
  var esriModule = store.state.esriModule;
  clearGraphicFromSelectLayer([], "all");
  if (!IsMutiSelect) {
    //清除查询tab的数据、状态
    store.commit("set_tiledServiceQueryState", false);
    store.commit("changeDataLoadState", true);
    store.commit("set_isResetTableSelected", true);
    selectedAllData = [];
    selectedIdData = [];
    createCanvas("selected", "selected");
  } else {
    //按shift
    createCanvas("selected", "selectedTool");
    deleteColRowIds = [];
  }
  store.commit("set_selectQueryState", true);
  //createCanvas("selected", "selectedTool");
  reorderPickedLayer("selected");
  var vectorData = getVetorLayerNode(store.state.dataTreeData);
  var canvas = document.getElementById("selected_changed");
  if (
    current_tool == "SelectByRectangle" ||
    current_tool == "SelectByPolygon" ||
    current_tool == "SelectByCircle" ||
    current_tool == "SelectByPolyline"
  ) {
    var extent = geometry.getExtent();
    var num = vectorData.length;
    var rowcol = getRowCol(extent);
    // var allrowcol = getRowCol(map.extent);
    for (var i = vectorData.length - 1; i >= 0; i--) {
      num--;
      if (vectorData[i].checked && commonB.isLayerSelect(vectorData[i].id)) {
        var selectIds = [];
        //后台返回的数据库更改数据（ChangedData全局数据）

        var alldata = AllChangedData.find(e => e.layerId == vectorData[i].id);
        var layerInfo = store.state.allLayerData.find(
          x => x.Id == vectorData[i].id
        );

        var symbol = JSON.parse(layerInfo.Symbol);
        let selectIdIndex = selectedIdData.findIndex(
          x => x.layerId == layerInfo.Id
        );
        if (selectIdIndex > -1) {
          selectIds = JSON.parse(
            JSON.stringify(selectedIdData[selectIdIndex].ids)
          );
        }

        if (alldata) {
          let viewdata = alldata.data.filter(ele => ele.IsInView == true)
          for (let f = 0; f < viewdata.length; f++) {
            var ele = viewdata[f];
            var insGeo = getGeometry(ele.Shape, layerInfo.GeoType);
            let isIntersect = esriModule.geometryEngine.intersects(
              insGeo,
              geometry
            );

            //取相交
            if (isIntersect) {
              var obj = {
                layerId: alldata.layerId,
                Id: ele.Attr.ID,
                type: "vector",
                geoType: layerInfo.GeoType,
                data: ele
              };

              if (!IsMutiSelect) {
                if (selectIds.indexOf(ele.Attr.ID) === -1) {
                  selectIds.push(ele.Attr.ID);
                  //绘制选中的图形
                  drawOnCanvasByChangeData(ele, canvas, alldata.layerId);
                }
                //添加数据到全局
                addSelectDataToAll(layerInfo.Id, ele.Attr.ID, obj);
              } else {
                //选中和不选中处理
                await commonB.notVectorSelectedHandle(
                  ele,
                  alldata.layerId,
                  selectIds,
                  obj
                );
              }
            }
          }
        }
        /*后台返回行列数据（TileData全局行列数据）*/
        //选择框所占的行列号
        // await changeData()
        for (var j = rowcol.minRow; j <= rowcol.maxRow; j++) {
          for (var k = rowcol.minCol; k <= rowcol.maxCol; k++) {
            var selectgeo = convertToScreen(
              geometry,
              j,
              k,
              layerInfo.GeoType,
              rowcol
            );
            var sdata = TileData.find(
              e => e.layerId == vectorData[i].id && e.row == j && e.col == k
            );

            if (sdata) {
              if (sdata.data.J != null && sdata.data.J.length != 0) {
                for (let m = 0; m < sdata.data.J.length; m++) {
                  var ele = sdata.data.J[m];
                  var ngeo = commonB.getGeometry(ele, layerInfo)
                  if (ngeo) {
                    //取相交
                    let isIntersect = esriModule.geometryEngine.intersects(
                      ngeo,
                      selectgeo
                    );
                    if (isIntersect) {
                      var sameIdDatas = [],
                        samePointIdDatas = [];
                      if (layerInfo.GeoType == "点") {
                        //256*256行列号的点转换为全屏行列号下的点位置
                        var jdata = commonB.deepClone(ele);
                        jdata.G[0][0][0] = jdata.G[0][0][0];
                        jdata.G[0][0][1] = jdata.G[0][0][1];
                        sameIdDatas = [{
                          row: j,
                          col: k,
                          data: [jdata]
                        }];
                        samePointIdDatas = [{
                          row: j,
                          col: k,
                          data: [ele]
                        }];
                      } else {
                        if (ngeo.type == "polygon" || ngeo.type == "polyline") {
                          var sextent = ngeo.getExtent();
                          if (!sextent) {
                            return;
                          }
                          if (
                            sextent.xmin == -2 ||
                            sextent.xmax > 256 ||
                            sextent.ymin == -2 ||
                            sextent.ymax > 256
                          ) {
                            sameIdDatas = getAllSameIds(sdata.layerId, ele.O);
                          } else {
                            sameIdDatas = [{
                              row: j,
                              col: k,
                              data: [ele]
                            }];
                          }
                        } else {
                          sameIdDatas = [{
                            row: j,
                            col: k,
                            data: [ele]
                          }];
                        }
                      }
                      var obj = {
                        layerId: sdata.layerId,
                        type: "screen",
                        Id: ele.O,
                        geoType: layerInfo.GeoType,
                        data: layerInfo.GeoType == "点" ?
                          samePointIdDatas : sameIdDatas
                      };
                      // 没有按住shift
                      if (!IsMutiSelect) {
                        if (selectIds.indexOf(ele.O) == -1) {
                          selectIds.push(ele.O);
                          addSelectDataToAll(layerInfo.Id, ele.O, obj);
                          redrawData(sdata.layerId, sameIdDatas, "selected");
                        }
                        //按住shift
                      } else {
                        if (deleteColRowIds.indexOf(ele.O) === -1) {
                          deleteColRowIds.push(ele.O);
                          if (selectIds.indexOf(ele.O) == -1) {
                            selectIds.push(ele.O);
                          } else {
                            selectIds.splice(selectIds.indexOf(ele.O), 1);
                          }
                          //选中和不选中处理
                          commonB.notSliceSelectedHandle(obj, sdata.layerId);


                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        selectIds = _.sortBy(selectIds, function (item) {
          return item;
        });
        settingPagination(layerInfo, selectIds);
      }
    }
    if (num == 0) {
      store.commit("changeDataLoadState", false);
    }
  }
}

/**
 * @author: wyt
 * @description: 获取相同id的行列号数据
 * @export
 * @param {*} layerId 图层Id
 * @param {*} dataID 数据Id
 * @return {*}
 */
export function getAllSameIds(layerId, dataID) {
  var allIdData = TileData.filter(e => e.layerId == layerId);
  var newData = [];
  for (var j = 0; j < allIdData.length; j++) {
    if (allIdData[j].data.J != null) {
      var tempJ = convertData(
        allIdData[j].row,
        allIdData[j].col,
        allIdData[j].data,
        allIdData[j].geoType
      );
      var temp = tempJ.J;
      var data = temp.filter(
        ele => ele.G != null && ele.G.length > 0 && ele.O == dataID
      );
      if (data.length > 0) {
        var obj = {
          row: allIdData[j].row,
          col: allIdData[j].col,
          data: data
        };
        newData.push(obj);
      }
    }
  }
  return newData;
}

/**
 * @author: wyt
 * @description: 构造geometry
 * @param {*} data
 * @param {*} type 类型
 * @return {*}
 */
export function getGeometry(data, type) {
  var esriModule = store.state.esriModule;
  let geometry;
  if (type == "点") {
    geometry = new esriModule.Point({
      x: data[0][0][0],
      y: data[0][0][1],
      spatialReference: map.spatialReference
    });
  } else if (type == "线") {
    geometry = new esriModule.Polyline({
      paths: data,
      spatialReference: map.spatialReference
    });
  } else {
    geometry = new esriModule.Polygon({
      rings: data,
      spatialReference: map.spatialReference
    });
  }
  return geometry;
}

/**
 * @author: wyt
 * @description: 构造屏幕坐标的geometry
 * @param {*} data
 * @param {*} type 类型（点线面）
 * @return {*}
 */
export function getGeometryToScreen(data, type, symbol) {
  var esriModule = store.state.esriModule;
  let geometry;
  if (type == "点") {
    // if(symbol.RenderType === "UniqueRender"){
    // + symbol.offsetX
    // + symbol.offsetY
    // }
    geometry = new esriModule.Point({
      x: data[0][0][0],
      y: data[0][0][1]
    });
  } else if (type == "线") {
    geometry = new esriModule.Polyline({
      paths: data
    });
  } else {
    geometry = new esriModule.Polygon({
      rings: data
    });
    if (data[0].length < 4 && data[0].length > 1) {
      geometry = new esriModule.Polyline({
        paths: data
      });
    }
    if (data[0].length == 1) {
      geometry = new esriModule.Point({
        x: data[0][0][0],
        y: data[0][0][1]
      });
    }
  }
  return geometry;
}

/**
 * @author: wyt
 * @description: 创建选择图层（点线面）
 * @export
 */
export function createAllSelectLayer() {
  let pointLayer = map.getLayer("selectedLayer_point");
  let polylineLayer = map.getLayer("selectedLayer_polyline");
  let polygonLayer = map.getLayer("selectedLayer_polygon");
  if (!pointLayer) {
    createSelectLayer("selectedLayer", "point", "#00FFFF", "#00FFFF");
  }
  if (!polylineLayer) {
    createSelectLayer("selectedLayer", "polyline", "#00FFFF", "#00FFFF");
  }
  if (!polygonLayer) {
    createSelectLayer("selectedLayer", "polygon", "#00FFFF", "#00FFFF");
  }
}

/**
 * @author: wyt
 * @description: 创建选择图层
 * @export
 * @param {*} layerName 图层名
 * @param {*} type 类型（点线面）
 * @param {*} color 填充颜色
 * @param {*} lineColor 边框颜色
 * @return {*}
 */
export function createSelectLayer(layerName, type, color, lineColor) {
  let esriModule = store.state.esriModule;
  var geoType = type == "point" ? "点" : type == "polyline" ? "线" : "面";
  var symbol = getSelectedSymbol(type, color, lineColor);

  if (type == "polygon" && layerName == "selectedLayer") {
    symbol.color = new esriModule.Color([0, 0, 0, 0]);
  }
  var renderer = new esriModule.SimpleRenderer(symbol);
  var VectorCollection = getVectorCollection(geoType);
  let layer = map.getLayer(layerName + "_" + type);
  if (layer) {
    return layer;
  }
  var tmpLayer = new esriModule.FeatureLayer(VectorCollection, {
    id: layerName + "_" + type
  });
  map.addLayer(tmpLayer);
  tmpLayer.setRenderer(renderer);
  return tmpLayer;
}
/**
 * @author: wyt
 * @description: 添加要素至选择图层
 * @export
 * @param {*} graphics
 */
export function addGraphicToSelectLayer(graphics) {
  addGraphicToMapLayer(graphics, "selectedLayer", "#00FFFF", "#00FFFF");
}

/**
 * 添加要素至高亮图层
 * @param {*} graphics
 */
function addGraphicToHighlightLayer(graphics) {
  addGraphicToMapLayer(graphics, "highlightLayer", "green", "green");
}

/**
 * 清除高亮图层
 */
function clearHighlightLayer() {
  clearLayer("highlightLayer");
}

/**
 * 添加图层
 * @param {*} graphics
 * @param {*} layerName 图层名
 * @param {*} color 颜色
 * @param {*} fillColor 填充色
 */
function addGraphicToMapLayer(graphics, layerName, color, fillColor) {
  let esriModule = store.state.esriModule;

  function addtInterval(graphic, tmpLayer) {
    let interval = setInterval(function () {
      if (tmpLayer.loaded) {
        var gra = new esriModule.Graphic(
          graphic.geometry,
          null,
          graphic.attributes
        );
        tmpLayer.applyEdits([gra], null, null);
        clearInterval(interval);
      }
    }, 100);
  }
  for (var i = 0; i < graphics.length; i++) {
    var tmpLayer = map.getLayer(layerName + "_" + graphics[i].geometry.type);
    if (!tmpLayer) {
      tmpLayer = createSelectLayer(
        layerName,
        graphics[i].geometry.type,
        color,
        fillColor
      );
    }
    if (tmpLayer.loaded) {
      var gra = new esriModule.Graphic(
        graphics[i].geometry,
        null,
        graphics[i].attributes
      );
      tmpLayer.applyEdits([gra], null, null);
    } else {
      addtInterval(graphics[i], tmpLayer);
    }
  }
}

/**
 * 清除图层
 * @param {*} layerName 图层名
 */
function clearLayer(layerName) {
  var pointLayer = map.getLayer(layerName + "_point");
  var polylineLayer = map.getLayer(layerName + "_polyline");
  var polygonLayer = map.getLayer(layerName + "_polygon");
  if (pointLayer) {
    pointLayer.clear();
  }
  if (polylineLayer) {
    polylineLayer.clear();
  }
  if (polygonLayer) {
    polygonLayer.clear();
  }
}

/**
 * 临时图层清除要素（批量）
 * @param {*} graphics
 * @param {*} type 类型
 */
export function clearGraphicFromSelectLayer(graphics, type) {
  if (type == "all") {
    // 恢复绘制
    store.dispatch("setStopLoading", false);
    //全清除
    //清除选择tab的数据
    selectQueryData = {};
    store.commit("set_selectQueryData", []);
    store.commit("set_selectQueryPaginaData", []);
    clearLayer("selectedLayer");
  } else {
    let pointArr = [];
    let lineArr = [];
    let polygonArr = [];
    graphics.forEach(item => {
      switch (item.geometry.type) {
        case "point":
          pointArr.push(item);
          break;
        case "polygon":
          polygonArr.push(item);
          break;
        case "polyline":
          lineArr.push(item);
          break;
      }
    });
    if (pointArr.length > 0) {
      let pointLayer = map.getLayer("selectedLayer_point");
      pointLayer.applyEdits(null, null, pointArr);
    }
    if (polygonArr.length > 0) {
      let polygonLayer = map.getLayer("selectedLayer_polygon");
      polygonLayer.applyEdits(null, null, polygonArr);
    }
    if (lineArr.length > 0) {
      let polylineLayer = map.getLayer("selectedLayer_polyline");
      polylineLayer.applyEdits(null, null, lineArr);
    }
  }
}

/**
 * 临时图层要素显隐
 * @param {*} flag 是否显隐
 * @param {*} layerId 图层Id
 */
function showOrHideLayer(flag, layerId) {
  var pointLayer = map.getLayer("selectedLayer_point");
  var polylineLayer = map.getLayer("selectedLayer_polyline");
  var polygonLayer = map.getLayer("selectedLayer_polygon");
  if (pointLayer) {
    pointLayer.graphics.forEach(ele => {
      if (ele.attributes.selectLayer.layerId == layerId) {
        if (flag) {
          ele.show();
        } else {
          ele.hide();
        }
      }
    });
  }
  if (polylineLayer) {
    polylineLayer.graphics.forEach(ele => {
      if (ele.attributes.selectLayer.layerId == layerId) {
        if (flag) {
          ele.show();
        } else {
          ele.hide();
        }
      }
    });
  }
  if (polygonLayer) {
    polygonLayer.graphics.forEach(ele => {
      if (ele.attributes.selectLayer.layerId == layerId) {
        if (flag) {
          ele.show();
        } else {
          ele.hide();
        }
      }
    });
  }
}
/**
 * 选择的符号
 * @param {*} type 数据类型
 * @param {*} changeColor 主颜色
 * @param {*} lineColor 线颜色
 */
export function getSelectedSymbol(type, changeColor, lineColor) {
  var esriModule = store.state.esriModule;
  var color1 = new esriModule.Color("#00FFFF");
  var defaultsymbol;
  if (type == "point") {
    defaultsymbol = new esriModule.SimpleMarkerSymbol(
      esriModule.SimpleMarkerSymbol.STYLE_CIRCLE,
      10,
      new esriModule.SimpleLineSymbol(
        esriModule.SimpleLineSymbol.STYLE_SOLID,
        new esriModule.Color(lineColor),
        1
      ),
      new esriModule.Color(changeColor)
    );
  } else if (type == "polyline") {
    defaultsymbol = new esriModule.SimpleLineSymbol(
      esriModule.SimpleLineSymbol.STYLE_SOLID,
      new esriModule.Color(changeColor),
      2
    );
  } else {
    let line = new esriModule.SimpleLineSymbol(
      esriModule.SimpleLineSymbol.STYLE_SOLID,
      new esriModule.Color(lineColor),
      2
    );
    defaultsymbol = new esriModule.SimpleFillSymbol(
      esriModule.SimpleFillSymbol.STYLE_SOLID,
      line,
      new esriModule.Color(changeColor)
    );
  }
  return defaultsymbol;
}

/**
 * 获取选择的要素
 */
export function getSelectGraphics() {
  let selectedList = [];
  let pointLayer = map.getLayer("selectedLayer_point");
  let polylineLayer = map.getLayer("selectedLayer_polyline");
  let polygonLayer = map.getLayer("selectedLayer_polygon");
  if (pointLayer != undefined) {
    pointLayer.graphics.forEach(item => {
      selectedList.push(item);
    });
  }
  if (polylineLayer != undefined) {
    polylineLayer.graphics.forEach(item => {
      selectedList.push(item);
    });
  }
  if (polygonLayer != undefined) {
    polygonLayer.graphics.forEach(item => {
      selectedList.push(item);
    });
  }
  return selectedList;
}

/**
 * 点击取数据定位
 * @param {*} layerId 图层Id
 * @param {*} id 数据Id
 * @param {*} opType 类型
 */
export function locateFeaturesBySearch(layerId, id, opType) {
  let pageType = getPageType();
  // let esriModule = store.state.esriModule;
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  var type =
    layerInfo.GeoType == "点" ?
      "point" :
      layerInfo.GeoType == "线" ?
        "polyline" :
        "polygon";
  var layer;
  let newGra;
  if (opType == "select") {
    //重置二次选中符号
    layer = map.getLayer("selectedLayer_" + type);
    if (layer) {
      if (secondSelectGraphic.length > 0) {
        clearGraphicFromSelectLayer(secondSelectGraphic, type);
        secondSelectGraphic = [];
      }
    }
    let params = {
      ID: id,
      UserId: store.state.user.UserId,
      GDataId: layerInfo.GDataId,
      mapDocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1,
      type: pageType == 1 ? 1 : 0
    };
    GetSingleGeoDataFeature(params).then(res => {
      if (res.data) {
        let newGraphic = getFeatures(
          layerInfo.GeoType,
          [res.data],
          layerInfo.coordinate,
          layerId,
          layerInfo.GDataId
        );
        addGraphicToSelectLayer(newGraphic);
        newGra = newGraphic[0];
        locateGeo(layerInfo.GeoType, newGra);
        var sys = getSelectedSymbol(type, "yellow", "#00FFFF");
        layer = map.getLayer("selectedLayer_" + type);
        let interval = setInterval(function () {
          if (layer.loaded) {
            layer.graphics[0].setSymbol(sys);
            clearInterval(interval);
          }
        }, 100);
        secondSelectGraphic.push(newGra);
      }
    });
  } else {
    var current = store.state.tiledServiceQueryFeatureData.find(
      ele => ele.attributes.ID == id
    );
    addGraphicToHighlightLayer([current]);
    layer = map.getLayer("highlightLayer_" + type);
    var graphic = layer.graphics[0];
    setExtent(graphic);
    setTimeout(function () {
      clearHighlightLayer();
    }, 1000);
  }
}

/**
 * 定位
 * 点：1、在地图范围，不做操作；2、不在当前地图范围，则移动至中间；
 * 线面：1、在地图范围，不做操作；2、不在当前地图范围：
 * (1)判断extent长宽是否大于地图的extent长宽；若是，则取extent中间点；否则，直接setExtent
 * @param {*} type 数据类型
 * @param {*} gra graphic
 */
export function locateGeo(type, gra) {
  let esriModule = store.state.esriModule;
  let geometry = gra.geometry;
  let extent = map.extent;
  if (type == "点") {
    if (
      geometry.x < extent.xmin ||
      geometry.x > extent.xmax ||
      geometry.y < extent.ymin ||
      geometry.y > extent.ymax
    ) {
      map.centerAt(geometry);
    }
  } else {
    let gextent = geometry.getExtent();
    var flag =
      gextent.xmin >= extent.xmin &&
      gextent.xmax <= extent.xmax &&
      gextent.ymin >= extent.ymin &&
      gextent.ymax <= extent.ymax;
    if (
      !(
        gextent.xmin >= extent.xmin &&
        gextent.xmax <= extent.xmax &&
        gextent.ymin >= extent.ymin &&
        gextent.ymax <= extent.ymax
      )
    ) {
      let diffx = gextent.xmax - gextent.xmin;
      let diffy = gextent.ymax - gextent.ymin;
      if (
        diffx > extent.xmax - extent.xmin ||
        diffy > extent.ymax - extent.ymin
      ) {
        let center_x = (gextent.xmax + gextent.xmin) / 2;
        let center_y = (gextent.ymax + gextent.ymin) / 2;
        let point = new esriModule.Point(
          center_x,
          center_y,
          map.spatialReference
        );
        map.centerAndZoom(point, 6);
      } else {
        isLocatePosition = "locatePosition";
        setExtent(gra);
      }
    }
  }
}

/**
 * 取消二次选中
 */
export function cancelSecondSelected() {
  var cnColor = "#00FFFF";
  for (let i = 0; i < secondSelectGraphic.length; i++) {
    if (secondSelectGraphic[i].geometry.type == "polygon")
      cnColor = [0, 0, 0, 0];
    var symbol = getSelectedSymbol(
      secondSelectGraphic[i].geometry.type,
      cnColor,
      "#00FFFF"
    );
    secondSelectGraphic[i].setSymbol(symbol);
    secondSelectGraphic.splice(i, 1);
    i--;
  }
}

//
/**
 * f符号渲染->重置canvas绘制符号
 * @param {*} layerId 图层Id
 */
export function resetCanvasSymbol(layerId) {
  if (!isShowLayer(layerId)) {
    return;
  }

  //清除缓存
  TileCanvasCache = TileCanvasCache.filter(ele => ele.layerId != layerId);
  ChangedCanvasCache = ChangedCanvasCache.filter(ele => ele.layerId != layerId);

  //清除对应canvas
  var canvasCtn = document.getElementsByClassName('gispaiLayer_' + layerId);
  if (canvasCtn && canvasCtn.length > 0) {
    canvasCtn[0].innerHTML = "";
  }
  //绘制数据库数据，并对现有的切片canvas进行纠偏
  drawChangedData(layerId);
  var layerTileData = TileData.filter(x => x.layerId == layerId)
  for (var i = 0; i < layerTileData.length; i++) {
    startDraw(
      layerTileData[i].row,
      layerTileData[i].col,
      layerTileData[i].offset,
      layerTileData[i].data,
      layerId,
      "redraw",
      0
    );
  }
}

/**
 * 属性修改->重置canvas绘制符号
 * @param {*} layerId 图层Id
 * @param {*} attr 属性数据
 */
export function resetCanvasSymbolByAttr(layerId, attr) {
  var nwTileData = TileData.filter(ele => ele.layerId == layerId);
  var index = -1;
  var data;
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  let layerSym = JSON.parse(layerInfo.Symbol);
  var isRender = false;
  if (layerSym.hasOwnProperty("FieldName")) {
    isRender = true;
  }
  for (var i = 0; i < nwTileData.length; i++) {
    if (nwTileData[i].data.J) {
      for (var j = 0; j < nwTileData[i].data.J.length; j++) {
        index = nwTileData[i].data.J.findIndex(ele => ele.O == attr.ID);
        if (index > -1) {
          if (isRender) {
            if (getPageType() == 0) {
              nwTileData[i].data.J[index].A = attr[layerSym.FieldName];
            } else {
              var temp = layerSym.Symbols;
              var symIndex = layerSym.Symbols.findIndex(
                ele => ele.Value == attr[layerSym.FieldName]
              );
              if (index > -1) {
                nwTileData[i].data.J[index].A = symIndex + 1;
              } else {
                nwTileData[i].data.J[index].A = 1;
              }
            }
          }
          data = nwTileData[i];
          break;
        }
      }
    }
  }
  // if (layerInfo.GeoType == "点") {
  //   var ele = document.getElementById(layerId + "_point_changed");
  //   var ctx = ele.getContext("2d");
  //   ctx.clearRect(0, 0, ele.width, ele.height);
  //   for (var i = 0; i < nwTileData.length; i++) {
  //     var newd = convertData(nwTileData[i].row,
  //       nwTileData[i].col,
  //       nwTileData[i].data, layerInfo.GeoType);
  //     startDrawPoint(
  //       nwTileData[i].row,
  //       nwTileData[i].col,
  //       newd, [],
  //       nwTileData[i].layerId,
  //       "redraw",
  //       0
  //     );
  //   }
  // } else {
  if (data) {
    //移除
    var canvasCtn = document.getElementsByClassName("gispaiLayer");
    if (canvasCtn && canvasCtn.length > 0) {
      for (var i = 0; i < canvasCtn.length; i++) {
        if (canvasCtn[i].attributes.targetType.value == "data") {
          var ids = canvasCtn[i].id.split("_");
          if (canvasCtn[i].id.indexOf("_changed") == -1) {
            if (ids[0] == layerId && data.row == ids[1] && data.col == ids[2]) {
              canvasCtn[i].remove();
              i = i - 1;
            }
          }
        }
      }
    }
    startDraw(
      data.row,
      data.col,
      data.offset,
      data.data,
      data.layerId,
      "redraw",
      0
    );
  }

  // }
  //重绘变化的数据
  ChangedCanvasCache = ChangedCanvasCache.filter(ele => ele.Id != layerId);
  getChangedData(layerId, "redraw");
}

/**
 * 转换地图extent坐标
 * @param {*} coordinate 坐标系
 */
export function convertMapExtent(coordinate) {
  let esriModule = store.state.esriModule;
  var extent = map.extent;
  var coor = mapCoordinate; //map.spatialReference.wkid

  let xmin = map.extent.xmin
  let xmax = map.extent.xmax
  let ymin = map.extent.ymin
  let ymax = map.extent.ymax

  if (coor == 4490 || coor == 4326) {
    if (xmin < -180 && xmin > -1000)
      xmin = -179
    if (xmax < 1000 && xmax > 180)
      xmax = 179

    if (ymin < -90 && ymin > -1000)
      ymin = -89
    if (ymax < 1000 && ymax > 90)
      ymax = 89

  }
  var geo1 = new esriModule.Point({
    x: xmin,
    y: ymin,
    spatialReference: coor
  });
  var geo2 = new esriModule.Point({
    x: xmax,
    y: ymax,
    spatialReference: coor
  });
  if (!coordinate) {
    return null;
  }
  var newGeo1 = TconvertLngLat(coordinate, geo1);
  var newGeo2 = TconvertLngLat(coordinate, geo2);
  if (newGeo1 == null || newGeo2 == null) {
    return null;
  }

  if (newGeo2.x < 0) {

    newGeo2.x = -newGeo2.x;

  }

  extent = {
    xmin: newGeo1.x,
    xmax: newGeo2.x,
    ymin: newGeo1.y,
    ymax: newGeo2.y
  };
  return extent;
}

/**
 *
 * @param {*} data
 */
export async function attrSelect(data) {
  store.commit("set_selectQueryState", true);
  clearGraphicFromSelectLayer([], "all");
  //清除查询tab的数据、状态
  store.commit("set_tiledServiceQueryState", false);
  store.commit("set_isResetTableSelected", true);
  var vectorData = getVetorLayerNode(store.state.dataTreeData);
  store.commit("set_selectedLayerData", []);
  var pageType = getPageType();
  for (var i = 0; i < data.length; i++) {
    var dataIds = [...new Set(data[i].ids)];
    var layerId = data[i].layerId;
    var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
    var geoType = layerInfo.GeoType;
    var gDataId = layerInfo.GDataId;
    var coordinate = layerInfo.coordinate;
    // var node = vectorData.find(ele => ele.id == layerId)
    // var isInS = isInScale(layerId);
    var paginaData = store.state.selectQueryPaginaData; //分页的id
    paginaData.push({
      layerId: layerId,
      ids: dataIds
    });
    var pagesData = store.state.selectedPagination.find(
      ele => ele.layerId == layerId
    );
    if (!pagesData) {
      pagesData = {
        layerId: layerId,
        pageSize: 20,
        currentPage: 1
      };
    }
    var newSelectedData = pagination(
      dataIds,
      pagesData.currentPage,
      pagesData.pageSize,
      dataIds.length
    );
    let params = {
      iDs: dataIds, //newSelectedData,
      userId: store.state.user.UserId,
      gDataId: gDataId,
      mapDocId: pageType == 1 ? store.state.SingleData.MapDocs.ID : -1,
      type: pageType == 1 ? 1 : 0
    };
    await getGeoDataFeatureBatch(params).then(res => {
      if (res.data.length > 0) {
        var features = getFeatures(
          geoType,
          res.data,
          coordinate,
          layerId,
          gDataId
        );
        addGraphicToSelectLayer(features);
      }
      var selectQueryData = store.state.selectQueryData;
      var obj = {
        name: layerInfo.LayerAliasName,
        layerId: layerId,
        num: dataIds.length,
        list: dataIds,
        // type: isInS == true ? "virtual" : "reality",
        type: "virtual",
        pageSize: pagesData.pageSize,
        currentPage: pagesData.currentPage,
        selectType: "attribute"
      };

      selectQueryData.push(obj);
      store.commit("set_selectQueryData", selectQueryData);
    });
  }
}

/**
 * 重置数据图层canvas的顺序
 */
export function reorderCanvasLayer() {
  var vNodes = getVetorLayerNode(store.state.dataTreeData);
  var baseList = store.state.baseTreeData[0].children;
  vNodes = vNodes.reverse();
  for (var i = 0; i < vNodes.length; i++) {
    var id = vNodes[i].id;
    var ele = document.getElementsByClassName("gispaiLayer_" + id);
    if (ele.length > 0) {
      ele[0].style.zIndex = i + 5 + baseList.length;
      //label图层
      var labelCtn = document.getElementById("gispaiLayer_labelLayer_" + id);
      if (labelCtn) {
        ele[0].after(labelCtn);
        labelCtn.style.zIndex = i + 5 + baseList.length;
      }
    }
  }
  // 选择图层
  var canvasCtn = document.querySelector(".gispaiLayer_selected");
  var div = document.querySelector("#mapView_gc");
  if (canvasCtn) {
    div.before(canvasCtn);
    canvasCtn.style.zIndex = vNodes.length + baseList.length;
  }
  //高亮图层
  var hCtn = document.querySelector(".gispaiLayer_selected");
  if (hCtn) {
    div.before(hCtn);
    hCtn.style.zIndex = vNodes.length + 5 + baseList.length;
  }
}
/**
 * 拾取图层canvas顺序
 * @param {*} name 类名
 */
export function reorderPickedLayer(name) {
  var canvasCtn = document.querySelector(".gispaiLayer_" + name);
  var vNodes = getVetorLayerNode(store.state.dataTreeData);
  var baseList = store.state.baseTreeData[0].children;
  var div = document.querySelector("#mapView_gc");
  if (canvasCtn) {
    div.before(canvasCtn);
    canvasCtn.style.zIndex = vNodes.length + 5 + baseList.length;
  }
}


/**
 * canvas偏移操作,  移除超出canvas和修改还在屏幕内canvas的偏移量
 * @param {*} name 类名
 */
function resetPickedCanvasByDrag(name) {

  var rowcol = getRowCol(map.extent);
  var ctnelement = document.getElementsByClassName(name + "Layer");
  setLayerClass(ctnelement, rowcol);
  for (var i = rowcol.minRow; i <= rowcol.maxRow; i++) {
    for (var j = rowcol.minCol; j <= rowcol.maxCol; j++) {
      var offset = getCoordByRowCol(i, j);
      var index = TileCanvasCache.findIndex(ele => {
        return ele.row == i && ele.col == j;
      });
      if (index > -1) {
        TileCanvasCache[index].cacheCanvas.style.left = offset.offsetX + "px";
        TileCanvasCache[index].cacheCanvas.style.top = offset.offsetY + "px";
      }
    }
  }
}

// 移除超出canvas和修改还在屏幕内canvas的偏移量
function setLayerClass(ctnelement, rowcol) {
  if (ctnelement && ctnelement.length > 0) {
    var ele = ctnelement;
    for (var k = 0; k < ele.length; k++) {
      if (ele[k].id.indexOf("changed") == -1) {
        var ids = ele[k].id.split("_");
        var eRow = parseInt(ids[1]);
        var eCol = parseInt(ids[2]);
        //超出屏幕范围移除
        if (
          eRow < rowcol.minRow ||
          eRow > rowcol.maxRow ||
          eCol < rowcol.minCol ||
          eCol > rowcol.maxCol
        ) {
          ele[k].remove();
          k = k - 1;
          //删除超出范围的缓存
          var index = TileCanvasCache.findIndex(ele => {
            return ele.row == eRow && ele.col == eCol;
          });
          if (index > -1) {
            TileCanvasCache.splice(index, 1);
          }
        } else if (
          eRow >= rowcol.minRow &&
          eRow <= rowcol.maxRow &&
          eCol >= rowcol.minCol &&
          eCol <= rowcol.maxCol
        ) {
          var offset = getCoordByRowCol(eRow, eCol);
          ele[k].style.left = offset.offsetX + "px";
          ele[k].style.top = offset.offsetY + "px";
        }
      }
    }
  }
}


/**
 * @author: wyt
 * @description: 清空点切片数据
 * @param {*} layerId 图层Id
 */
export function clearPointCanvas(layerId) {
  var ele = document.getElementById(layerId + "_point_changed");
  if (ele) {
    var ctx = ele.getContext("2d");
    ctx.clearRect(0, 0, ele.width, ele.height);
  }
}

/**
 * @author: wyt
 * @description: 添加全局数据
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} data 数据
 * @param {*} geoType 数据类型
 * @param {*} layerId 图层Id
 */
function setTileData(row, col, data, geoType, layerId) {
  var offset = getCoordByRowCol(row, col);
  var obj = {
    layerId: layerId,
    geoType: geoType,
    data: data,
    row: row,
    col: col,
    offset: offset
  };
  TileData.push(obj);
}

/**
 * @author: wyt
 * @description:创建canvas
 * @param {*} name 类名后缀(Selected或highlight)
 * @param {*} mouseType 操作类型（drag、scale等）
 */
export function createCanvas(name, mouseType, dataType) {
  var div = document.querySelector("#mapView_gc");
  if (div == null) return;
  var canvasCtn = document.querySelector(".gispaiLayer_" + name);
  if (!canvasCtn) {
    canvasCtn = document.createElement("div");
    canvasCtn.className = "gispaiLayer_" + name + " gsplayer";
    canvasCtn.style.position = "absolute";
    div.before(canvasCtn);
  } else {
    if (mouseType == "drag") {
      //删除数据库数据对应的canvas
      var ele1 = document.getElementById(name + "_point_changed");
      var ele2 = document.getElementById(name + "_changed");
      if (ele1) ele1.remove();
      if (ele2) ele2.remove();
    } else if (mouseType != "selectedTool") {
      canvasCtn.innerHTML = "";
    }
  }
  //行列canvas
  var rowcol = getRowCol(map.extent);
  for (var i = rowcol.minRow; i <= rowcol.maxRow; i++) {
    for (var j = rowcol.minCol; j <= rowcol.maxCol; j++) {
      var offset = getCoordByRowCol(i, j);
      var ele = document.getElementById(name + "_" + i + "_" + j);
      if (!ele) {
        ele = document.createElement("canvas");
        ele.className = name + "Layer";
        ele.style.left = offset.offsetX + "px";
        ele.style.top = offset.offsetY + "px";
        ele.setAttribute("id", name + "_" + i + "_" + j);
        ele.width = 256;
        ele.height = 256;
        ele.style.position = "absolute";
        canvasCtn.append(ele);
      }
      var pointEle = document.getElementById(
        name + "_" + i + "_" + j + "_point"
      );
      if (!pointEle) {
        pointEle = document.createElement("canvas");
        pointEle.className = name + "Layer";
        pointEle.style.left = offset.offsetX - pointSpace + "px";
        pointEle.style.top = offset.offsetY - pointSpace + "px";
        pointEle.setAttribute("id", name + "_" + i + "_" + j + "_point");
        pointEle.width = pointCanvasWidth;
        pointEle.height = pointCanvasWidth;
        pointEle.style.position = "absolute";
        canvasCtn.append(pointEle);
      }
      var lineEle = document.getElementById(
        name + "_" + i + "_" + j + "_line"
      );
      if (!lineEle) {
        lineEle = document.createElement("canvas");
        lineEle.className = name + "Layer";
        lineEle.style.left = offset.offsetX - pointSpace + "px";
        lineEle.style.top = offset.offsetY - pointSpace + "px";
        lineEle.setAttribute("id", name + "_" + i + "_" + j + "_line");
        lineEle.width = pointCanvasWidth;
        lineEle.height = pointCanvasWidth;
        lineEle.style.position = "absolute";
        canvasCtn.append(lineEle);
      }

    }
  }

  //全地图canvas
  var canvas = document.getElementById(name + "_changed");
  if (!canvas) {
    canvas = document.createElement("canvas");
    var pdiv = document.querySelector("#mapView");
    canvas.id = name + "_changed";
    canvas.className = name + "Layer" + " changedCanvas";
    canvas.width = pdiv.clientWidth;
    canvas.height = pdiv.clientHeight;
    canvas.style.position = "absolute";
    canvas.style.left = "0px";
    canvas.style.top = "0px";
    canvasCtn.append(canvas);
  }

  // //点canvas
  // var pcanvas = document.getElementById(name + "_point_changed");
  // if (!pcanvas) {
  //   var rowcol = getRowCol(map.extent);
  //   // createPointCanvas(canvasCtn, rowcol, name, name);
  // }
}

/**
 * @author: wyt
 * @description:创建点数据canvas
 * @param {*} canvasCtn 包裹的div
 * @param {*} rowcol 行列号
 * @param {*} className 类名
 * @param {*} idName id名称
 */
export function createPointCanvas(canvasCtn, rowcol, className, idName) {
  var offset = getCoordByRowCol(rowcol.maxRow, rowcol.minCol);
  var allCol = rowcol.maxCol - rowcol.minCol + 1;
  var allRow = rowcol.maxRow - rowcol.minRow + 1;
  var pcanvas = document.createElement("canvas");
  pcanvas.className = className + "Layer";
  pcanvas.style.left = offset.offsetX + "px";
  pcanvas.style.top = offset.offsetY + "px";
  pcanvas.setAttribute("id", idName + "_point_changed");
  pcanvas.width = 256 * allCol;
  pcanvas.height = 256 * allRow;
  pcanvas.style.position = "absolute";
  if (canvasCtn) {
    canvasCtn.append(pcanvas);
  }
  return pcanvas;
}

/**
 * @author: wyt
 * @description:清除选择的canvas
 * @param {*} name canvas类名前缀
 */
export function clearSelectCanvas(name) {
  var ele = document.getElementsByClassName(name + "Layer");
  if (ele.length > 0) {
    for (var i = 0; i < ele.length; i++) {
      var ctx = ele[i].getContext("2d");
      ctx.clearRect(0, 0, ele[i].width, ele[i].height);
    }
  }
}

/**
 * @author: wyt
 * @description:清除选择图层的全屏canvas
 */
export function clearSelectCanvasByType() {
  var ele = document.getElementById("selected_changed");
  if (ele) {
    var ctx = ele.getContext("2d");
    ctx.clearRect(0, 0, ele.width, ele.height);
  }
}

/**
 * @author: wyt
 * @description:清除选中的canvas
 * @param {*} type 类型
 */
export function clearAllSelectCanvas(type) {
  let ele = document.getElementById("selected_changed");
  if (ele) {
    var ctx = ele.getContext("2d");
    ctx.clearRect(0, 0, ele.width, ele.height);
  }
  // if (type == "点") {
  //   let ele = document.getElementById("selected_point_changed");
  //   if (ele) {
  //     let ctx = ele.getContext("2d");
  //     ctx.clearRect(0, 0, ele.width, ele.height);
  //   }
  // } else {
  let ele2 = document.getElementsByClassName("selectedLayer");
  for (var i = 0; i < ele2.length; i++) {
    if (ele2[i].id.indexOf("changed") == -1) {
      let ctx = ele2[i].getContext("2d");
      ctx.clearRect(0, 0, ele2[i].width, ele2[i].height);
    }
  }
  // }
}
/**
 * @author: wyt
 * @description:绘制选择的数据（数据库变化的数据）
 * @param {*} newData 待绘制数据
 * @param {*} canvas
 * @param {*} layerId 图层Id
 */
export function drawOnCanvasByChangeData(data, canvas, layerId) {
  if (!isInScale(layerId) || !commonB.isLayerSelect(layerId)) {
    return;
  }
  // for(var m=0;m<notDrawIDs.length;m++){
  //   if(data.Attr.ID == notDrawIDs[m]){
  //     return
  //   }
  // }
  // console.log(data,'绘制')
  let esriModule = store.state.esriModule;
  var context = canvas.getContext("2d");
  var layerInfo = store.state.allLayerData.find(ele => ele.Id == layerId);
  let layerSym = JSON.parse(layerInfo.Symbol);
  var symbol = layerInfo.Symbol != "" ? JSON.parse(layerInfo.Symbol) : "";
  var isRender = false;
  if (layerSym.hasOwnProperty("FieldName")) {
    isRender = true;
  }
  let style = {};
  if (!isRender) {
    style = commonB.newGetCanvasStyle(layerInfo, "", symbol);
    var rings = data.Shape;
    context.beginPath();
    if (layerInfo.GeoType === "线") {
      if (style.set.lineStyles && style.set.lineStyles.length) {
        style.set.lineStyles.forEach(item => {
          drawPickup(rings, esriModule, layerInfo, context, item, canvas)
        });
      } else {
        drawPickup(rings, esriModule, layerInfo, context, style, canvas)
      }
    } else {
      drawPickup(rings, esriModule, layerInfo, context, style, canvas)
    }
  } else {
    // var attributes = data.attr;
    commonB
      .getUniRenderLabelVals(layerId, [data], layerSym.FieldName, "Attribute")
      .then(res => {
        var keys = Object.keys(res);
        let index = keys.findIndex(key => key === data.Attr.ID + "");
        var attrValue = res[keys[index]];
        style = getAttrStyle(layerInfo, attrValue, symbol);
        var rings = data.Shape;
        context.beginPath();
        if (layerInfo.GeoType === "线") {
          if (style.set.lineStyles && style.set.lineStyles.length) {
            style.set.lineStyles.forEach(item => {
              drawUniRenderPickup(rings, esriModule, layerInfo, context, item, canvas)
            })
          } else {
            drawUniRenderPickup(rings, esriModule, layerInfo, context, style, canvas)
          }
        } else {
          drawUniRenderPickup(rings, esriModule, layerInfo, context, style, canvas)
        }
      });
  }
}

async function drawUniRenderPickup(rings, esriModule, layerInfo, context, style, canvas) {
  for (var j = 0; j < rings.length; j++) {
    var single = rings[j];
    for (var k = 0; k < single.length; k++) {
      var point = new esriModule.Point(
        single[k][0],
        single[k][1],
        map.spatialReference
      );
      var screenPoint = map.toScreen(point);
      var x = screenPoint.x;
      var y = screenPoint.y;
      if (layerInfo.GeoType === "点") {
        if (style.set.url) {
          context.fillStyle = "#00FFFF";
          context.arc(
            x + cacheImageOffset,
            y + cacheImageOffset,
            style.set.width / 2,
            0,
            Math.PI * 2
          );
          context.fill();
        } else {
          var _style = commonB.deepClone(style);
          _style.set.color = "#00FFFF";
          pointCtx.ctx.iconFont(
            canvas,
            pointCtx.ctx.iconFontStyle(_style, x, y)
          );
        }
      } else {
        if (k == 0) {
          context.moveTo(x, y);
          if (layerInfo.GeoType === "线") {
            lastLineCoordinate = [x, y]
            commonB.initLineSymbol(x, y)
          }
        } else {
          context.lineTo(x, y);
          if (layerInfo.GeoType === "线") {
            commonB.drawChangeLineSymbol(x, y, style, "", canvas, "#00FFFF", context, "", "pickup");
          }
        }
      }
    }
    setCanvasPicked(layerInfo.GeoType, context, style);
  }
}

async function drawPickup(rings, esriModule, layerInfo, context, style, canvas) {
  if (!rings)
    return
  for (var j = 0; j < rings.length; j++) {
    var single = rings[j];
    for (var k = 0; k < single.length; k++) {
      var point = new esriModule.Point(
        single[k][0],
        single[k][1],
        map.spatialReference
      );
      var screenPoint = map.toScreen(point);
      var x = screenPoint.x;
      var y = screenPoint.y;
      if (layerInfo.GeoType === "点") {
        if (style.set.url) {
          context.fillStyle = "#00FFFF";
          context.arc(
            x + cacheImageOffset,
            y + cacheImageOffset,
            style.set.width / 2,
            0,
            Math.PI * 2
          );
          context.fill();
        } else {
          var _style = commonB.deepClone(style);
          _style.set.color = "#00FFFF";
          pointCtx.ctx.iconFont(
            canvas,
            pointCtx.ctx.iconFontStyle(_style, x, y)
          );
        }
      } else {
        if (k == 0) {
          context.moveTo(x, y);
          if (layerInfo.GeoType === "线") {
            lastLineCoordinate = [x, y]
            commonB.initLineSymbol(x, y)
          }
        } else {
          context.lineTo(x, y);
          if (layerInfo.GeoType === "线") {
            commonB.drawChangeLineSymbol(x, y, style, "", canvas, "#00FFFF", context, "", "pickup");
            // commonB.cacheDrawChangeLineSymbol(x, y, style, canvas, "", "#00FFFF", "", context);
          }
        }
      }
    }
    setCanvasPicked(layerInfo.GeoType, context, style);
  }
}
/**
 * @author: wyt
 * @description:转屏幕坐标
 * @param {*} geometry
 * @param {*} row 行号
 * @param {*} col 列号
 */
export function convertToScreen(geometry, row, col) {
  let esriModule = store.state.esriModule;
  var arr = [];
  var geo;
  // var rowcol = getRowCol(map.extent);
  if (geometry.type == "polygon") {
    var rings = geometry.rings;
    rings.forEach(ele => {
      var ringsArr = [];
      ele.forEach(item => {
        let point = new esriModule.Point(item[0], item[1]);
        var px = getPixelOnRowCol(point, row, col);
        ringsArr.push([px.x, px.y]);
      });
      arr.push(ringsArr);
    });
    geo = new esriModule.Polygon({
      rings: arr,
      spatialReference: map.spatialReference
    });
  } else if (geometry.type == "polyline") {
    var rings = geometry.paths;
    rings.forEach(ele => {
      var ringsArr = [];
      ele.forEach(item => {
        let point = new esriModule.Point(item[0], item[1]);
        var px = getPixelOnRowCol(point, row, col);
        ringsArr.push([px.x, px.y]);
      });
      arr.push(ringsArr);
    });

    geo = new esriModule.Polyline({
      paths: arr,
      spatialReference: map.spatialReference
    });
  }
  return geo;
}

/**
 * @author: wyt
 * @description:重绘选择canvas
 * @param {*} type 类型（vector、screen）
 * @param {*} data 待绘制数据
 * @param {*} layerId
 * @param {*} row 行号
 * @param {*} col 列号
 * @param {*} geoType 数据类型
 */
export function redrawSelectedCanvas(type, data, layerId, row, col, geoType) {
  var selected = selectedIdData.find(ele => ele.layerId == layerId);
  let allNode = getVetorLayerNode(store.state.dataTreeData);
  let node = allNode.find(ele => ele.id == layerId);
  let info = store.state.allLayerData.find(ele => ele.Id == layerId);
  let flag = getChecked(node, info);
  if (selected) {
    if (type == "vector") {
      var canvas = document.getElementById("selected_changed");
      if (selected.ids.indexOf(data.Attr.ID) > -1) {
        let selectId = selectedAllData.findIndex(
          x =>
            x.layerId == layerId && x.Id == data.Attr.ID && x.type == "vector"
        );
        if (selectId > -1) {
          selectedAllData[selectId].data = data;
        } else {
          var jdata = {
            layerId: layerId,
            Id: data.Attr.ID,
            geoType: geoType,
            data: data,
            type: "vector"
          };
          selectedAllData.push(jdata);
        }
        if (flag) {
          drawOnCanvasByChangeData(data, canvas, layerId);
        }
      }
    } else {
      if (selected.ids.indexOf(data.O) > -1) {
        let selectId = selectedAllData.findIndex(
          x => x.layerId == layerId && x.Id == data.O && x.type == "screen"
        );
        let temp;
        if (geoType == "点") {
          //此坐标为转换后的屏幕坐标，存为全局，坐标要转回去
          var allrowcol = getRowCol(map.extent);
          var jdata = JSON.parse(JSON.stringify(data));
          // jdata.G[0][0][0] = jdata.G[0][0][0] - 256 * (col - allrowcol.minCol);
          // jdata.G[0][0][1] = jdata.G[0][0][1] - 256 * (allrowcol.maxRow - row);
          // jdata.G[0][0][0] = jdata.G[0][0][0];
          // jdata.G[0][0][1] = jdata.G[0][0][1];
          temp = jdata;
        } else {
          temp = data;
        }
        let obj = {
          row: row,
          col: col,
          data: [temp]
        };
        if (selectId > -1) {
          selectedAllData[selectId].data.push(obj);
        } else {
          var jdata = {
            layerId: layerId,
            Id: data.O,
            geoType: geoType,
            data: [obj], //newData,
            type: "screen"
          };
          selectedAllData.push(jdata);
        }
        let newData = [{
          row: row,
          col: col,
          data: [data]
        }];
        if (flag) {
          redrawData(layerId, newData, "selected");
        }
      }
    }
  }
}

/**
 * @author: wyt
 * @description:选择canvas的显隐
 * @param {*} isShow 是否显隐
 * @param {*} type 树形节点类型
 */
function isShowSelectedCanvas(isShow, type) {
  var ele = document.querySelector(".gispaiLayer_selected");
  let tree3 = store.state.dataTreeData;
  if (type == "dataLayer") {
    if (isShow) {
      if (ele) {
        ele.style.display = "block";
      }
    } else {
      if (ele) {
        ele.style.display = "none";
      }
    }
  } else {
    var canvas = document.getElementById("selected_changed");
    var vectorData = getVetorLayerNode(store.state.dataTreeData);
    clearSelectCanvas("selected");
    var allrowcol = getRowCol(map.extent);
    for (var i = 0; i < vectorData.length; i++) {
      var layerInfo = store.state.allLayerData.find(
        ele => ele.Id == vectorData[i].id
      );
      //判断是否勾选
      let flag = getChecked(vectorData[i], layerInfo);
      if (flag) {
        var selectedData = selectedAllData.filter(
          x => x.layerId == vectorData[i].id
        );
        selectedData.forEach(ele => {
          if (ele.type == "vector") {
            drawOnCanvasByChangeData(ele.data, canvas, vectorData[i].id);
          } else {
            //256*256行列号的点转换为全屏行列号下的点位置
            var idDatas = getScreenPoint(
              ele.data,
              layerInfo.GeoType,
              allrowcol
            );
            redrawData(vectorData[i].id, idDatas, "selected");
          }
        });
      }
    }
  }
}

/**
 * @author: wyt
 * @description:屏行列->点坐标转屏幕坐标
 * @param {*} data 待转换的数据
 * @param {*} type 数据类型（点线面）
 * @param {*} allrowcol 当前范围的行列号
 */
function getScreenPoint(data, type, allrowcol) {
  var idDatas = [];
  if (type == "点") {
    data.forEach(item => {
      var jdata = JSON.parse(JSON.stringify(item.data[0]));
      // jdata.G[0][0][0] = jdata.G[0][0][0] + 256 * (item.col - allrowcol.minCol);
      // jdata.G[0][0][1] = jdata.G[0][0][1] + 256 * (allrowcol.maxRow - item.row);
      idDatas.push({
        row: item.row,
        col: item.col,
        data: [jdata]
      });
    });
  } else {
    idDatas = data;
  }
  return idDatas;
}

/**
 * @author: wyt
 * @description:选择图层清除要素
 * @param {*} graphics
 * @param {*} type 数据类型
 */
export function clearCanvasFromSelect(graphics, type) {
  if (type == "all") {
    //全清除
    //清除选择tab的数据
    selectQueryData = {};
    store.commit("set_selectQueryData", []);
    store.commit("set_selectQueryPaginaData", []);
    selectedIdData = []; //选中的Ids
    selectedAllData = []; //选中的全部数据
    clearSelectCanvas("selected");
  } else {
    let pointArr = [];
    let lineArr = [];
    let polygonArr = [];
    graphics.forEach(item => {
      switch (item.geometry.type) {
        case "point":
          pointArr.push(item);
          break;
        case "polygon":
          polygonArr.push(item);
          break;
        case "polyline":
          lineArr.push(item);
          break;
      }
    });
    if (pointArr.length > 0) {

      let pointLayer = map.getLayer("selectedLayer_point");
      pointLayer.applyEdits(null, null, pointArr);
    }
    if (polygonArr.length > 0) {
      let polygonLayer = map.getLayer("selectedLayer_polygon");
      polygonLayer.applyEdits(null, null, polygonArr);
    }
    if (lineArr.length > 0) {
      let polylineLayer = map.getLayer("selectedLayer_polyline");
      polylineLayer.applyEdits(null, null, lineArr);
    }
  }
}

/**
 * @author: wyt
 * @description:将选中的数据添加到全局变量中
 * @param {*} selectedData 选中的数据
 */
export function addDataToSelectedData(selectedData) {

  var selectIds = [];
  selectedData.forEach(ele => {
    var allIndex = selectedAllData.findIndex(
      item => item.layerId == ele.layerId
    );
    let layerInfo = store.state.allLayerData.find(x => x.Id == ele.layerId);
    if (allIndex == -1) {
      selectedAllData.push(ele);
    }
    var index = selectedIdData.findIndex(item => item.layerId == ele.layerId);
    if (index > -1) {
      if (selectedIdData[index].ids.indexOf(ele.Id) == -1) {
        selectedIdData[index].ids.push(ele.Id);
      }
    } else {
      selectedIdData.push({
        layerId: ele.layerId,
        ids: [ele.Id]
      });
    }

    let canvas = document.getElementById("selected_changed");
    if (ele.type == "vector") {
      //数据库数据绘制
      drawOnCanvasByChangeData(ele.data, canvas, ele.layerId);
    } else {
      //行列号数据绘制
      redrawData(layerInfo.Id, ele.data, "selected");
    }
    selectIds.push(ele.Id);
    settingPagination(layerInfo, selectIds);
  });
}

/**
 * @author: wyt
 * @description:编辑过程重绘切片数据操作
 * @param {*} arr  删掉的行列号数据
 */
export function resetSelectCanvasByEdit(arr) {
  var temp = selectedAllData.filter(ele => ele.type == "screen");
  var data = [];
  if (temp.length == 0) {
    data = arr;
  } else {
    data = _.differenceWith(temp, arr, _.isEqual);
  }
  // var index = data.findIndex(ele => ele.geoType == "点");
  // var oindex = data.findIndex(ele => ele.geoType != "点");
  // if (index > -1) {
  //   var ele = document.getElementById("selected_point_changed");
  //   if (ele) {
  //     var ctx = ele.getContext("2d")
  //     ctx.clearRect(0, 0, ele.width, ele.height);
  //   }
  // }
  // if (oindex > -1) {
  var ele = document.getElementsByClassName("selectedLayer");
  if (ele.length > 0) {
    for (var i = 0; i < ele.length; i++) {
      if (ele[i].id.indexOf("_changed") === -1) {
        var ctx = ele[i].getContext("2d");
        ctx.clearRect(0, 0, ele[i].width, ele[i].height);
      }
    }
  }
  // }
  //重绘切片数据
  // redrawCanvasByOperation(arr);
  redrawSplice(arr);
}
/**
 * //重绘选中的切片数据
 * @param {*} arr 选中的数据
 */
export function redrawSplice(arr) {
  if (!arr.length) {
    return;
  }

  var canvasCtn = document.getElementsByClassName("gispaiLayer");
  var nwTileData = [];
  for (let a = 0; a < arr.length; a++) {
    var ele = arr[a];
    var id = ele.Id;
    var zRenIndex = ZrenUniderIds[ele.layerId].findIndex(x => x === id);
    if (zRenIndex > -1) {
      ZrenUniderIds[ele.layerId].splice(zRenIndex, 1);
    }
    // 清理选中的数据
    for (var i = 0; i < TileData.length; i++) {
      if (TileData[i].layerId === ele.layerId) {
        if (TileData[i].data) {
          var index = TileData[i].data.J.findIndex(val => val.O === id);
          if (index > -1) {
            TileData[i].data.J.splice(index, 1);
          }
        }
      }
    }
    //缓存 清理选中的缓存
    // TileCanvasCache = TileCanvasCache.filter(x => x.layerId != ele.layerId);
    for (let f = 0; f < TileCanvasCache.length; f++) {
      var cacheItem = TileCanvasCache[f];
      for (let index = 0; index < ele.data.length; index++) {
        var element = ele.data[index];
        if (
          cacheItem.row === element.row &&
          cacheItem.col === element.col &&
          cacheItem.layerId === ele.layerId
        ) {
          TileCanvasCache.splice(f, 1);
          // f--;
        }
      }
    }
    // 更新选中的行列块数据
    var layerInfo = store.state.allLayerData.find(e => e.Id == ele.layerId);
    // var nwTileData = TileData.filter(ele => ele.layerId == ele.layerId);
    for (let index = 0; index < ele.data.length; index++) {
      var element = ele.data[index];
      for (let k = 0; k < TileData.length; k++) {
        var canvas_D = TileData[k];
        if (
          canvas_D.row === element.row &&
          canvas_D.col === element.col &&
          canvas_D.layerId === ele.layerId
        ) {
          nwTileData.push(canvas_D);
        }
      }
    }
    // 删除行列选中的行列canvas
    var canvasElArr = [];
    if (canvasCtn && canvasCtn.length > 0) {
      for (let i = canvasCtn.length - 1; i >= 0; i--) {
        if (canvasCtn[i].attributes.targetType != undefined) {
          if (canvasCtn[i].attributes.targetType.value == "data") {
            var ids = canvasCtn[i].id.split("_");
            if (canvasCtn[i].id.indexOf("_changed") == -1) {
              if (+ids[0] === +ele.layerId) {
                for (let index = 0; index < ele.data.length; index++) {
                  var element = ele.data[index];
                  if (+ids[1] === element.row && +ids[2] === element.col) {
                    canvasElArr.push(canvasCtn[i]);
                  }
                }
              }
            }
          }
        }
      }
    }
    // 对选中的行列切片进行绘制
    for (let index = 0; index < canvasElArr.length; index++) {
      var element = canvasElArr[index];
      element.remove();
    }
    for (var i = 0; i < nwTileData.length; i++) {
      var newd = convertData(
        nwTileData[i].row,
        nwTileData[i].col,
        nwTileData[i].data,
        layerInfo.GeoType
      );
      startDraw(
        nwTileData[i].row,
        nwTileData[i].col,
        nwTileData[i].offset,
        newd,
        nwTileData[i].layerId,
        "",
        0
      );
    }
    // }
  }
}
/**
 * @author: wyt
 * @description:重绘切片数据
 * @export
 * @param {*} arr 删掉的行列号数据
 */
export function redrawCanvasByOperation(arr) {
  arr.forEach(ele => {
    var id = ele.Id;
    for (var i = 0; i < TileData.length; i++) {
      if (TileData[i].layerId == ele.layerId) {
        if (TileData[i].data) {
          for (var j = 0; j < TileData[i].data.J.length; j++) {
            var index = TileData[i].data.J.findIndex(ele => ele.O == id);
            if (index > -1) {
              TileData[i].data.J.splice(index, 1);
              j--;
            }
          }
        }
      }
    }
    //缓存
    TileCanvasCache = TileCanvasCache.filter(x => x.layerId != ele.layerId);
    var layerInfo = store.state.allLayerData.find(e => e.Id == ele.layerId);
    var nwTileData = TileData.filter(ele => ele.layerId == ele.layerId);

    var canvasCtn = document.getElementsByClassName("gispaiLayer");
    if (canvasCtn && canvasCtn.length > 0) {
      for (let i = canvasCtn.length - 1; i >= 0; i--) {
        if (canvasCtn[i].attributes.targetType != undefined) {
          if (canvasCtn[i].attributes.targetType.value == "data") {
            var ids = canvasCtn[i].id.split("_");
            if (canvasCtn[i].id.indexOf("_changed") == -1) {
              if (ids[0] == ele.layerId) {
                canvasCtn[i].remove();
                // i = i - 1;
              }
            }
          }
        }
      }
    }

    for (var i = 0; i < nwTileData.length; i++) {
      var newd = convertData(
        nwTileData[i].row,
        nwTileData[i].col,
        nwTileData[i].data,
        layerInfo.GeoType
      );
      startDraw(
        nwTileData[i].row,
        nwTileData[i].col,
        nwTileData[i].offset,
        newd,
        nwTileData[i].layerId,
        "",
        0
      );
    }
  });
}

/**
 * @author: wyt
 * @description:属性表删除、图层删除重绘
 * @export
 * @param {*} geoType 图层类型（点线面三种）
 */
export function redrawSelectedCanvasByOperation(geoType) {
  //重绘
  let canvas = document.getElementById("selected_changed");
  let otherSelectData = [];
  if (geoType == "点") {
    otherSelectData = selectedAllData.filter(
      ele =>
        ele.type == "vector" || (ele.type == "screen" && ele.geoType == "点")
    );
  } else {
    otherSelectData = selectedAllData.filter(
      ele =>
        ele.type == "vector" || (ele.type == "screen" && ele.geoType != "点")
    );
  }
  //获取行列号
  var allrowcol = getRowCol(map.extent);
  let allNode = getVetorLayerNode(store.state.dataTreeData);
  for (let i = 0; i < otherSelectData.length; i++) {
    var info = store.state.allLayerData.find(
      ele => ele.Id == otherSelectData[i].layerId
    );
    let node = allNode.find(ele => ele.id == otherSelectData[i].layerId);
    let flag = getChecked(node, info);
    if (flag) {
      if (otherSelectData[i].type == "vector") {
        //绘制矢量数据
        drawOnCanvasByChangeData(
          otherSelectData[i].data,
          canvas,
          otherSelectData[i].layerId
        );
      } else {
        let sameIdDatas = [];
        let info = store.state.allLayerData.find(
          ele => ele.Id == otherSelectData[i].layerId
        );
        // if (info.GeoType == "点") {
        //   var idDatas = getScreenPoint(otherSelectData[i].data, info.GeoType, allrowcol)
        //   sameIdDatas = idDatas;
        // } else {
        sameIdDatas = otherSelectData[i].data;
        // }
        //绘制行列号数据
        redrawData(otherSelectData[i].layerId, sameIdDatas, "selected");
      }
    }
  }
}

/**
 * @author: wyt
 * @description:拾取过程若点击则设置为选中状态
 * @export
 */
export function settingPickedToSelected() {
  //清除
  clearGraphicFromSelectLayer([], "all");
  store.commit("set_isResetTableSelected", true);
  createCanvas("selected", "selected");
  reorderPickedLayer("selected");
  selectedAllData = [];
  selectedIdData = [];
  let selectIds = [];
  //右侧属性tab开启状态
  store.commit("set_openAttr", false);
  let canvas = document.getElementById("selected_changed");
  selectedAllData.push(lastPickedData[0]);
  selectIds.push(lastPickedData[0].Id);
  let layerInfo = store.state.allLayerData.find(
    x => x.Id == lastPickedData[0].layerId
  );
  if (lastPickedData[0].type == "vector") {
    //数据库数据绘制
    drawOnCanvasByChangeData(
      lastPickedData[0].data,
      canvas,
      lastPickedData[0].layerId
    );
  } else {
    //行列号数据绘制
    redrawData(layerInfo.Id, lastPickedData[0].data, "selected");
  }

  //全局重绘数据
  selectedIdData.push({
    layerId: layerInfo.Id,
    ids: selectIds
  });
  settingPagination(layerInfo, selectIds);
  store.commit("set_openAttr", true);
}

/**
 * @author: wyt
 * @description:设置左侧选择tab
 * @export
 * @param {*} layerInfo 图层数据
 * @param {*} selectIds 选中的id数组
 */
export function settingPagination(layerInfo, selectIds) {
  var paginaData = store.state.selectQueryPaginaData; //分页的id
  let index = paginaData.findIndex(x => x.layerId == layerInfo.Id);
  let obj = {
    layerId: layerInfo.Id,
    ids: selectIds
  };
  if (index == -1) {
    paginaData.push(obj);
  } else {
    paginaData.splice(index, 1, obj);
  }
  var selectQueryData = store.state.selectQueryData;
  var pagesData = store.state.selectedPagination.find(
    ele => ele.layerId == layerInfo.Id
  );
  if (!pagesData) {
    pagesData = {
      layerId: layerInfo.Id,
      pageSize: 20,
      currentPage: 1
    };
  }
  //分页
  var newSelectedData = [...new Set(selectIds)];
  if (selectIds.length > pagesData.pageSize) {
    newSelectedData = pagination(
      selectIds,
      pagesData.currentPage,
      pagesData.pageSize,
      selectIds.length
    );
  }
  // 同属于一个layerId的图形id 进行合并
  var selectIndex = selectQueryData.findIndex(
    val => val.layerId === layerInfo.Id
  );
  if (selectIndex > -1) {
    selectQueryData[selectIndex].list = [
      ...new Set(selectQueryData[selectIndex].list.concat(newSelectedData))
    ];
  } else {
    var sobj = {
      name: layerInfo.LayerAliasName,
      layerId: layerInfo.Id,
      num: selectIds.length,
      list: newSelectedData,
      type: "virtual",
      pageSize: pagesData.pageSize,
      currentPage: pagesData.currentPage,
      selectType: "tools"
    };
    selectQueryData.push(sobj);
  }
  // selectQueryData.push(sobj);
  store.commit("set_selectQueryData", selectQueryData);
  store.commit("set_selectQueryPaginaData", paginaData);
}

/**
 * @author: wyt
 * @description: 地图双击 获取对应点击的数据
 * @param {*} evt 地图的evt
 */
export function dblCilckEvent(evt) {
  let dblData = null;
  var layerArr = [];
  var layerCacheArr = [];
  let mappoint = evt.mapPoint;
  let point = map.toScreen(mappoint);
  var vNodes = getVetorLayerNode(store.state.dataTreeData);
  for (var i = 0; i < vNodes.length; i++) {
    let flag = getChecked(vNodes[i]);
    if (flag) {
      let cd = TileCanvasCache.filter(ele => ele.layerId == vNodes[i].id);
      layerArr = layerArr.concat(cd);
      let ccd = ChangedCanvasCache.find(ele => ele.layerId == vNodes[i].id);
      if (ccd) {
        layerCacheArr.push(ccd);
      }
    }
  }
  var obj = getSingleRowCol(point.x, point.y);
  //拾取全屏canvas
  if (layerCacheArr.length > 0) {
    for (var i = 0; i < layerCacheArr.length; i++) {
      var ChangedData = AllChangedData.filter(ele => ele.layerId == layerCacheArr[i].layerId)
      var position = {
        x: point.x,
        y: point.y
      };
      var color = getCacheColor(position, layerCacheArr[i].cacheContext);
      if (color != "") {
        var selectIndex = ex16hex(color);
        if (selectIndex != 0 && selectIndex != NaN) {
          var viewdata = ChangedData[0].data.filter(ele => ele.IsInView == true)
          var shape = viewdata[selectIndex - 1];
          if (shape) {
            dblData = {
              layerId: layerCacheArr[i].layerId,
              Id: shape.Attr.ID,
              data: shape,
              type: "vector"
            };
            return dblData;
          }
        }
      }
    }
  }
  //拾取行列号canvas
  var tmp = layerArr.filter(ele => {
    return ele.row == obj.row && ele.col == obj.col;
  });
  if (tmp.length > 0) {
    var position = {
      x: obj.colp,
      y: obj.rowp
    };
    for (var i = 0; i < tmp.length; i++) {
      var color = "";
      if (tmp[i].geoType == "点" || tmp[i].geoType == "线") {
        var pos = {};
        pos.x = position.x + pointSpace;
        pos.y = position.y + pointSpace;
        color = getCacheColor(pos, tmp[i].cacheContext);
      } else {
        color = getCacheColor(position, tmp[i].cacheContext);
      }
      if (color != "") {
        var selectIndex = ex16hex(color);
        if (selectIndex != 0 && selectIndex != NaN) {
          var shape = tmp[i].data.J[selectIndex - 1];
          if (shape) {
            var dataID = shape.O;
            var tmpD = TileCanvasCache.filter(ele => ele.layerId == tmp[i].layerId);
            var newData = [];
            for (var j = 0; j < tmpD.length; j++) {
              if (tmpD[j].data.J != null) {
                var temp = tmpD[j].data.J;
                var data = temp.filter(
                  ele => ele.G != null && ele.G.length > 0 && ele.O == dataID
                );
                if (data.length > 0) {
                  let obj = {
                    row: tmpD[j].row,
                    col: tmpD[j].col,
                    data: data
                  };
                  newData.push(obj);
                }
              }
            }
            dblData = {
              layerId: tmp[i].layerId,
              Id: dataID,
              type: "screen",
              data: newData
            };
            return dblData;
          }
        }
      }
    }
  }
  return dblData;
}
/**
 * @author: wyt
 * @description: 添加数据至全局的选择数据中
 * @export
 * @param {*} layerId 图层Id
 * @param {*} id 数据Id
 * @param {*} obj 构造的数据对象
 */
export function addSelectDataToAll(layerId, id, obj) {
  if (!isInScale(layerId) || !commonB.isLayerSelect(layerId)) return;
  if (!store.state.keyCode.ctrlKey) {
    let selectIdIndex = selectedIdData.findIndex(x => x.layerId == layerId);
    if (selectIdIndex > -1) {
      if (selectedIdData[selectIdIndex].ids.indexOf(id) === -1) {
        selectedIdData[selectIdIndex].ids.push(id);
        selectedAllData.push(obj);
      } else {
        if (obj.type === "screen") {
          let o = selectedAllData.find(x => x.layerId == layerId && x.Id == id);
          if (o != undefined) {
            let index = selectedAllData.findIndex(
              x => x.layerId == layerId && x.Id == id
            );
            selectedAllData.splice(index, 1);
            // selectedAllData.push(obj)
          }
        }
      }
      // let o = selectedAllData.find(x => x.layerId == layerId && x.Id == id)
    } else {
      selectedIdData.push({
        layerId: layerId,
        ids: [id]
      });
      selectedAllData.push(obj);
    }
  }
}
//同步写法
export async function getCoorList() {

  var param = {
    UserId: store.state.user.userid
  };
  await get_coorList(param)
    .then(response => {
      store.commit("set_coorList", response.data);
      log(response);
    })
    .catch(err => { });
}
// 11806
// 添加影像图层
export function addRegionalOnline() {
  let allLayers = store.state.allLayerData;
  let Id = 1;
  if (allLayers.length > 0) {
    Id = Math.max.apply(
      Math,
      allLayers.map(item => {
        return item.Id;
      })
    );
  }
  let o = store.state.onlineScreenage
  var LayerStr = {
    Id: Id + 1,
    LayerName: o.Name,
    LayerType: "影像",
    GeoType: "GSPTile",
    LayerUrl: o.ServicePath,
    LayerField: "[]",
    Label: "",
    LayerAliasName: o.Name,
    RenderType: "",
    LayerIndex: 0,
    Symbol: "",
    Opacity: 100,
    OpenState: 0,
    MaxScale: 0,
    MinScale: 0,
    IsChoice: 1,
    Isedit: 1,
    IsPicked: 1,
    GDataId: "",
    ParentId: 0,
    Executor: store.state.user.UserId,
    field: "[]",
    IsConcealed: 0
  };
  handleSaveBaseLayer(LayerStr, "GSPTile");
  let esriModule = store.state.esriModule
  let MapExtent = o.Extent.split(",")
  if (MapExtent.length > 0) {
    let extent = new esriModule.Extent(
      parseFloat(MapExtent[0]),
      parseFloat(MapExtent[1]),
      parseFloat(MapExtent[2]),
      parseFloat(MapExtent[3]),
      new esriModule.SpatialReference(Number(o.Coordinate))
      //map.spatialReference
    );
    extent = convertLngLat(Number(o.Coordinate), extent)
    map.setExtent(extent);
  }

}
//emap图层
export function addEMapLayer() {
  let allLayers = store.state.allLayerData;
  let Id = 1;
  if (allLayers.length > 0) {
    Id = Math.max.apply(
      Math,
      allLayers.map(item => {
        return item.Id;
      })
    );
  }
  let o = store.state.eMapData;

  var LayerStr = {
    Id: Id + 1,
    LayerName: o.Name,
    LayerType: "影像",
    GeoType: "GSPTile",
    LayerUrl: o.tiledUrl,
    LayerField: "[]",
    Label: "",
    LayerAliasName: o.Name,
    RenderType: "",
    LayerIndex: 0,
    Symbol: "",
    Opacity: 100,
    OpenState: 0,
    MaxScale: 0,
    MinScale: 0,
    IsChoice: 1,
    Isedit: 1,
    IsPicked: 1,
    GDataId: "",
    ParentId: 0,
    Executor: store.state.user.UserId,
    field: "[]",
    IsConcealed: 0
  };
  handleSaveBaseLayer(LayerStr, "EMapTile");
  let esriModule = store.state.esriModule

  let MapExtent = o.initExent.split(",")
  if (MapExtent.length > 0) {
    let extent = new esriModule.Extent(
      parseFloat(MapExtent[0]),
      parseFloat(MapExtent[1]),
      parseFloat(MapExtent[2]),
      parseFloat(MapExtent[3]),
      new esriModule.SpatialReference(Number(o.Coordinate))
      //map.spatialReference
    );
    extent = convertLngLat(Number(o.Coordinate), extent)
    map.setExtent(extent);
  }
}
//保存视频详情
export function saveVideoContent() {
  let data = store.state.videoDetailContent
  if (data != null && data != "") {
    UpdateVIdeoContents({
      userId: store.state.user.UserId,
      unitCode: data.Id,
      videoContents: JSON.stringify(data),
    }).then((res) => {
      //console.log(res);
      if (res.data.Status == 1) {
        //console.log("保存成功");
      } else {
        //console.log(res.data.Msg);
      }
    });
  }
}
